{
  "general.login": "로그인",
  "general.logout": "로그아웃",
  "general.title_zero": "스토리",
  "general.title_one": "스토리",
  "general.title_other": "스토리",
  "general.chapter_zero": "에피소드",
  "general.chapter_one": "에피소드",
  "general.chapter_other": "에피소드",
  "general.character_zero": "캐릭터",
  "general.character_one": "캐릭터",
  "general.character_other": "캐릭터",
  "general.title_language": "스토리 언어",
  "general.display_language": "Display Language",
  "general.category_zero": "카테고리",
  "general.category_one": "카테고리",
  "general.category_other": "카테고리",
  "general.category.fantasy": "판타지",
  "general.category.urban_fantasy": "현대판타지",
  "general.category.romance_fantasy": "로맨스판타지",
  "general.category.oriental_fantasy": "무협",
  "general.category.boyslove": "BL",
  "general.category.girlslove": "GL",
  "general.category.alternative_history": "대체역사",
  "general.category.drama": "드라마",
  "general.category.daily": "일상",
  "general.category.action": "액션",
  "general.category.romance": "로맨스",
  "general.category.gag_comedy": "개그/코미디",
  "general.category.horror": "호러",
  "general.category.mystery": "미스터리",
  "general.category.horror_mystery": "호러/미스터리",
  "general.category.sci_fi": "SF",
  "general.category.know_how": "노하우",
  "general.category.Daily": "일상",
  "general.create_title": "스토리 생성하기",
  "general.edit_title": "스토리 수정하기",
  "general.create_character": "캐릭터 생성하기",
  "general.edit_character": "캐릭터 수정하기",
  "general.all": "전체",
  "general.home": "홈",
  "general.navigation": "주요 메뉴",
  "general.best": "핫탭",
  "general.discover": "와글와글",
  "general.my_titles": "나의 스토리",
  "general.library": "서재",
  "general.profile": "제작자 페이지",
  "general.my": "마이",
  "general.bubblepick": "버블픽",
  "general.username": "아이디",
  "general.writername": "닉네임",
  "general.description": "설명",
  "general.setting": "설정",
  "general.setting_email": "이메일",
  "general.setting_autosave": "자동 저장",
  "general.setting_reading_mode": "읽기 모드",
  "general.setting_change_password": "비밀번호 변경",
  "general.save": "저장",
  "general.exitsave": "저장하고 나가기",
  "general.cancel": "취소",
  "general.next": "다음",
  "general.create": "생성",
  "general.create_button": "생성하기",
  "general.add_chapter": "에피소드 생성하기",
  "general.edit": "편집",
  "general.delete": "삭제",
  "general.publish": "공개",
  "general.unpublish": "비공개",
  "general.publishrequest": "공개 요청",
  "general.stay_on": "취소",
  "general.leave": "나가기",
  "general.done": "완료",
  "general.no_chapter_name": "제목없음",
  "general.unsaved_changes": "저장하지 않은 변경 사항이 있어요.",
  "general.unsaved_changes_message": "변경사항을 저장하시겠어요?",
  "general.unsaved_changes_warning_message": "작성 중인 내용은 저장되지 않아요.",
  "general.leave_confirm_message": "이 페이지에서 나가시겠어요?",
  "general.asset_no_list_message": "아직 등록된 애셋이 없어요.",
  "general.chapter_status.publish_requested": "공개 요청됨",
  "general.chapter_status.published": "공개됨",
  "general.chapter_status.unpublished": "비공개됨",
  "general.title_status.draft": "드래프트",
  "general.title_status.ongoing": "연재 중",
  "general.title_status.completed": "완결",
  "general.title_status.blocked": "차단됨",
  "general.title_status.waiting": "대기 중",
  "general.character_name": "캐릭터 이름",
  "general.character_status": "캐릭터 설명",
  "general.character_position.left": "왼쪽",
  "general.character_position.right": "오른쪽",
  "general.image_filetype_validation_message": "업로드 할 수 있는 파일은 webp, png, jpg 및 jpeg가 가능해요.",
  "general.image_size_validation_message": "이미지 크기는 개당 최대 10MB까지 가능합니다.",
  "general.image_load_validation_message": "이미지를 불러올 수 없어요. 다시 시도해 주세요.",
  "general.contact_customer_support_error_message": "문제가 발생했어요. 고객 지원에 문의해 주세요.",
  "general.yes": "네",
  "general.no": "아니오",
  "general.modify": "수정",
  "general.modify_button": "수정하기",
  "general.save_alert": "저장되지 않은 변경 사항이 있어요.<br/>그래도 종료하시겠어요?",
  "general.save_success_message": "변경 내용이 저장되었어요.",
  "general.save_fail_message": "변경 내용 저장에 실패했어요. 다시 시도해 주세요.",
  "general.delete_alert_message": "정말로 삭제하시겠어요?",
  "general.delete_success_message": "해당 내용이 삭제되었어요.",
  "general.saving_successful": "저장에 성공했어요.",
  "general.saving_unsuccessful": "저장에 실패했어요. 다시 한 번 시도해주세요.",
  "general.terms_of_service": "이용약관",
  "general.privacy_policy": "개인정보처리방침",
  "general.operation_policy": "운영정책",
  "general.juvenile_protection_policy": "청소년보호정책",
  "general.apply": "적용",
  "general.language_letter_zero": "자",
  "general.language_letter_one": "자",
  "general.language_letter_other": "자",
  "general.tap_zero": "탭",
  "general.tap_one": "탭",
  "general.tap_other": "탭",
  "general.scroll_zero": "스크롤",
  "general.scroll_one": "스크롤",
  "general.scroll_other": "스크롤",
  "general.original": "오리지널",
  "general.gallery": "갤러리",
  "general.camera": "카메라",
  "general.size": "사이즈",
  "general.contest": "공모전",
  "general.challenge": "챌린지",
  "general.bubbletap_original": "버블탭 오리지널",
  "general.bubbleup": "버블업",
  "general.bubbleup.challenge_header_button": "버블업 도전",
  "general.bubbleup.challenge_message": "버블업에 도전 중입니다.",
  "general.story_created_complete": "스토리가 생성되었습니다.",
  "general.list_tap_asset_sort_last_hour": "최근 1시간",
  "general.list_tap_asset_sort_daily": "일간",
  "general.list_tap_asset_sort_weekly": "주간",
  "general.list_tap_asset_sort_monthly": "월간",
  "general.list_tap_asset_sort_all": "전체",
  "general.tap_order_newest": "최신순",
  "general.tap_order_liked": "좋아요 많은 순",
  "general.tap_order_oldest": "오래된 순",
  "general.tap.order_int_hourly": "{{int_number}}시간",
  "general.tap.order_int_daily": "{{int_number}}일간",
  "general.tap.order_int_weekly": "{{int_number}}주간",
  "general.tap.order_int_monthly": "{{int_number}}개월간",
  "general.pass.basic": "BASIC",
  "general.pass.super": "MAGIC",
  "general.pass.hyper": "DREAM",
  "general.comments": "댓글",
  "general.event_awarded": "{{int_numbers}} 포인트 지급 완료!",
  "general.event_popup_alert1": "대한민국 유저만 참여 가능한 이벤트입니다.",
  "general.event_popup_alert2": "본인인증이 완료된 유저만 참여 가능합니다.",
  "general.event_popup_alert3": "이미 참여한 이벤트입니다.",
  "general.event_popup_alert4": "종료된 이벤트입니다.",
  "general.bubbles_zero": "{{int_numbers}} 포인트",
  "general.bubbles_one": "{{int_numbers}} 포인트",
  "general.bubbles_other": "{{int_numbers}} 포인트",
  "general.copy": "복사",
  "general.maintenance_title": "서비스 점검 중",
  "general.maintenance_title2": "더 나은 서비스 제공을 위해 서버 점검이 진행되고 있습니다.<br/>잠시 후 다시 이용해 주세요.",
  "general.maintenance_description": "점검 시간: 오늘 오전 06:30~09:30",
  "general.maintenance_period": "점검 시간: {{startDate}} {{startTime}}~{{endTime}}",
  "popup.banner_close_button": "닫기",
  "popup.close_for_a_day_button": "오늘 하루 보지 않기",
  "popup.banner_close_for_a_day_button": "3일간 보지 않기",
  "register.userinfo_username_message": "아이디를 정해 주세요.",
  "register.userinfo_username_used_validation_message": "이미 사용 중인 아이디예요.",
  "register.userinfo_writername_used_validation_message": "이미 사용 중인 닉네임이에요.",
  "register.userinfo_username_impossible_used_validation_message": "사용할 수 없는 아이디예요.",
  "register.userinfo_writername_impossible_used_validation_message": "사용할 수 없는 닉네임이에요.",
  "register.userinfo_username_format_validation_message": "아이디는 영어와 숫자로 6~25글자 사이로 입력해 주세요.",
  "register.userinfo_writername_format_validation_message": "문자, 숫자, 일부 특수문자를 조합해 2~25글자 사이로 입력해 주세요.",
  "register.userinfo_password_message": "비밀번호를 입력해 주세요.",
  "register.userinfo_password_placeholder": "비밀번호",
  "register.userinfo_password_format_validation_message": "비밀번호는 8~25글자 사이로 입력해 주세요.",
  "register.userinfo_next": "확인",
  "register.userinfo_password_retype_placeholder": "비밀번호 재입력",
  "register.userinfo_username_description_message": "아이디를 다시 바꿀 수 없으니, 신중히 정해 주세요.",
  "register.userinfo_email_title_message": "이메일을 입력해 주세요",
  "register.userinfo_email_description_message": "가입 후, 인증하시면 분실한 비밀번호를 찾을 수 있어요.",
  "register.userinfo_email_description_message2": "이메일을 인증하시면<br/>아래 서비스를 이용하실 수 있습니다.",
  "register.userinfo_email_certification_message": "이메일 인증이 필요해요.",
  "register.userinfo_email_certification_message2": "이메일 인증 상태를 확인해 주세요.",
  "register.userinfo_email_certification_button": "인증하러 가기",
  "register.userinfo_email_checkbox_description_message1": "분실 비밀번호 찾기",
  "register.userinfo_email_checkbox_description_message2": "이벤트 당첨 안내",
  "register.userinfo_email_checkbox_description_message3": "버블업 선정 안내",
  "register.userinfo_email_checkbox_description_message4": "연재 제안",
  "register.userinfo_verification_agree_select_all": "전체 동의하기",
  "register.userinfo_verification_privacy_policy": "개인정보 처리방침",
  "register.userinfo_verification_terms_of_service": "서비스 이용약관",
  "register.userinfo_verification_agree_description1": "1개의 명의로 3개의 계정까지 본인 인증이 가능합니다.",
  "register.userinfo_verification_agree_description2": "본인 인증을 통해 성인임이 확인되어야 성인용 컨텐츠를 제작하거나 이용할 수 있습니다.",
  "register.userinfo_verification_failed_modal_description": "본인 인증은 1개의 명의 당 최대 3개의 계정까지만 가능해요.",
  "register.userinfo_verification_failed_modal_retry": "다시하기",
  "register.userinfo_set_nickname_title": "닉네임 설정",
  "register.userinfo_set_nickname_skip": "건너뛰기",
  "register.userinfo_set_nickname_placeholder": "사용할 닉네임을 입력해주세요.",
  "register.userinfo_set_nickname_description1": "대화 내에서 불릴 이름이자, 서비스 전반에 사용될 닉네임이에요.",
  "register.userinfo_set_nickname_description2": "페르소나를 설정한 경우, 캐릭터가 이 닉네임 대신 다른 이름으로 부를 수 있어요.",
  "register.userinfo_set_nickname_description3": "닉네임은 마이페이지에서 언제든지 변경할 수 있어요.",
  "register.userinfo_set_nickname_done_button": "완료",
  "register.userinfo_set_nickname_format_validation_message": "문자, 숫자, 일부 특수문자를 조합해 2~25글자 사이로 입력해 주세요.",
  "register.userinfo_set_nickname_already_used_validation_message": "이미 사용 중인 닉네임이에요.",
  "register.userinfo_set_nickname_inappropriate_words_validation_message": "부적절한 단어가 포함되어 있어요. 다른 닉네임을 입력해주세요.",
  "register.userinfo_set_nickname_invalid_characters_validation_message": "사용할 수 없는 문자가 포함되어 있어요.",
  "register.userinfo_set_country_korea": "대한민국",
  "register.userinfo_set_country_thai": "ประเทศไทย",
  "register.userinfo_set_country_taiwan": "臺灣",
  "register.userinfo_set_country_japan": "日本",
  "login.userinfo_message": "로그인하기 위해 <strong>아이디</strong>와 <strong>비밀번호</strong>를 입력해 주세요.",
  "login.userinfo_login": "로그인",
  "login.userinfo_forgot_password_message": "비밀번호를 잊으셨나요?",
  "login.userinfo_username_format_validation_message": "아이디는 영어와 숫자로 6~25글자 사이로 입력해 주세요.",
  "login.userinfo_password_format_validation_message": "비밀번호는 8~25글자 사이로 입력해 주세요.",
  "login.userinfo_username_fail_validation_message": "존재하지 않는 아이디입니다. 다시 확인해 주세요.",
  "login.userinfo_password_fail_validation_message": "잘못된 비밀번호입니다. 다시 확인해 주세요.",
  "login.userinfo_password_not_set_validation_message": "비밀번호가 아직 설정되지 않았습니다. 소셜 로그인을 하여 먼저 비밀번호를 설정해 주세요.",
  "login.password_reset_password_first_description_message": "아이디와 인증된 메일 주소를 입력해 주세요.",
  "login.password_reset_password_second_description_message": "<strong>새 비밀번호</strong>를 설정할 수 있는 메일을 보내드릴게요.",
  "login.password_reset_password_username_placeholder": "아이디를 입력해 주세요.",
  "login.password_reset_password_email_placeholder": "인증된 메일을 입력해 주세요.",
  "login.password_reset_password_button": "새 비밀번호 설정",
  "login.password_reset_password_username_fail_validation_message": "아이디는 6글자 이상 입력해주세요.",
  "login.password_reset_password_email_fail_validation_message": "이메일 형식에 맞춰 입력해 주세요.",
  "login.password_reset_password_username_fail_validation_toast": "존재하지 않는 아이디입니다. 다시 확인해 주세요.",
  "login.password_reset_password_email_validation_email_none_message": "이 계정에는 인증된 메일이 없어요.",
  "login.password_reset_password_email_success_title": "비밀번호 재설정을 위해 이메일을 전송하였습니다.",
  "login.password_reset_password_email_success_message": "받은 메일함을 확인해 주세요.",
  "login.password_reset_password_email_current_validation_toast": "사용 중인 비밀번호가 잘못되었습니다. 다시 확인해 주세요.",
  "login.password_reset_password_email_new_validation_toast": "사용 중인 비밀번호와 새 비밀번호가 일치하지 않습니다.",
  "login.password_reset_password_email_validation_email_verify_message": "유효한 이메일 주소를 입력해 주세요.",
  "login.connect_fail_unknown_title": "예상치 못한 오류가 발생했어요.",
  "login.connect_fail_unknown_description": "이 오류에 대해 저희에게 알려 주세요.<br/>(support@tingle.chat)",
  "login.account_member": "이미 가입하셨나요?",
  "login.account_kakao": "<strong>Kakao</strong>로 로그인하기",
  "login.account_google": "<strong>Google</strong>로 로그인하기",
  "login.account_facebook": "<strong>Facebook</strong>으로 로그인하기",
  "login.account_apple": "<strong>Apple</strong>로 로그인하기",
  "login.account_agree_policy": "로그인하시면 <link1>서비스 이용약관</link1> 및 <link2>개인정보 처리방침</link2>에 동의하게 되어요.",
  "login.account_fail_toast": "로그인에 실패했어요. 다시 시도해 주세요.",
  "login.account_fail_password_toast": "비밀번호가 잘못되었습니다.",
  "login.account_cancel_toast": "로그인이 취소되었어요.",
  "login.account_must_login": "로그인 후 이용이 가능해요.",
  "login.nonlogin_users_login_button": "로그인 하러가기",
  "login.account_existing_account_title": "기존 계정으로 로그인",
  "login.account_social_account_title": "소셜 계정으로 로그인",
  "login.password_reset_modal_title": "비밀번호 재설정을 위해 이메일을 전송하였습니다.",
  "login.password_reset_modal_description": "받은 메일함을 확인해 주세요.",
  "login.password_change_login_button": "비밀번호 변경하고 로그인",
  "login.password_change_title": "비밀번호 변경하기",
  "gnb.about_bubblechat": "팅글 소개",
  "gnb.studio": "스튜디오",
  "gnb.faq": "자주 묻는 질문",
  "gnb.guide_download": "가이드 다운로드",
  "story.my_titles.title_list": "스토리 리스트",
  "story.my_titles.published_titles": "공개한 스토리",
  "story.create_title.list_thumbnail_guide_message": "새로운 스토리를 만들어 보세요.",
  "story.create_title.list_null_text": "아직 작성 중인 스토리가 없어요.",
  "story.create_edit_title.add_cover": "표지를 등록해 주세요.",
  "story.create_edit_title.bubbletap_original_cover_assets_alert_name": "오리지널 표지 애셋",
  "story.create_edit_title.title_completed_label": "스토리 완결",
  "story.create_edit_title.select_categories_text": "1~2개의 카테고리를 선택하세요.",
  "story.create_edit_title.add_characters_text": "당신의 스토리에 캐릭터를 추가해 보세요.",
  "story.create_characters.name_guide_text": "새로운 캐릭터 이름을 입력해 주세요.",
  "story.create_characters.status_guide_text": "캐릭터 설명을 입력해 주세요.",
  "story.create_characters.position_guide_text": "캐릭터의 좌우 위치를 선택해 주세요.",
  "story.select_characters_text": "캐릭터를 선택해 주세요.",
  "story.delete_characters_confirmation_message": "정말로 캐릭터를 삭제하시겠어요?",
  "story.delete_characters_warning_message": "이 캐릭터를 스토리 내에서 사용할 수 없게 됩니다.",
  "story.delete_characters_validation_message": "이 캐릭터를 삭제할 수 없어요.",
  "story.delete_characters_info_message": "스토리 내 사용한 캐릭터는 삭제할 수 없어요.",
  "story.delete_title_confirmation_message": "이 스토리를 삭제하면 복구할 수 없어요. <br/> 정말로 삭제하시겠어요?",
  "story.delete_title_character_chapter_warning_message": "해당 스토리 내 사용한 캐릭터와 에피소드가 모두 삭제되어요.",
  "story.delete_title_like_warning_message": "해당 스토리의 좋아요가 모두 삭제되어요.",
  "story.delete_title_comment_warning_message": "해당 스토리의 작성된 댓글이 모두 삭제되어요.",
  "story.delete_title_read_warning_message": "해당 스토리의 탭 수가 모두 삭제되어요.",
  "story.create_edit_title.title_validation_message": "스토리명은 1에서 40자 사이여야 해요.",
  "story.create_edit_title.description_validation_message": "스토리 설명은 1에서 150자 사이여야 해요.",
  "story.create_edit_title.category_validation_message": "한 개 이상의 카테고리를 선택해 주세요.",
  "story.create_edit_title.status_validation_message": "스토리 설명은 비워둘 수 없어요.",
  "story.create_edit_title.delete_chapter_confirmation_message": "정말로 에피소드를 삭제하시겠어요?",
  "story.create_edit_title.delete_chapter_warning_message": "이 에피소드는 더 이상 이 스토리에서 표시되지 않아요.",
  "story.create_edit_title_serial_chapter_unpublished_impossible_alert_message": "연재 작품의 에피소드는 비공개 할 수 없어요.",
  "story.create_edit_title_serial_chapter_published_impossible_alert_message": "연재 작품의 에피소드는 직접 공개를 할 수 없어요.",
  "story.create_edit_title_serial_chapter_deleted_impossible_alert_message": "연재 작품의 에피소드는 삭제할 수 없어요.",
  "story.create_edit_title.title_placeholder": "스토리명을 입력해 주세요.",
  "story.create_edit_title.description_placeholder": "스토리 소개를 입력해 주세요.",
  "story.create_edit_title.chapter_order_tooltip": "에피소드 순서 변경하기",
  "story.create_title_info_title": "스토리명",
  "story.create_edit_component_delete_message": "삭제되었어요.",
  "story.create_characters.bubbletap_original_avatar_assets_alert_name": "캐릭터 아바타",
  "story.create_characters.edit_image_zoom_button": "확대",
  "story.create_characters.edit_image_reset_all_button": "초기화",
  "story.create_characters.edit_image_remove_background_button": "배경 제거",
  "story.create_characters.edit_image_send_button": "설정",
  "story.create_characters.edit_image_cancel_button": "취소",
  "story.create_edit_title_serial_title_delete_impossible_alert_message": "연재 중인 작품은 삭제할 수 없어요.",
  "story.create_edit_title_serial_title_completed_impossible_alert_message": "연재 작품은 연재 상태를 변경할 수 없어요.",
  "story.create_edit_title_status_change_publishrequest_alert_title": "한 번 공개 요청을 하면 상태를 변경할 수 없어요.",
  "story.create_edit_title_status_change_publishrequest_alert_message": "공개 요청 상태로 전환되면 에피소드 편집 및 삭제가 불가합니다.",
  "story.create_edit_title_status_change_publishrequest_alert_error_message": "요청에 실패했어요. 다시 시도해 주세요.",
  "story.create_edit_title.list_null_message": "스토리를 공개하고 친구들과 공유해 보세요.",
  "preview.controller_play_button": "재생",
  "preview.controller_pause_button": "정지",
  "preview.controller_replay_button": "다시 재생",
  "preview.controller_end_button": "종료",
  "preview.controller_info_scroll_zero": "전체 스크롤 수",
  "preview.controller_info_scroll_one": "전체 스크롤 수",
  "preview.controller_info_scroll_other": "전체 스크롤 수",
  "preview.controller_info_tap_zero": "전체 탭 수",
  "preview.controller_info_tap_one": "전체 탭 수",
  "preview.controller_info_tap_other": "전체 탭 수",
  "preview.controller_info_letter_zero": "전체 글자 수",
  "preview.controller_info_letter_one": "전체 글자 수",
  "preview.controller_info_letter_other": "전체 글자 수",
  "profile.username_placeholder": "사용할 아이디를 입력해 주세요.",
  "profile.description_placeholder": "나의 소개글을 작성해 주세요.",
  "profile.username_length_validation_message": "아이디는 6 - 25자 사이여야해요.",
  "profile.username_format_validation_message": "아이디에는 영어 대소문자와 숫자만 사용할 수 있어요.",
  "profile.image_upload": "프로필 이미지 업로드 ",
  "chapter.confirm_publish_chapter_message": "이 에피소드를 공개하시겠어요?",
  "chapter.confirm_draft_chapter_message": "이 에피소드를 저장하시겠어요?",
  "chapter.info_fail_validation_message": "존재하지 않는 에피소드입니다.",
  "chapter.edit": "에피소드 수정",
  "chapter.edit_background_image": "배경 이미지",
  "chapter.edit_background_your_image": "직접 업로드",
  "chapter.edit_background_simple_color": "배경 색상",
  "chapter.edit_text_input_narrative_placeholder": "내러티브를 입력하세요.",
  "chapter.edit_text_input_character_placeholder": "대사를 입력하세요.",
  "chapter.edit_text_input_background_image_button": "배경 이미지",
  "chapter.edit_text_input_narrative_button": "내러티브",
  "chapter.edit_text_input_image_button": "이미지",
  "chapter.edit_text_input_clear_room_button": "새 페이지",
  "chapter.edit_text_input_narrative_characters_limit_toast": "내러티브는 최대 10,000자까지 입력할 수 있어요.",
  "chapter.edit_text_input_dialogue_characters_limit_toast": "대사는 최대 10,000자까지 입력할 수 있어요.",
  "chapter.edit_text_input_newpage_limit_message": "새 페이지는 연달아 생성할 수 없어요.",
  "chapter.edit_text_input_newpage_warning_alert_message": "새 페이지는 첫 번째 버블로 사용할 수 없어요.",
  "chapter.edit_text_input_between_newpage_contents_limit_message": "해당 Bubble을 삭제하려면, 먼저 앞 또는 뒤의 새 페이지를 삭제해 주세요.",
  "chapter.edit_page_clear_room_tap": "새 페이지로 시작",
  "chapter.edit_page_current_location_line": "작성 중인 위치",
  "chapter.edit_page_delete_message": "해당 내용이 삭제되었어요.",
  "chapter.edit_page_background_color_tap": "배경 색상",
  "chapter.edit_preview_tooltip": "미리보기",
  "chapter.edit_save_tooltip": "저장하려면 제목과 한 줄 이상의 글을 입력해 주세요.",
  "chapter.edit_save_publish_chapter_warning_alert_message": "공개된 에피소드는 수정할 수 없어요.",
  "chapter.edit_chapter_name_text": "에피소드명",
  "chapter.edit_chapter_title_placeholder": "에피소드명을 입력해 주세요.",
  "chapter.edit_create_chapter": "에피소드 생성하기",
  "chapter.edit_back": "이전",
  "chapter.edit_chapter_title": "에피소드 이름을 입력해 주세요.",
  "chapter.edit_text_edit_text": "텍스트 편집",
  "chapter.edit_text_change_monologue": "독백으로 변경",
  "chapter.edit_text_change_dialogue": "대화로 변경",
  "chapter.edit_assets_background_color": "배경 색상",
  "chapter.edit_assets_background_title": "배경 이미지",
  "chapter.edit_assets_background_category_your_image": "내 이미지",
  "chapter.edit_assets_background_category_simple_color": "배경 색상",
  "chapter.edit_assets_background_category_bubbletap_original": "버블탭 오리지널 배경",
  "chapter.edit_assets_animated_overlay_image": "오버레이",
  "chapter.edit_text_auto_separation": "대화 자동 분리",
  "chapter.edit_text_auto_separation_enter": "Enter를 통해<br/>대화를 분리할 수 있어요!",
  "chapter.edit_text_convo_type": "대화 유형 변경",
  "chapter.edit_cut": "잘라내기",
  "chapter.edit_paste": "붙여넣기",
  "chapter.edit_searchby_char": "캐릭터 이름으로 검색하세요.",
  "chapter.edit_assets_bubbletap_original_transition_action_sheet": "전환 방식 변경 ",
  "chapter.edit_assets_bubbletap_original_transition_screen_name": "화면 전환 방식을 선택해 주세요.",
  "chapter.edit_assets_bubbletap_original_transition_image_button": "느린 화면 전환  (이미지 유형)",
  "chapter.edit_assets_bubbletap_original_transition_text_button": "빠른 화면 전환  (텍스트 유형)",
  "chapter.list_reading_mode_screen_name": "읽기 모드를 설정해 주세요.",
  "chapter.list_reading_tap_mode_button": "탭 모드",
  "chapter.list_reading_scroll_mode_button": "스크롤 모드",
  "chapter.list_reading_tap_mode_alert_title": "탭 모드 보기로 설정되었습니다.",
  "chapter.list_reading_tap_mode_alert_message": "설정 변경을 원하시면 <strong>마이 페이지 > 설정 > 읽기 모드</strong>에서 <br/>변경하실 수 있습니다.",
  "chapter.list_reading_scroll_mode_alert_title": "스크롤 모드 보기로 설정되었습니다.",
  "chapter.list_reading_scroll_mode_alert_message": "설정 변경을 원하시면 <strong>마이 페이지 > 설정 > 읽기 모드</strong>에서 <br/>변경하실 수 있습니다.",
  "chapter.list_non_login_user_reading_mode_setting_alert_message": "설정 변경을 원하시면 로그인을 하신 후<br/><strong>마이 페이지 > 설정 > 읽기 모드</strong>에서 변경하실 수 있습니다.",
  "chapter.list_share_fail_message": "선택한 앱을 찾을 수 없어요.",
  "chapter.edit_assets_bubbletap_original_soundeffect_action_sheet": "효과음 추가",
  "chapter.edit_assets_bubbletap_original_soundeffect_screen_name": "효과음",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category1": "버블탭 효과음",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category2": "즐겨찾기",
  "chapter.edit_assets_bubbletap_original_soundeffect_category1": "자연",
  "chapter.edit_assets_bubbletap_original_soundeffect_category2": "사물",
  "chapter.edit_assets_bubbletap_original_soundeffect_category3": "동물",
  "chapter.edit_assets_bubbletap_original_soundeffect_category4": "공간적 배경",
  "chapter.edit_assets_bubbletap_original_soundeffect_category5": "사람",
  "chapter.edit_assets_bubbletap_original_soundeffect_category6": "장르",
  "chapter.edit_assets_bubbletap_original_soundeffect_category7": "기타",
  "chapter.edit_assets_bubbletap_original_soundeffect_categories_screen_name": "효과음",
  "chapter.edit_assets_bubbletap_original_soundeffect_edit_action_sheet": "효과음 제거",
  "chapter.edit_assets_bubbletap_original_soundeffect_play_failed_toast": "오디오 재생에 실패했어요.",
  "chapter.list_free_label": "무료",
  "chapter.list_owned_label": "구매",
  "chapter.list_rented_label": "대여",
  "chapter.list_rented_expire_label": "대여만료",
  "chapter.list_share_title": "공유하기",
  "chapter.list_share_kakaotalk_label": "카카오톡",
  "chapter.list_share_kakaotalk_message": "지금 바로 보러가기!",
  "chapter.list_share_instagram_label": "인스타그램",
  "chapter.list_share_link_label": "링크 복사",
  "chapter.list_share_link_message": "링크가 복사되었습니다.",
  "chapter.list_rented_label_time1": "{{int_rentDay}}D {{int_rentHour}}H",
  "chapter.list_rented_label_time2": "{{int_rentDay}}D",
  "chapter.list_rented_label_time3": "{{int_rentHour}}H {{int_rentMinute}}M",
  "chapter.list_rented_label_time4": "{{int_rentHour}}H",
  "chapter.list_rented_label_time5": "{{int_rentMinute}}M",
  "chapter.list_charge_status": "무료 열람 가능",
  "chapter.list_charge_time_day_description_zero": "{{int_rentDay}}일 마다 무료",
  "chapter.list_charge_time_day_description_one": "{{int_rentDay}}일 마다 무료",
  "chapter.list_charge_time_day_description_other": "{{int_rentDay}}일 마다 무료",
  "chapter.list_charge_time_hour_description_zero": "{{int_rentHour}}시간 마다 무료",
  "chapter.list_charge_time_hour_description_one": "{{int_rentHour}}시간 마다 무료",
  "chapter.list_charge_time_hour_description_other": "{{int_rentHour}}시간 마다 무료",
  "chapter.list_charge_time_minute_description_zero": "{{int_rentMinute}}분 마다 무료",
  "chapter.list_charge_time_minute_description_one": "{{int_rentMinute}}분 마다 무료",
  "chapter.list_charge_time_minute_description_other": "{{int_rentMinute}}분 마다 무료",
  "chapter.list_charge_time_count_day_description": "{{int_rentDay}}일 남음",
  "chapter.list_charge_time_count_day_hour_description": "{{int_rentDay}}일 {{int_rentHour}}시간 남음",
  "chapter.list_charge_time_count_hour_description": "{{int_rentHour}}시간 남음",
  "chapter.list_charge_time_count_hour_minute_description": "{{int_rentHour}}시간 {{int_rentMinute}}분 남음",
  "chapter.list_charge_time_count_minute_description": "{{int_rentMinute}}분 남음",
  "chapter.list_free_count": "{{int_count}}화 무료",
  "chapter.list_charge_info_alert_tittle": "기다리면 무료",
  "chapter.list_charge_time_day_info_alert_message1_zero": "이용권을 사용 후, {{int_rentDay}}일을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_day_info_alert_message1_one": "이용권을 사용 후, {{int_rentDay}}일을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_day_info_alert_message1_other": "이용권을 사용 후, {{int_rentDay}}일을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_hour_info_alert_message1_zero": "이용권을 사용 후, {{int_rentHour}}시간을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_hour_info_alert_message1_one": "이용권을 사용 후, {{int_rentHour}}시간을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_hour_info_alert_message1_other": "이용권을 사용 후, {{int_rentHour}}시간을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_minute_info_alert_message1_zero": "이용권을 사용 후, {{int_rentMinute}}분을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_minute_info_alert_message1_one": "이용권을 사용 후, {{int_rentMinute}}분을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_minute_info_alert_message1_other": "이용권을 사용 후, {{int_rentMinute}}분을 기다리면 이용권 1장을 드려요.",
  "chapter.list_charge_time_info_alert_message2": "해당 이용권으로 3일 동안 대여하실 수 있어요.",
  "chapter.list_charge_time_info_alert_message3": "최신 {{int_rentRecent}}편은 해당 이용권을 사용할 수 없어요.",
  "chapter.list_purchase_purchased_chapter_button": "보유회차",
  "chapter.list_purchase_chapter_collect": "구매하기",
  "chapter.list_purchase_chapter_rent": "대여하기",
  "chapter.list_purchase_chapter_free_charge": "무료열람",
  "chapter.list_purchase_alert_my_bubble": "보유 포인트",
  "chapter.list_purchase_alert_message": "에피소드를 구매하시겠어요?",
  "chapter.list_purchase_failed_alert_message": "에피소드 구매에 실패했어요. 다시 시도해 주세요.",
  "chapter.list_purchase_alert_footer_message": "대여 시간은 구매 후 72시간 입니다.",
  "chapter.edit_autosave_error_toast_message": "자동 저장에 실패했어요.",
  "chapter.edit_autosave_saving_text": "자동 저장 중",
  "chapter.edit_autosave_success_text": "자동 저장 완료",
  "chapter.edit_autosave_last_success_time_text": "마지막 저장",
  "chapter.read_config_font_size_change": "글자 크기",
  "asset_browser.add": "추가",
  "asset_browser.in_use": "사용중",
  "asset_browser.max_num_images_limit_info_text": "최대 20개의 이미지만 선택할 수 있습니다.",
  "asset_browser.no_asset_in_use_message": "사용 중인 애셋이 없어요.",
  "asset_browser.character_image": "캐릭터 이미지",
  "asset_browser.narrative_image": "내러티브 이미지",
  "setting.edit_email_verify_now_button": "이메일 인증",
  "setting.edit_email_re_verify_button": "재인증",
  "setting.edit_email_password_change_button": "변경",
  "setting.edit_email_verify_message": "이메일을 인증해 주세요",
  "setting.edit_email_verify_info_text": "이메일을 인증하시면<br/>분실한 비밀번호를 찾을 수 있어요.",
  "setting.edit_email_verify_text": "이메일 입력",
  "setting.edit_email_verify_placeholder": "인증할 이메일을 입력해 주세요.",
  "setting.edit_cancel_button": "취소",
  "setting.edit_email_verify_verify_now_button": "인증하기",
  "setting.edit_email_verify_validation_text": "이메일 형식에 맞춰 입력해 주세요.",
  "setting.edit_email_verify_success_message": "입력하신 이메일 주소로<br/>인증 메일을 발송했어요.",
  "setting.edit_email_verify_success_info_text": "24시간 이내로 메일을 인증해 주세요.",
  "setting.edit_email_verify_fail_current_text": "현재 인증한 이메일이에요.",
  "setting.edit_email_verify_fail_use_text": "사용 중인 이메일이에요.",
  "setting.edit_ok_button": "확인",
  "setting.edit_email_verify_email_template_message": "이메일 인증",
  "setting.edit_email_verify_email_template_guide_text": "이메일을 인증하려면 아래 버튼을 클릭해 주세요.",
  "setting.edit_email_verify_email_template_info_text": "이 이메일은 24시간 동안 유효해요",
  "setting.edit_email_verify_email_template_click_here_button": "인증하기",
  "setting.edit_email_verify_email_template_success_message": "인증 완료",
  "setting.edit_email_verify_email_template_success_text": "감사합니다! 이메일 인증이 완료되었어요.",
  "setting.edit_email_verify_email_template_close_window_button": "인증 창 닫기",
  "setting.edit_email_verify_email_template_fail_message": "이 인증 이메일은 더 이상 유효하지 않아요.",
  "setting.edit_email_verify_email_template_fail_text": "시간이 지나 인증 기한이 만료되었어요. 다시 시도해 주세요.",
  "setting.edit_email_verify_email_template_expiration_message": "이 이메일은 이미 인증되었어요.",
  "setting.edit_email_verify_email_template_expiration_text": "다른 이메일로 인증을 시도해 주세요.",
  "setting.edit_email_verify_email_template_move_studio_button": "스튜디오로 돌아가기",
  "setting.edit_email_re_verify_message": "이메일을 재인증해 주세요",
  "setting.edit_email_re_verify_info_text": "인증 이메일을 다른 이메일 주소로 변경할 수 있어요. 새로운 이메일을 입력해 주세요.",
  "setting.edit_autosave_setup_alert_title_message": "자동저장 설정",
  "setting.edit_autosave_setup_alert_description_message": "에피소드가 자동 저장되는 시간을<br/>설정할 수 있어요.",
  "setting.edit_autosave_setup_time_value_one_minute": "1분 마다 저장",
  "setting.edit_autosave_setup_time_value_three_minutes": "3분 마다 저장",
  "setting.edit_autosave_setup_time_value_five_minutes": "5분 마다 저장",
  "setting.edit_autosave_setup_time_value_on": "켜기",
  "setting.edit_autosave_setup_time_value_off": "끄기",
  "setting.edit_autosave_setup_time_status_one_minute": "1분",
  "setting.edit_autosave_setup_time_status_three_minutes": "3분",
  "setting.edit_autosave_setup_time_status_five_minutes": "5분",
  "setting.edit_autosave_setup_time_status_minute": "분",
  "setting.edit_reading_tap_mode_title_message": "탭 모드",
  "setting.edit_reading_tap_mode_description_message": "컨텐츠를 탭하며 볼 수 있어요.",
  "setting.edit_reading_scroll_mode_title_message": "스크롤 모드",
  "setting.edit_reading_scroll_mode_description_message": "컨텐츠를 스크롤하며 볼 수 있어요.",
  "setting.edit_password_change_your_password_description": "현재 비밀번호와 새 비밀번호를 입력해 주세요.",
  "setting.edit_password_change_your_password_message": "비밀번호를 변경해 주세요.",
  "setting.edit_password_input_current_password_placeholder": "현재 사용 중인 비밀번호를 입력해 주세요.",
  "setting.edit_password_input_new_password_placeholder": "새로 설정할 비밀번호를 입력해 주세요.",
  "setting.edit_password_input_re_type_new_password_placeholder": "새로 설정할 비밀번호를 다시 입력해 주세요.",
  "setting.edit_password_change_your_password_validation_text": "비밀번호는 영어, 숫자 또는 특수문자로 8~25글자 입력해 주세요.",
  "setting.edit_password_change_your_password_validation_toast": "잘못된 비밀번호를 입력하셨어요.",
  "setting.edit_password_change_new_password_validation_toast": "현재 사용 중인 비밀번호를 입력하셨어요. 다른 비밀번호를 입력해 주세요.",
  "setting.edit_password_change_success_message": "비밀번호 변경이 완료되었어요.",
  "setting.edit_password_change_success_text": "이제 새로운 비밀번호로<br/>로그인할 수 있어요.",
  "setting.edit_password_change_enable_validation_text": "사용 가능한 비밀번호예요.",
  "setting.edit_password_change_new_password_again_placeholder": "새로 설정할 비밀번호를 한번 더 입력해주세요",
  "setting.edit_password_change_new_password_match_validation_text": "새 비밀번호가 일치해요.",
  "setting.edit_password_change_new_password_not_match_validation_text": "새 비밀번호가 일치하지 않아요.",
  "setting.edit_setuppassword_title_message": "비밀번호 설정",
  "setting.edit_setuppassword_description_message": "설정한 비밀번호는<br/>아이디로 로그인 시, 사용되어요.",
  "setting.edit_setuppassword_new_password_placeholder": "비밀번호를 입력해 주세요.",
  "setting.edit_setuppassword_new_password_validation_text": "비밀번호는 영어, 숫자 또는 특수문자로 8~25글자 입력해 주세요.",
  "setting.edit_setuppassword_new_password_again_placeholder": "비밀번호를 다시 입력해 주세요.",
  "setting.edit_setuppassword_new_password_again_validation_text": "비밀번호를 한번 더 입력해 주세요.",
  "setting.edit_setuppassword_change_button": "설정",
  "setting.edit_setuppassword_alert_title": "비밀번호가 설정되었어요.",
  "setting.edit_setuppassword_alert_description": "이제 이 비밀번호로 로그인할 수 있어요.",
  "register.userinfo_password_not_match_validation_text": "비밀번호가 일치하지 않아요.",
  "register.userinfo_password_match_validation_text": "비밀번호가 일치해요.",
  "email.template_footer_message": "이 이메일은 발신 전용입니다. 문의가 있으실 경우, 고객센터 문의하기로 연락주시기 바랍니다.",
  "email.template_title": "새 비밀번호 설정",
  "email.template_password_reset_body_title": "새 비밀번호 설정",
  "email.template_password_reset_body_description": "새 비밀번호를 설정하려면 아래 버튼을 눌러 주세요.",
  "email.template_password_reset_reset_password_button": "새 비밀번호 설정",
  "email.page_password_reset_success_title": "<strong>새 비밀번호가 설정되었어요</strong>.",
  "email.page_password_reset_success_description": "이제 새 비밀번호로 로그인해보세요.",
  "email.page_password_reset_fail_title": "<strong>새 비밀번호 설정을 위한 링크가 더 이상 유효하지 않아요</strong>.",
  "email.page_password_reset_fail_title_no_strong": "새 비밀번호 설정을 위한 링크가 더 이상 유효하지 않아요.",
  "email.page_password_reset_fail_description": "다른 이메일로 다시 시도해 주세요.",
  "email.page_password_reset_validation_text": "영문, 숫자를 포함하여 8~25글자를 입력해 주세요.",
  "email.page_password_reset_re_type_validation_text": "영문, 숫자를 포함하여 8~25글자를 입력해 주세요.",
  "email.page_password_reset_re_type_match_validation_text": "같은 비밀번호를 다시 입력해 주세요.",
  "block.account_title": "회원님의 계정이 차단되었어요.",
  "block.account_message": "문의가 있으신 경우, 고객센터로 연락 주세요.",
  "block.account_re_active_date_text": "해제 날짜",
  "block.account_contact_us_button": "문의하기",
  "block.title_title": "회원님의 스토리가 차단되었어요. 지금은 스토리를 공개할 수 없어요.",
  "block.useraccount_alert_message": "현재 팅글 이용이 차단된 상태입니다.",
  "block.community_alert_message": "현재 커뮤니티 활동이 차단된 상태입니다.",
  "block.account_unblocked_date_text": "해제 예정일",
  "block.reason": "사유",
  "profile.introduction": "소개글",
  "block.block_button": "차단하기",
  "block.block_alert_title_character": "캐릭터를 차단하시겠어요?",
  "block.block_toast_complete": "차단에 성공했어요.",
  "block.block_toast_failed": "차단에 실패했어요.",
  "block.block_toast_failed2": "더 이상 차단할 수 없어요.",
  "block.block_list": "차단 목록",
  "block.block_list_empty_character": "차단한 캐릭터가 없어요.",
  "block.unblock_toast_deleted": "삭제된 캐릭터입니다.",
  "block.unblock_button": "차단해제",
  "block.unblock_alert_title_character": "캐릭터 차단을 해제하시겠어요?",
  "block.unblock_toast_complete": "차단이 해제됐어요.",
  "block.unblock_toast_failed": "차단 해제에 실패했어요.",
  "banner.body_title": "버블탭 스튜디오에서<br/>당신의 스토리를 담아보세요.",
  "banner.body_description": "보다 전문적이며 다양한 기능을 가진 버블탭 스튜디오에서<br/>더욱 재밌는 스토리를 만들 수 있습니다.",
  "banner.body_button": "스튜디오 방문하기",
  "footer.rights_message": "© 2025 주식회사 버블탭",
  "footer.ceo_text": "대표자",
  "footer.ceo_name_text": "박종범",
  "footer.address_text": "주소",
  "footer.address_info_text": "대한민국 서울특별시 강남구 테헤란로 207 아가방빌딩 5층",
  "footer.company_name_text": "주식회사 버블탭",
  "footer.tel_text": "TEL",
  "footer.tel_info_text": "＋82 02-2039-7572",
  "footer.email_text": "Email",
  "footer.email_info_text": "support@bubbletap.com",
  "footer.registration_number_text": "사업자 등록번호",
  "footer.registration_bus_report_num": "통신판매업 신고번호",
  "browser.support_alert_title_message": "웹 브라우저를 업데이트해주세요!",
  "browser.support_alert_description_message": "팅글 스튜디오는 최신 버전의 브라우저에 최적화 되어 있어요.",
  "browser.support_alert_chrome_description_message": "Chrome은  Ver. 9 이상에서 원활하게 동작해요",
  "browser.support_alert_edge_description_message": "Edge는 Ver. 18  이상에서 원활하게 동작해요.",
  "browser.support_alert_safari_description_message": "Safari는 Ver. 14 이상에서 원활하게 동작해요.",
  "browser.support_alert_firefox_description_message": "Firefox는 Ver. 65 이상에서 원할하게 동작해요.",
  "browser.support_alert_ie_description_message": "IE는 아쉽게도 지원하지 않아요.",
  "error.page_title_message": "잘못된 경로로 접속하셨어요.",
  "error.page_description_message": "아래 버튼을 누르시면 팅글 홈페이지로 갈 수 있어요",
  "error.page_bubblechat_go_button": "팅글 홈페이지로 가기",
  "contest.agree_message": "참가하기",
  "contest.agree_confirm_message": "'{{string_contestName}}'에 참가 중입니다.",
  "contest.agree_alert_title": "'{{string_contestName}}' 참가 안내",
  "contest.agree_alert_description": "체크할 경우, 참가에 동의하게 됩니다.",
  "contest.publish_alert_title": "이 에피소드를 공개할 수 없어요.",
  "contest.publish_alert_description_first": "각각의 에피소드는 {{int_mintext}}자 이상 입력해야해요.",
  "contest.publish_alert_description_second": "현재 글자 수:",
  "contest.save_alert_title": "이 에피소드를 저장할 수 없어요.",
  "contest.save_alert_description_first": "각각의 에피소드는 {{int_mintext}}자 이상 입력해야해요.",
  "contest.save_alert_description_second": "현재 글자 수:",
  "contest.delete_alert_title": "이 스토리는 삭제할 수 없어요.",
  "contest.delete_alert_description": "스토리는 드래프트 상태에서만 삭제할 수 있어요.",
  "contest.modify_alert_title": "이 스토리는 수정할 수 없어요.",
  "contest.modify_alert_description": "심사 기간 중에는 공모전에 참가한 스토리의 편집, 삭제를 할 수 없어요.",
  "contest.edit_draft_alert_title": "이 스토리는 수정할 수 없어요.",
  "contest.edit_draft_alert_description": "심사 기간 중에는 공모전에 참가한 스토리의 편집을 할 수 없어요.",
  "contest.bubbleup.challenge_message": "도전하기",
  "contest.bubbleup.challenge_description": "누구나 가능해!",
  "contest.edit_draft_alert_character_title": "이 캐릭터는 수정할 수 없어요.",
  "contest.edit_draft_alert_character_description": "심사 기간 중에는 공모전에 참가한 스토리의 캐릭터는 편집을 할 수 없어요.",
  "contest.edit_draft_alert_warning_message": "해당 스토리를 삭제하면 공모전 또는 이벤트 참가가 취소되어요.",
  "contest.agree_end_error_alert_tittle": "일시적인 현상으로 참여할 수 없어요. 재시도 해주세요.",
  "contest.agree_end_error_alert_message": "공모전 또는 이벤트가 종료되어 참여할 수 없습니다.",
  "contest.title": "공모전",
  "profile.edit_username_description": "아이디 변경",
  "profile.edit_writername_description": "닉네임 변경",
  "profile.edit_username_description_message": "새로운 아이디를 입력해 주세요.",
  "profile.edit_writername_description_message": "새로운 닉네임을 입력해주세요.",
  "profile.edit_username_duplicate_message": "이미 사용 중인 아이디예요.",
  "profile.category_community_other_post_list_null_message": "첫 포스트를 작성해 보세요!",
  "profile.following_suggestion": "팔로잉을 해보세요.",
  "profile.gather_followers": "팔로워를 모아 보세요.",
  "profile.category_community_post_list_null_message": "작성한 포스트가 없어요.",
  "profile.sns_category_following_list_null_message": "아직 팔로잉한 사람이 없어요.",
  "profile.sns_category_follower_list_null_message": "아직 팔로워가 없어요.",
  "notice.legal_content_alert_message": "본 서비스의 콘텐츠는 (주)팅글 소유의 저작물로서 (주)팅글 웹스튜디오와 앱 내에서만 사용 가능합니다. (주)팅글의 승인 없이 무단으로 이를 도용하거나 복제할 시 저작권법에 의거해 법적 조치를 취할 수 있습니다.",
  "notice.legal_content_alert_create_story_title_message": "유의 사항을 읽어주세요!",
  "notice.legal_content_alert_create_story_main_message": "이용자가 스토리 및 에피소드 제목, 표지, 본문, 캐릭터 등 생성 시 아래 사항들을 위반할 경우 팅글 운영 정책 및 관련 법률에 따라 제재를 받을 수 있습니다.",
  "notice.legal_content_alert_create_story_body_message1": "타회원을 비롯한 타인의 지적재산권을 당사자의 동의 없이 불법으로 공유하거나 게재한 경우",
  "notice.legal_content_alert_create_story_body_message2": "유명인을 비롯한 타인의 개인 정보, 사생활, 초상, 성명 등과 관련된 모든 권리를 침해하거나 모욕하는, 또는 명예를 훼손하는, 작품, 표지, 캐릭터 등을 생성 및 배포하는 경우",
  "notice.legal_content_alert_create_story_body_message3": "본인 이외의 자를 사칭하거나 허위사실을 주장하는 등 타인을 기만하는 경우",
  "notice.legal_content_alert_create_story_body_message4": "과도한 욕설, 비속어 등을 반복적으로 사용하여 혐오감, 불쾌감, 공포심을 일으키는 경우",
  "notice.legal_content_alert_create_story_body_message5": "타인에게 잔혹감 또는 혐오감을 일으킬 수 있는 폭력적이고 자극적인 내용을 생성 또는 유포하는 경우",
  "notice.legal_content_alert_create_story_body_message6": "자극적이고 노골적인 성행위를 묘사하는 등 타인에게 성적 수치심을 유발시키거나 왜곡된 성의식 등을 야기할 수 있는 음란물을 생성 또는 유포하는 경우",
  "notice.legal_content_alert_create_story_body_message7": "타인에 대해 직접적이고 명백한 신체적 위협을 가하는 내용 또는 타인의 자해 행위 또는 자살을 부추기거나 권장하는 경우",
  "notice.legal_content_alert_create_story_body_message8": "특정 개인이나 단체에 대한 악의적인 차별, 편견을 조장하는 경우",
  "notice.legal_content_alert_create_story_body_message9": "관련 법령상 금지되거나 형사처벌의 대상이 되는 행위를 수행하거나 이를 교사 또는 방조하는 경우",
  "notice.legal_content_alert_create_story_body_message10": "관련 법령에서 홍보, 광고, 판매 등을 금지하고 있는 물건 또는 서비스를 홍보, 광고, 판매하는 경우",
  "notice.legal_content_alert_create_story_body_message11": "공공 안전에 대해 직접적이고 심각한 위협을 가하는 내용을 생성 또는 유포하는 경우",
  "notice.legal_content_alert_create_story_body_message12": "회사는 유의 사항을 위반한 게시물에 대해 별도의 통지 없이 삭제 조치를 취하거나 계정을 정지할 수 있습니다.",
  "notice.legal_content_alert_create_story_body_message13": "회사는 생성된 스토리의 텍스트, 이미지 등 구성 요소를 마케팅 활동에 이용할 수 있습니다.",
  "notice.legal_content_alert_create_story_tail_message": "유의 사항을 위반한 법적 문제의 모든 책임은<br/>스토리 작성자에게 있습니다.",
  "notice.legal_content_alert_create_story_button": "동의 후 스토리 생성하기",
  "ai.create_edit_title.cover_name": "AI 서비스",
  "ai.create_edit_title.name": "AI 이미지",
  "ai.create_edit_title.cover_message": "팅글 AI로 나만의 표지를 만들어 보세요.",
  "ai.create_screen_title.image_similarity_name": "유사도",
  "ai.create_screen_title.image_similarity_message": "유사도가 높을수록 원본 이미지가 더 많이 반영돼요!",
  "ai.create_screen_title.image_style_name": "스타일",
  "ai.create_screen_title.image_view_all_name": "모두 보기",
  "ai.create_screen_title.image_prompt_name": "프롬프트",
  "ai.create_screen_title.image_prompt_example_name": "프롬프트 예시",
  "ai.create_screen_title.image_prompt_example_description1": "이 여자가 우주공간 배경에 있는걸로 바꿔줘",
  "ai.create_screen_title.image_prompt_example_description2": "우주에 있는 한명의 여자",
  "ai.create_screen_title.image_prompt_example_description3": "80대 노인으로 늙게 만들어주고 전신샷 해줘",
  "ai.create_screen_title.image_prompt_example_description4": "80대 노인, 주름살, 전신샷",
  "ai.create_screen_title.image_prompt_example_description5": "소년, 무표정, 금발, 흰 피부, 흰 티셔츠, 청바지, 숲",
  "ai.create_screen_title.image_prompt_example_description6": "잘생긴 남자, 20대, 갈색 머리, 녹색 눈, 하늘색 셔츠, 흰색 티셔츠, 검은색 바지, 온화한 미소, 비오는 날씨, 길, 우산을 들고 있는 남자",
  "ai.create_screen_title.image_prompt_example_description7": "해변에 누워 칵테일을 들고 선베드에 누워 일광욕을 하는 남자, 야자수, 갈매기",
  "ai.create_screen_title.image_prompt_example_description8": "실루엣 스타일, 밤에 나뭇가지에 앉아 있는 부엉이의 실루엣을 담은 영화 필름, 매우 세밀한 안개 조명, 백라이트, 4k uhd 걸작",
  "ai.create_screen_title.image_prompt_description": "원하는 이미지의 설명을 적어주세요.",
  "ai.create_screen_title.original_image_button": "그대로 사용",
  "ai.create_screen_title.random_image_button": "랜덤으로 이미지 만들기",
  "ai.create_screen_title.ai_image_button": "AI로 이미지 만들기",
  "ai.create_screen_title.return_message": "생성한 이미지를 사용하지 않고 종료하시겠습니까?",
  "ai.create_studio_background_color_edit_name": "배경 색상 편집",
  "ai.create_studio_background_upload_fail_message": "입력한 이미지 업로드에 실패했어요.",
  "ai.create_studio_background_example_description1": "파란 하늘과 드넓은 해안가",
  "ai.create_studio_background_example_description2": "전체적으로 파란 하늘 배경",
  "ai.create_studio_background_example_description3": "윗 부분은 회색 천장, 아랫 부분은 교실 책상과 의자",
  "ai.create_studio_background_example_description4": "푸른 하늘과 산, 옛 한옥 골목길",
  "ai.create_studio_background_example_description5": "비오는 하늘, 분위기 있는 조명이 비춰지는 도시",
  "ai.create_studio_background_example_description6": "파스텔 톤의 창고 내부",
  "ai.create_studio_background_example_description7": "별이 빛나는 어두운 하늘의 야외 수영장",
  "ai.create_studio_background_example_description8": "이미지 상단의 흰색 여백, 하단의 집 사이 골목",
  "ai.loading_screen_advertising_message1": "손끝으로 즐기는 이야기",
  "ai.loading_screen_advertising_message2": "팅글에서 나만의 스토리를 손쉽게 만들고 즐겨보세요!",
  "ai.loading_screen_alert_description": "현재 대기인수",
  "ai.loading_screen_alert_message": "AI 이미지 생성 중",
  "ai.loading_screen_alert_message2": "서비스 접속 대기 중입니다.",
  "ai.result_screen_alert_message": "AI 이미지 생성 완료!",
  "ai.result_screen_alert_prompt_description1": "프롬프트를 추가해 보세요!",
  "ai.result_screen_alert_prompt_description2": "프롬프트를 변경해 보세요!",
  "ai.result_screen_title.ai_image_button1": "다시 만들기",
  "ai.result_screen_title.ai_image_button2": "사용하기",
  "ai.result.fail_create_image_message": "AI 이미지 생성에 실패했습니다.",
  "ai.button_background": "배경",
  "notification.list_title": "알림",
  "notification.my_news_title": "내소식",
  "notification.freebie_reads_title": "기다무",
  "notification.events_title": "이벤트",
  "notification.bubble_title": "재화",
  "notification.notice_title": "공지",
  "notification.list_unread_notification": "읽지 않은 알림",
  "notification.list_all_read": "모두 읽기",
  "notification.delete_90days_message": "받은 알림이 없어요.",
  "notification.delete_90days_message_part2": "받은 알림은 90일 후, 자동 삭제됩니다.",
  "notification.notice_history_headline_description": "알림 상세 내역은 팅글 앱에서 확인할 수 있어요.",
  "tag.title": "태그",
  "tag.selection": "1~10개의 태그를 선택하세요.",
  "tag.selection_notification": "1개 이상의 태그를 선택하세요.",
  "tag.suggestion_button": "태그 제안하기",
  "tag.suggestion_title": "태그 제안하기",
  "tag.suggestion_description": "추가하고 싶은 태그를 알려주시면<br/> 내부 검토를 통해 태그가 추가될 수 있어요! ",
  "tag.suggestion_placeholder": "태그 이름 및 요청사항 작성",
  "tag.suggestion_submission_button": "제안",
  "tag.selection_untap": "태그를 선택하고 원하는 스토리를 찾아보세요!",
  "tag.suggestion_no_match": "태그에 맞는 스토리가 없어요.",
  "search.category_story_tab_msg": "읽고 싶은 스토리를 검색해 보세요.",
  "search.category_profile_tab_msg": "찾고 싶은 닉네임을 검색해 보세요.",
  "search.category_title_list_null_message": "검색어에 맞는 스토리가 없어요.",
  "search.category_profile_null_message": "검색어에 맞는 닉네임이 없어요.",
  "search.asset_none": "찾으시는 애셋이 없어요.",
  "search.story": "읽고 싶은 스토리를 찾아보세요.",
  "topup.purchase_receive_bonus": "이벤트에 참여하고 보너스를 받아 보세요.",
  "report.result_title": "신고가 접수되었어요.",
  "report.result_description": "보내주신 신고 내역은<br/>꼼꼼하게 살펴볼게요.",
  "report.error_occurred": "신고 전송 중 오류가 발생했어요!",
  "report.result_fail_description": "불편을 드려 죄송해요.<br/>잠시 후 다시 시도해주세요.",
  "report.type.chat_sexual_content": "성적 내용",
  "report.type.chat_violent_content": "폭력성",
  "report.type.chat_hate_discrimination": "혐오 및 차별",
  "report.type.chat_privacy_violation": "프라이버시 침해",
  "report.type.chat_other": "기타",
  "chapter.read_end_comment_list_null_message": "댓글을 작성해 보세요.",
  "chapter.list_null_message": "아직 공개한 스토리가 없어요.",
  "library.category_favorites_asset_add_msg": "마음에 드는 애셋을 <br/>즐겨찾기에 등록해 보세요.",
  "library.category_favorites_list_null_message": "관심있는 스토리에 북마크를 해보세요.",
  "library.category_purchased_story_list_null_message": "스토리를 구매해 보세요.",
  "network.internet_no_connection_title": "연결된 인터넷을 찾을 수 없어요.",
  "network.internet_no_connection_message": "네트워크에 연결되어 있지 않아요.<br/>다시 연결을 시도해 주세요.",
  "setting.edit_delete_account_button": "회원 탈퇴",
  "setting.edit_delete_account_screen_name": "회원 탈퇴",
  "setting.edit_delete_account_screen_agree_alert_set_password_title": "비밀번호를 먼저 설정해주세요",
  "setting.edit_delete_account_screen_agree_alert_set_password_description": "아직 비밀번호가 설정되어 있지 않아요. 비밀번호를 먼저 설정해 주세요.",
  "setting.edit_delete_account_screen_title": "정말 탈퇴하실 건가요?",
  "setting.edit_delete_account_screen_description": "탈퇴하시면 팅글과 여러 작가님들이 준비한 서사와 스토리를 만나실 수 없어요.",
  "setting.edit_delete_account_screen_agree_message": "아래 내용을 확인하였으며 이에 동의합니다.",
  "setting.edit_delete_account_screen_agree_story_message": "작성하신 스토리는 모두 삭제되어 다시 복구할 수 없습니다.<br/>또한 구매한 스토리를 비롯한 모든 유료 및 무료 콘텐츠 역시 모두 삭제되며 다시 복구할 수 없습니다.",
  "setting.edit_delete_account_screen_agree_post_message": "작성한 게시물 중 본인 계정에 등록된 게시물 일체는 삭제되나,<br/>제 3자에 의해 담기, 스크랩 등이 되어 재게시되거나, 공용게시판에 등록된 게시물은 삭제되지 않습니다.",
  "setting.edit_delete_account_screen_agree_revenue_message": "스토리 및 에피소드 등 판매한 콘텐츠로 인해 발생한 수익 내역이 모두 사라지며 다시 복구할 수 없습니다.<br/>또한 수익금의 잔액 또한 출금 요청하실 수 없습니다.",
  "setting.edit_delete_account_screen_agree_delete_message": "회원 탈퇴 후에도 해당 법령에 따라 개인 정보는 일정 기간 보관 후에 파기하게 됩니다.",
  "setting.edit_delete_account_screen_agree_verification_message": "본인 인증 후 회원 탈퇴 시, 7일간 해당 명의로 다시 본인 인증이 불가능합니다.",
  "setting.edit_delete_account_screen_agree_confirm_password_message": "본인 확인을 위한 계정의 비밀번호를 입력해 주세요.",
  "setting.edit_delete_account_screen_agree_alert_agree_title": "모든 내용에 동의해 주세요.",
  "setting.edit_delete_account_screen_agree_alert_agree_description": "모든 내용에 동의하셔야 회원 탈퇴가 이루어집니다.",
  "setting.edit_delete_account_screen_agree_alert_password_title": "비밀번호가 잘못되었습니다.",
  "setting.edit_delete_account_screen_agree_alert_password_description": "현재 사용 중인 비밀번호를 입력해 주세요.",
  "setting.edit_delete_account_screen_agree_alert_delete_account_title": "회원 탈퇴 되었습니다.",
  "setting.edit_delete_account_screen_agree_alert_delete_account_description": "팅글은 언제든 여러분의 스토리를 기다릴게요.",
  "identity.verification": "본인 인증",
  "identity.verification.adult": "성인 인증",
  "identity.verification_request": "본인 인증을 해주세요.",
  "identity.verification_completed": "본인 인증이 완료되었습니다.",
  "identity.reverification_completed_title": "재인증이 완료되었습니다",
  "identity.reverification_completed_description": "이제 성인용 콘텐츠를 정상적으로 이용하실 수 있습니다.",
  "identity.verification_explanation1": "본인 인증은 사용하고 있는 계정이 본인의 것임을 인증 받기위한 적법한 절차예요.",
  "identity.verification_explanation2": "최대 2개의 계정에 동일한 명의로 본인 인증이 가능해요.",
  "identity.verification_explanation3": "본인 인증이 완료되면 내역을 취소하거나 명의를 변경할 수 없어요.",
  "identity.verification_explanation4": "버블업에 선정되는 경우 반드시 본인 인증이 완료되어야 이후 절차를 진행할 수 있어요.",
  "identity.verification_notify1": "<link1>개인 정보 수집 및 이용</link1>에 동의합니다.",
  "identity.verification_notify2": "타인의 명의를 도용하거나 본인의 개인 정보가 아닐 경우 법적 책임을 다할 것에 동의합니다.",
  "identity.verification_toverify": "인증하기",
  "identity.verification_expired": "성인 인증 만료",
  "identity.verification_success": "본인 인증 성공",
  "identity.verification_completed2": "인증완료",
  "identity.verification_complete_date": "본인 인증 완료일",
  "identity.verification_failed": "본인 인증 실패",
  "identity.verification_cancelled": "사용자가 본인 인증을 취소하였습니다.",
  "identity.verification_failed_reason_unknown": "알 수 없는 이유로 실패하였습니다.",
  "identity.verification_fail_message": "본인 인증에 실패했습니다.",
  "identity.verification_success_message": "본인 인증이 완료되었습니다.",
  "charging_stn.free_tap": "무료 충전소",
  "charging_stn.paid_tap": "유료 스토어",
  "charging_stn.free_msg_choose_button": "마음에 드는 버튼을 눌러",
  "charging_stn.free_msg_get_bubbles": "무료포인트를 획득해 보세요",
  "charging_stn.top_title": "스토어",
  "charging_stn.top_title_a": "포인트 무료 충전소",
  "charging_stn.button_bubble": "포인트 충전소",
  "charging_stn.button_preparing": "준비중",
  "charging_stn.info_msg": "포인트 스토어에 대한 안내",
  "charging_stn.info_msg_expiration": "스토어를 통해 지급된 광고 리워드의 유효기간은 7일입니다.",
  "charging_stn.info_msg_refund": "스토어를 통해 지급된 광고 리워드는 환불이 불가능합니다.",
  "charging_stn.info_msg_charge_time": "광고 실행 후, 충전까지 최대 3분이 소요될 수 있습니다.",
  "charging_stn.info_msg_inquiry": "충전이 되지 않는 경우, 각 포인트 충전소의 문의하기를 통해 요청해 주시면 확인 후 지급해드립니다.",
  "charging_stn.free_button": "충전소 {{int_number}}호",
  "payment.page_bubble_zero": "보유 포인트",
  "payment.page_bubble_one": "보유 포인트",
  "payment.page_bubble_other": "보유 포인트",
  "payment.page_paid_bubble_zero": "유료 포인트",
  "payment.page_paid_bubble_one": "유료 포인트",
  "payment.page_paid_bubble_other": "유료 포인트",
  "payment.page_bonus_bubble_zero": "보너스 포인트",
  "payment.page_bonus_bubble_one": "보너스 포인트",
  "payment.page_bonus_bubble_other": "보너스 포인트",
  "payment.page_reward_bubble_zero": "포인트 지급",
  "payment.page_reward_bubble_one": "포인트 지급",
  "payment.page_reward_bubble_other": "포인트 지급",
  "payment.page_purchase_tab": "충전하기",
  "payment.page_spent_tab": "유료구매",
  "payment.page_bonus_tab": "보너스",
  "payment.page_list_bubble_zero": "포인트",
  "payment.page_list_bubble_one": "포인트",
  "payment.page_list_bubble_other": "포인트",
  "payment.history_rewards": "리워드",
  "payment.history_awarded_bonus": "보너스 지급",
  "payment.history_expired_bonus": "유효기간 만료",
  "payment.history_ad_reward": "광고 리워드 지급",
  "payment.history_adj": "조정",
  "payment.history_purchased_ep": "에피소드 구매",
  "payment.history_rented_ep": "에피소드 대여",
  "payment.history_in_app_purchase": "인앱결제",
  "payment.history_topup_bubble": "포인트 구매",
  "payment.history_refunded": "환불",
  "payment.history_receive_bonus": "이벤트에 참여하고 보너스를 받아보세요.",
  "payment.history_purchase_shampoo_title": "구매",
  "payment.history_purchase_shampoo_detail": "포션 결제",
  "payment.history_refund_shampoo": "환불",
  "payment.history_refund_for_censored_image": "검열 이미지 환불",
  "payment.status_progress": "결제를 진행 중입니다.",
  "payment.status_failed": "결제에 실패했어요. 관련 문의는 <link1>고객센터 문의하기</link1>를 이용해주세요.",
  "payment.status_invalid_info": "입력하신 카드정보가 유효하지 않아요.<br/>다시 시도해주세요.",
  "payment.status_completed": "결제가 완료되었습니다.",
  "payment.status_successful": "결제에 성공했습니다!",
  "payment.unavailable_paid_episodes": "유료 에피소드는 대여 및 구매가 불가능합니다.",
  "chat.home_home_title": "홈",
  "chat.home_characters_title": "캐릭터",
  "chat.home_characters_count_zero": "캐릭터",
  "chat.home_characters_count_one": "캐릭터",
  "chat.home_characters_count_other": "캐릭터",
  "chat.home_universes_title": "서사",
  "chat.home_universes_count_zero": "서사",
  "chat.home_universes_count_one": "서사",
  "chat.home_universes_count_other": "서사",
  "chat.home_scenes_title": "테마",
  "chat.home_scenes_count_zero": "테마",
  "chat.home_scenes_count_one": "테마",
  "chat.home_scenes_count_other": "테마",
  "chat.home_nsfw_toggle": "팅글모드",
  "chat.home_nsfw_toggle_modal_title": "팅글모드에는 성인용 콘텐츠가<br/>포함되어 있습니다.",
  "chat.home_nsfw_toggle_modal_description": "만 18세 미만은 이용하실 수 없어요.<br/>만 18세 이상이신가요?",
  "chat.home_nsfw_toggle_modal_confirm": "네, 만 18세 이상입니다",
  "chat.home_nsfw_toggle_modal_cancel": "아니오, 만 18세 미만입니다",
  "chat.home_nsfw_toggle_reject_country_modal_title": "서비스 이용이 제한된 지역이에요.",
  "chat.home_first_title": "당신만의 캐릭터와 당신만의 세계에서",
  "chat.home_first_select_character": "어떤 캐릭터와 대화하고 싶으신가요?",
  "chat.home_first_select_character_female": "여자 캐릭터",
  "chat.home_first_select_character_male": "남자 캐릭터",
  "chat.home_first_start_chat": "대화 시작",
  "chat.home_first_failed_character_list_message": "앗! 캐릭터 목록을 가져오지 못했어요.",
  "chat.home_first_failed_character_list_refresh_message": "새로고침 해주실래요?",
  "chat.home_first_failed_character_list_refresh_button": "새로 고침",
  "chat.home_nsfw_toggle_mobile": "팅글",
  "chat.home_first_shampoo_empty": "포션이 모두 소진됐어요",
  "chat.home_first_verification_super_shampoo": "지금 본인 인증 하시면 매직 포션으로 즉시 업그레이드 해드려요. 24시간 동안 마음껏 대화할 수 있는 매직 포션을 경험해보세요!",
  "chat.home_first_verification_super_shampoo_description": "*매직 포션은 일반 포션보다 10배 더 넉넉해요!<br/>*포션이 차있는 동안 무료 채팅이 가능해요.<br/>*포션 충전은 최대 24시간이 걸려요.",
  "chat.home_first_verification_no_thanks": "괜찮아요",
  "chat.home_first_verification_button": "본인 인증",
  "chat.home_first_upgrade_super_shampoo": "매직 포션으로 업그레이드 해보세요!",
  "chat.home_first_shampoo_bubbles_empty": "일반 포션과 포인트를 모두 소진했습니다.",
  "chat.home_first_normal_shampoo_empty": "일반 포션을 모두 소진했습니다.",
  "chat.home_first_get_super_shampoo": "매직 포션 받기",
  "chat.home_first_no_show_again": "다시 보지 않음",
  "chat.home_first_verification_super_shampoo_upgrade": "최초 본인 인증 시, 보다 많은 무료 대화를 나눌 수 있는 '매직 포션'으로 업그레이드 해드립니다!",
  "chat.home_first_sign_in": "로그인하고 <strong>포션</strong>으로 매일<br/><strong>무료 대화</strong>를 나눠 보세요!",
  "chat.home_first_start_kakao": "<strong>Kakao</strong>로 시작하기",
  "chat.home_first_start_google": "<strong>Google</strong>로 시작하기",
  "chat.home_first_start_apple": "<strong>Apple</strong>로 시작하기",
  "chat.home_first_welcome_title": "환영해요!",
  "chat.home_first_welcome_sub_title": "가입하신 기념으로 매직 포션을 지급해 드렸어요. 다양한 캐릭터들과 더 많은 대화를 나눠보세요.",
  "chat.home_first_welcome_description": "10배 많은 무료 대화를 원하신다면 본인 인증하고 매직 포션을 받아보세요.",
  "chat.home_first_welcome_regular": "일반 포션 쓰기",
  "chat.home_first_welcome_super": "매직 포션 받기",
  "chat.home_first_wait_title": "잠깐! 아직 더 많은 대화를 나눌 수 있어요",
  "chat.home_first_wait_description": "10초만에 본인 인증하고 매직 포션으로 무료 대화를 이어가 보세요.",
  "chat.home_first_wait_topup": "충전하러 가기",
  "chat.home_first_wait_verify": "본인 인증",
  "chat.home_first_supershampoo_title": "매직 포션으로 업그레이드 됐어요!",
  "chat.home_first_supershampoo_description": "이제 24시간 동안 10배 더 길게 대화할 수 있어요.<br/>매직 포션은 [마이페이지]에서 확인하세요.",
  "chat.home_first_supershampoo_done": "확인",
  "chat.home_more_button": "더보기",
  "chat.home_sidebar_create": "만들기",
  "chat.home_sidebar_reward": "리워드",
  "chat.home_recent_chats": "최근 대화",
  "chat.title_chat_list": "대화 목록",
  "chat.home_sidebar_chat_list": "대화목록",
  "chat.home_sidebar_favorites": "즐겨찾기",
  "chat.home_sidebar_likes": "좋아요",
  "chat.home_sidebar_charging_station": "스토어",
  "chat.home_sidebar_guide": "가이드",
  "chat.home_sidebar_bg_fx": "배경효과",
  "chat.home_sidebar_bubbletap": "버블탭",
  "chat.home_sidebar_download": "다운로드",
  "chat.home_sidebar_display": "디스플레이",
  "chat.home_sidebar_community": "커뮤니티",
  "chat.home_sidebar_discord": "디스코드",
  "chat.home_sidebar_facebook": "페이스북",
  "chat.home_sidebar_x": "X 공식계정",
  "chat.home_sidebar_kakaotalk": "카카오톡",
  "chat.home_sidebar_threads": "스레드",
  "chat.home_sidebar_instagram": "인스타그램",
  "chat.home_sidebar_pinterest": "핀터레스트",
  "chat.tap_order_recent": "최신순",
  "chat.tap_order_liked": "좋아요 많은 순",
  "chat.tap_order_played": "플레이 많은 순",
  "chat.tap_asset_sort_week": "주간",
  "chat.tap_asset_sort_all": "전체",
  "chat.tap_asset_sort_month": "월간",
  "chat.tap_asset_tap_rising": "라이징",
  "chat.tap_asset_tap_follow": "팔로우",
  "chat.tap_asset_tap_follow_empty": "팔로우 중인 크리에이터가 없어요.",
  "chat.tap_asset_tap_follow_featured_creators": "추천 크리에이터",
  "chat.tap_asset_tap_follow_featured_creators_failed": "추천 크리에이터 불러오기에 실패했습니다.<br/>잠시 후 다시 접속해 주세요.",
  "chat.tap_asset_tap_now": "실시간",
  "chat.tap_asset_more_options_button": "추가 설정",
  "chat.tap_asset_more_options_modal_title": "필터",
  "chat.tap_asset_more_options_modal_sort": "정렬",
  "chat.tap_asset_more_options_modal_gender": "캐릭터 성별",
  "chat.tap_asset_modal_all_characters": "전체 캐릭터",
  "chat.tap_asset_modal_male_characters": "남성 캐릭터",
  "chat.tap_asset_modal_female_characters": "여성 캐릭터",
  "chat.tap_asset_modal_other_characters": "기타 캐릭터",
  "chat.tap_asset_modal_type": "유형",
  "chat.tap_asset_modal_random": "랜덤",
  "chat.tap_asset_more_options_modal_latest": "최신순",
  "chat.tap_asset_more_options_modal_multi_images": "멀티 이미지",
  "chat.tap_asset_more_options_modal_most": "많은 순",
  "chat.tap_asset_more_options_modal_least": "적은 순",
  "chat.tap_asset_more_options_modal_none": "없음",
  "chat.tap_asset_more_options_modal_most_commented": "댓글 많은 순",
  "chat.tap_asset_more_options_modal_sort_none": "선택 없음",
  "chat.tap_asset_empty": "조건에 맞는 결과가 없어요.",
  "chat.home_login": "로그인",
  "chat.home_terms_of_service": "이용약관",
  "chat.home_privacy_policy": "개인정보처리방침",
  "chat.home_operational_policy": "운영정책",
  "chat.home_juvenile_protection_policy": "청소년보호정책",
  "chat.home_app_downloads_appstore": "앱스토어에서 팅글 다운로드",
  "chat.home_app_downloads_googleplay": "스토어에서 팅글 다운로드",
  "chat.home_notification_list_unread": "확인하지 않은 알림",
  "chat.home_notification_list_read_all": "모두 읽음",
  "chat.home_notification_list_view_more": "자세히 보기",
  "chat.home_notification_setting": "알림 설정",
  "chat.home_notification_setting_agree_date": "동의일",
  "chat.home_notification_setting_comment_label": "댓글 알림",
  "chat.home_notification_setting_comment_description": "내 애셋에 새로운 댓글이 달리면 알림을 받을 수 있어요.",
  "chat.home_notification_setting_reply_label": "답글 알림",
  "chat.home_notification_setting_reply_description": "내 댓글에 새로운 답글이 달리면 알림을 받을 수 있어요.",
  "chat.home_notification_setting_like_label": "좋아요 알림",
  "chat.home_notification_setting_like_description": "내 애셋, 댓글, 답글에 좋아요가 표시되면 알림을 받을 수 있어요.",
  "chat.home_notification_setting_follow_label": "팔로우 알림",
  "chat.home_notification_setting_follow_description": "누군가 나를 팔로우하면 알림을 받을 수 있어요.",
  "chat.home_notification_setting_event_label": "이벤트 알림",
  "chat.home_notification_setting_event_description": "이벤트 관련 알림을 받을 수 있어요.",
  "chat.home_notification_setting_nighttime_event_label": "야간 이벤트 알림",
  "chat.home_notification_setting_nighttime_event_description": "21시~8시 사이에 이벤트 관련 알림을 받을 수 있어요.",
  "chat.home_notification_setting_depletion_label": "포인트 소진 알림",
  "chat.home_notification_setting_depletion_description": "포인트 소진에 대한 알림을 받을 수 있어요.",
  "chat.home_notification_setting_personal_label": "개인 중요 알림",
  "chat.home_notification_setting_personal_description": "개인에게 중요한 알림을 보내드려요.",
  "chat.home_notification_setting_official_label": "팅글 주요 공지",
  "chat.home_notification_setting_official_description": "팅글의 공지사항을 알려드립니다.",
  "chat.list_empty": "관심있는 캐릭터와 대화를 시작해보세요.",
  "chat.list_menu_view_details": "상세보기",
  "chat.list_menu_delete": "삭제하기",
  "chat.list_menu_delete_alert_cancel": "취소",
  "chat.list_menu_delete_alert_delete": "삭제",
  "chat.list_modal_character_title": "캐릭터",
  "chat.list_modal_character_description": "캐릭터 설명",
  "chat.list_modal_character_information": "상세정보",
  "chat.list_modal_character_information_gender": "성별",
  "chat.list_modal_character_information_age": "나이",
  "chat.list_modal_character_information_age_help_text": "* 19세 이하의 캐릭터는 팅글모드로 제작할 수 없어요.",
  "chat.list_modal_character_information_job": "직업",
  "chat.list_modal_character_information_character": "성격",
  "chat.list_modal_character_information_speaking_style": "말투",
  "chat.list_modal_character_information_interests": "관심사",
  "chat.list_modal_character_information_details": "추가설명",
  "chat.list_modal_character_information_details_private_exist": "비공개 추가설명이 존재합니다",
  "chat.list_modal_first_sentence": "도입부",
  "chat.list_modal_universe": "서사",
  "chat.list_modal_scene": "테마",
  "chat.list_modal_persona_title": "나의 페르소나",
  "chat.list_modal_persona_information": "상세정보",
  "chat.list_modal_persona_gender": "성별",
  "chat.list_modal_persona_age": "나이",
  "chat.list_modal_persona_job": "직업",
  "chat.list_modal_persona_character": "성격",
  "chat.list_modal_persona_speaking_style": "말투",
  "chat.list_modal_persona_interests": "관심사",
  "chat.list_modal_persona_details": "상세설명",
  "chat.list_modal_universe_title": "서사",
  "chat.list_modal_universe_relationship": "캐릭터와 나의 관계",
  "chat.list_modal_universe_introduction": "세계관 설명",
  "chat.list_modal_universe_details": "추가설명",
  "chat.list_modal_universe_private_relationship": "비공개 관계 설정이 존재합니다",
  "chat.list_modal_universe_private_details": "비공개 추가설명이 존재합니다",
  "chat.list_modal_scene_title": "테마",
  "chat.list_modal_scene_details": "추가설명",
  "chat.list_modal_scene_private_details": "비공개 추가설명이 존재합니다",
  "chat.list_modal_edit_chat_name_title": "대화방 이름",
  "chat.list_modal_edit_chat_name_placeholder": "대화방 이름을 입력해 주세요.",
  "chat.list_edit_chat_selected": "{{int_numbers}}개 선택됨",
  "chat.list_edit_delete_button": "대화방 삭제",
  "chat.list_edit_select": "항목 선택",
  "chat.list_edit_delete": "삭제",
  "chat.list_edit_delete_all": "전체 삭제",
  "chat.list_edit_select_all": "전체 선택",
  "chat.list_edit_deselect_all": "전체 해제",
  "chat.list_edit_chats": "대화방 편집",
  "chat.list_edit_delete_failed": "삭제에 실패했어요. 다시 시도해주세요.",
  "chat.list_edit_edit_failed": "수정 중 오류가 발생했어요. 다시 시도해주세요.",
  "chat.information_character_title": "캐릭터",
  "chat.information_character_none": "선택된 캐릭터가 없습니다",
  "chat.information_asset_information": "정보",
  "chat.information_asset_information_nsfw": "팅글",
  "chat.information_unit_thousand": "천",
  "chat.information_unit_ten_thousand": "만",
  "chat.information_unit_hundred_million": "억",
  "chat.information_asset_information_first_release": "최초 공개",
  "chat.information_character_deleted_account": "탈퇴한 유저",
  "chat.information_character_deleted_account_toast": "탈퇴한 유저입니다.",
  "chat.information_start_chat": "대화시작",
  "chat.information_start_chat_guest": "무제한 무료 대화 시작",
  "chat.information_resume_chat": "이어서 대화",
  "chat.information_custom_chat": "커스텀 대화",
  "chat.information_like": "좋아요",
  "chat.information_like_fail_message": "좋아요에 실패했어요.",
  "chat.information_unlike_fail_message": "좋아요 취소에 실패했어요.",
  "chat.information_favorite": "즐겨찾기",
  "chat.information_favorite_fail_message": "즐겨찾기에 실패했어요.",
  "chat.information_unfavorite_fail_message": "즐겨찾기 취소에 실패했어요.",
  "chat.information_persona": "현재 선택된 페르소나",
  "chat.information_persona_active": "사용 중",
  "chat.information_persona_add": "페르소나 추가",
  "chat.information_character_introduction": "캐릭터 설명",
  "chat.information_information": "상세정보",
  "chat.information_character_gender": "성별",
  "chat.information_character_age": "나이",
  "chat.information_character_job": "직업",
  "chat.information_character_character": "성격",
  "chat.information_character_speaking_style": "말투",
  "chat.information_character_interests": "관심사",
  "chat.information_details": "추가설명",
  "chat.information_details_user": "나",
  "chat.information_details_private_only": "비공개된 추가설명입니다",
  "chat.information_details_private_exist": "비공개 추가설명이 존재합니다",
  "chat.information_first_sentence": "도입부",
  "chat.information_universe": "서사",
  "chat.information_universe_none": "선택된 서사가 없습니다",
  "chat.information_more": "더보기",
  "chat.information_scene": "테마",
  "chat.information_scene_none": "선택된 테마가 없습니다",
  "chat.custom_selected_universe": "내가 선택한 서사",
  "chat.custom_selected_scene": "내가 선택한 테마",
  "chat.information_delete": "삭제하기",
  "chat.information_edit": "수정하기",
  "chat.information_delete_alert_message_universe": "삭제 시, 해당 서사가 기본으로 설정된 모든 캐릭터에서 제외돼요.<br/>그래도 삭제하시겠어요?",
  "chat.information_delete_alert_message_scene": "삭제 시, 해당 테마가 기본으로 설정된 모든 캐릭터에서 제외돼요.<br/>그래도 삭제하시겠어요?",
  "chat.information_delete_alert_message_failed": "삭제에 실패했어요. 다시 시도해주세요.",
  "chat.information_delete_alert_cancel": "취소",
  "chat.information_delete_alert_delete": "삭제",
  "chat.information_reviews_submit_button": "댓글 남기기",
  "chat.information_reviews_placeholder": "댓글을 남겨보세요.",
  "chat.information_reviews_empty": "아직 작성된 댓글이 없어요.",
  "chat.information_reviews_few_seconds": "몇 초 전",
  "chat.information_reviews_seconds": "{{int_seconds}}초 전",
  "chat.information_reviews_minutes": "{{int_minutes}}분 전",
  "chat.information_reviews_hours": "{{int_hours}}시간 전",
  "chat.information_reviews_view_translation": "번역 보기",
  "chat.information_reviews_view_original": "원문 보기",
  "chat.information_reviews_view_translation_unsupported_language_toast": "지원하지 않는 언어입니다.",
  "chat.information_reviews_delete failed": "삭제에 실패했습니다.",
  "chat.information_reviews_deleted_user_username": "탈퇴한 유저",
  "chat.information_reviews_deleted_user_review": "탈퇴한 유저의 댓글입니다.",
  "chat.information_reviews_deleted_review": "삭제된 댓글입니다.",
  "chat.information_replies": "답글",
  "chat.information_sort_recent": "최신순",
  "chat.information_sort_liked": "인기순",
  "chat.information_new_comment": "새로운 댓글이 달렸습니다.",
  "chat.information_new_reply": "내 댓글에 새로운 답글이 달렸습니다.",
  "chat.information_write_comment": "댓글을 작성해 주세요.",
  "chat.information_write_reply": "답글 쓰기",
  "chat.information_reply_delete_fail_message": "답글을 삭제할 수 없어요.",
  "chat.information_delete_comment_alert": "정말로 댓글을 삭제하시겠어요?",
  "chat.information_delete_reply_alert": "정말로 답글을 삭제하시겠어요?",
  "chat.information_comment_characters_limit_message": "댓글은 최대 1,000자까지 입력할 수 있어요.",
  "chat.information_reply_characters_limit_message": "답글은 최대 1,000자까지 입력할 수 있어요.",
  "chat.information_comment_character": "{{string_characterName}} 캐릭터에 댓글이 달렸어요.",
  "chat.information_comment_universe": "{{string_narrativeName}} 서사에 댓글이 달렸어요.",
  "chat.information_comment_scene": "{{string_themeName}} 테마에 댓글이 달렸어요.",
  "chat.information_comment_edit_placeholder": "내용을 입력해주세요.",
  "chat.information_reply_edit_placeholder": "내용을 입력해주세요.",
  "chat.information_comment_edit": "수정",
  "chat.information_comment_delete": "삭제",
  "chat.information_comment_edit_done": "수정",
  "chat.information_comment_edit_cancel": "취소",
  "chat.information_comment_view_all_comment": "전체 댓글 보기",
  "chat.information_comment_pin_failed": "댓글 고정에 실패했어요.",
  "chat.information_comment_unpin_failed": "댓글 고정 해제에 실패했어요.",
  "chat.information_comment_post_failed": "댓글 작성에 실패했어요.",
  "chat.information_comment_edit_failed": "댓글 수정에 실패했어요.",
  "chat.information_comment_delete_success": "댓글이 삭제되었습니다.",
  "chat.information_comment_delete_failed": "댓글 삭제에 실패했어요.",
  "chat.information_comment_like_failed": "댓글 좋아요에 실패했어요.",
  "chat.information_comment_report_success": "신고가 완료되었습니다.",
  "chat.information_comment_report_failed": "신고에 실패했습니다.",
  "chat.information_reply_post_failed": "답글 작성에 실패했어요.",
  "chat.information_reply_edit_failed": "답글 수정에 실패했어요.",
  "chat.information_reply_delete_success": "답글이 삭제되었습니다.",
  "chat.information_reply_delete_failed": "답글 삭제에 실패했어요.",
  "chat.information_reply_like_failed": "답글 좋아요에 실패했어요.",
  "chat.information_reply_report_success": "신고가 완료되었습니다.",
  "chat.information_reply_report_failed": "신고에 실패했습니다.",
  "chat.information_comment_reply_deleted_comment": "삭제된 댓글에는 답글을 남길 수 없어요.",
  "chat.information_comment_pin_deleted_comment": "삭제된 댓글은 고정하거나 해제할 수 없어요.",
  "chat.information_reviews_report": "신고하기",
  "chat.information_reviews_report_modal_title": "댓글 신고하기",
  "chat.information_reply_report_modal_title": "답글 신고하기",
  "chat.information_reply_deleted_user": "탈퇴한 유저의 답글입니다.",
  "chat.information_reply_deleted": "삭제된 답글입니다.",
  "chat.information_leave_reply": "답글을 남겨보세요.",
  "chat.information_comment_button_submit_only": "남기기",
  "chat.information_comment_show_more": "더보기",
  "chat.information_comment_show_more2": "펼치기",
  "chat.information_comment_show_less": "접기",
  "chat.information_reviews_report_modal_description": "신고 사유를 알려주세요.",
  "chat.information_reviews_report_modal_dropdown": "신고 사유 선택",
  "chat.information_reviews_report_modal_misconduct": "부적절한 활동",
  "chat.information_reviews_report_modal_unapproved": "무허가 광고",
  "chat.information_reviews_report_modal_personal": "개인정보 유출",
  "chat.information_reviews_report_modal_promo": "광고",
  "chat.information_reviews_report_modal_other": "그 외",
  "chat.information_reviews_report_modal_placeholder": "신고 사유 작성",
  "chat.information_reviews_report_modal_cancel": "취소",
  "chat.information_reviews_report_modal_submit": "전송",
  "chat.information_character_report_modal_title": "캐릭터 신고하기",
  "chat.information_universe_report_modal_title": "서사 신고하기",
  "chat.information_scene_report_modal_title": "테마 신고하기",
  "chat.information_asset_report_modal_copyright_title": "표절 / 저작권 침해",
  "chat.information_asset_report_modal_copyright_description": "표절 혹은 저작권 침해 신고는 증빙 자료 및 서류에 따라 처리됩니다.",
  "chat.information_universe_introduction": "서사 설명",
  "chat.information_universe_relationship": "캐릭터와 나의 관계",
  "chat.information_relationship_private_only": "비공개된 관계 설정입니다.",
  "chat.information_relationship_private_exist": "비공개 관계 설정이 존재합니다.",
  "chat.information_scene_introduction": "소개문구",
  "chat.information_scene_place": "공간적 배경",
  "chat.information_scene_time": "시대적 배경",
  "chat.information_character_load_fail_message": "캐릭터 정보를 불러오는데 실패했어요.",
  "chat.information_universe_load_fail_message": "서사 정보를 불러오는데 실패했어요.",
  "chat.information_scene_load_fail_message": "테마 정보를 불러오는데 실패했어요.",
  "chat.information_private_fail_message_character": "존재하지 않는 캐릭터입니다.",
  "chat.information_private_fail_message_universe": "존재하지 않는 서사입니다.",
  "chat.information_private_fail_message_scene": "존재하지 않는 테마입니다.",
  "chat.information_no_chat_nsfw_characters": "19세 이하 캐릭터와는 팅글모드로 대화가 불가능합니다.",
  "chat.information_character_details_private_only": "비공개된 인물 설명입니다.",
  "chat.information_character_details_private_exist": "비공개 인물 설명이 존재합니다.",
  "chat.information_background_details_private_only": "비공개된 배경 설명입니다.",
  "chat.information_background_details_private_exist": "비공개 배경 설명이 존재합니다.",
  "chat.information_lorebook_private_only": "비공개된 설정집입니다.",
  "chat.information_lorebook_private_exist": "비공개 설정집이 존재합니다.",
  "chat.information_weekly_character": "주간 인기 캐릭터 ",
  "chat.information_weekly_universe": "주간 인기 서사",
  "chat.information_weekly_scene": "주간 인기 테마",
  "chat.custom_title": "커스텀 대화",
  "chat.custom_help_text_title": "나만의 대화를 만들어 보세요",
  "chat.custom_help_text_description": "내가 원하는 조합으로 커스텀하여 대화를 시작할 수 있어요",
  "chat.custom_character": "캐릭터",
  "chat.custom_universe": "서사",
  "chat.custom_optional": "선택",
  "chat.custom_scene": "테마",
  "chat.custom_add": "추가하기",
  "chat.custom_change": "변경하기",
  "chat.custom_create": "생성하기",
  "chat.custom_first_sentence": "도입부",
  "chat.custom_first_sentence_placeholder": "캐릭터와의 대화 도입부를 작성해 주세요.",
  "chat.custom_first_sentence_edit_modal_title": "도입부 수정",
  "chat.custom_first_sentence_edit_modal_description": "대화의 도입부를 수정할 수 있어요!\n\n",
  "chat.custom_first_sentence_edit_modal_placeholder": "캐릭터와의 대화 도입부를 작성해 주세요.",
  "chat.custom_first_sentence_edit_modal_cancel": "취소",
  "chat.custom_first_sentence_edit_modal_save": "수정",
  "chat.custom_start_chat": "바로 대화",
  "chat.custom_character_modal_title": "캐릭터 선택",
  "chat.custom_modal_done": "선택 완료",
  "chat.custom_modal_tag_placeholder": "태그를 검색해 보세요",
  "chat.custom_modal_tap_recents": "최근 플레이",
  "chat.custom_modal_tap_favorites": "즐겨찾기",
  "chat.custom_character_modal_tap_my": "나의 캐릭터",
  "chat.custom_universe_modal_title": "서사 선택",
  "chat.custom_universe_modal_tap_my": "나의 서사",
  "chat.custom_scene_modal_title": "테마 선택",
  "chat.custom_scene_modal_tap_my": "나의 테마",
  "chat.custom_select_character": "캐릭터를 선택해 주세요",
  "chat.custom_select_universe": "서사를 선택해 주세요",
  "chat.custom_select_scene": "테마를 선택해 주세요",
  "chat.custom_retry": "다시 시도하기",
  "chat.custom_back_home": "홈으로 돌아가기",
  "chat.custom_find_character_failed": "찾으시는 캐릭터가 없나요?",
  "chat.custom_go_create_character": "내 캐릭터 만들러 가기",
  "chat.custom_report_once": "신고는 한 번만 할 수 있어요.",
  "chat.custom_private_universe_selected": "비공개된 서사가 선택되었습니다. 다른 서사로 시도해주세요.",
  "chat.custom_private_scene_selected": "비공개된 테마가 선택되었습니다. 다른 테마로 시도해주세요.",
  "chat.custom_nsfw_age_verification": "팅글모드 캐릭터/서사/테마는 성인 인증 후 이용하실 수 있어요.",
  "chat.custom_no_exist_assets": "존재하지 않는 캐릭터/서사/테마가 포함되어 있습니다. 다시 시도해 주세요.",
  "chat.custom_create_chat_failed": "대화방 생성에 실패했습니다. 다시 시도해 주세요.",
  "chat.custom_search_characters": "캐릭터를 검색해 보세요",
  "chat.custom_search_universes": "서사를 검색해 보세요",
  "chat.custom_search_scenes": "테마를 검색해 보세요",
  "chat.custom_search_no_results": "검색 결과가 없어요",
  "chat.custom_select_modal_asset_same_language": "동일한 언어설정 하에서 생성된 서사와 테마만 기본으로 설정할 수 있어요.",
  "chat.character.list_empty": "캐릭터가 없어요.",
  "chat.universe.list_empty": "서사가 없어요.",
  "chat.scene.list_empty": "테마가 없어요.",
  "chat.popup_settings_title": "대화방 설정",
  "chat.popup_name_title": "이름",
  "chat.popup_name_placeholder": "이름을 입력해주세요",
  "chat.popup_chat_mode_title": "스타일",
  "chat.popup_chat_mode_chat": "대화형",
  "chat.popup_chat_mode_story": "소설형",
  "chat.popup_model_title": "AI 모델",
  "chat.popup_model_estimated_cost": "예상 가격",
  "chat.popup_model_estimated_cost_failed": "응답 실패",
  "chat.popup_model_estimated_cost_description": "입력한 프롬프트 양, 누적 대화량, 답변 길이에 따라 비용이 변동될 수 있습니다.",
  "chat.popup_model_diamond": "스탠다드",
  "chat.popup_model_dia_description": "창의성과 이해력이 뛰어난 고품격 모델",
  "chat.popup_model_price_bubble": "포인트",
  "chat.popup_model_emerald": "소프트",
  "chat.popup_model_emerald_description": "수준급의 표현력을 지닌 균형잡힌 모델",
  "chat.popup_model_ruby": "라이트",
  "chat.popup_model_ruby_description": "가성비가 좋고 빠른 모델",
  "chat.popup_model_best": "추천",
  "chat.popup_nsfw_toggle_title": "팅글모드",
  "chat.popup_nsfw_toggle_description_nsfw_enable": "팅글모드 활성화 시, 보다 자극적인 대화가 가능합니다.",
  "chat.popup_nsfw_toggle_description_nsfw_disable": "19세 이하 캐릭터와는 팅글모드로 대화가 불가능합니다.",
  "chat.popup_done": "확인",
  "chat.popup_label_new": "New",
  "chat.popup_label_beta": "Beta",
  "chat.popup_label_value": "가성비",
  "chat.popup_label_sale": "할인 중",
  "chat.popup_label_date": "~{{int_date}} 까지",
  "chat.popup_chat_ai_model_signature": "시그니처",
  "chat.popup_chat_ai_model_basic": "일반",
  "chat.conversation_ai_model_basic_failed_message": "메시지 수신에 실패했습니다. 포인트는 차감되지 않았어요.",
  "chat.conversation_ai_model_basic_switch_failed": "AI 모델 변경에 실패했어요.",
  "chat.popup_character_switched_nsfw_alert": "해당 캐릭터가 팅글모드로 변경되었습니다.",
  "chat.popup_character_switched_nsfw_alert_description": "성인 인증 후에 대화를 나눌 수 있어요.",
  "chat.popup_nsfw_asset_normal_mode_failed_message": "팅글모드 캐릭터/서사/테마는 일반모드로 대화할 수 없어요.",
  "chat.conversation_menu": "대화방 관리",
  "chat.conversation_username": "이름",
  "chat.conversation_menu_gallery": "갤러리",
  "chat.conversation_menu_display_images": "이미지 보기",
  "chat.conversation_menu_gallery_unlock_button": "해금하기",
  "chat.conversation_menu_gallery_unlock_image": "대화를 통해 이미지를 획득해 보세요.",
  "chat.conversation_menu_gallery_no_images": "갤러리에 이미지가 존재하지 않아요.",
  "chat.conversation_menu_settings": "대화방 설정",
  "chat.conversation_menu_oldbie_shampoo": "포션",
  "chat.conversation_menu_newbie_shampoo": "매직 포션",
  "chat.conversation_menu_hyper_shampoo": "드림 포션",
  "chat.conversation_menu_shampoo_loading": "리필 중",
  "chat.conversation_menu_shampoo_error": "리필 실패",
  "chat.popup_new_user_title": "회원가입을 축하합니다!",
  "chat.popup_new_user_description": "가입 기념으로 무료 대화가 가능한 '포션'을 드립니다!",
  "chat.popup_newbie_shampoo_title": "매직 포션으로 업그레이드 완료!",
  "chat.popup_newbie_shampoo_description": "앞으로 24시간 동안 매직 포션을 사용해 보다 많은 무료 대화를 즐기실 수 있습니다.",
  "chat.popup_same_identity_under_seven_days_description": "본인 인증한 계정을 탈퇴 후 7일 이내에는 동일 명의로 본인 인증이 불가능합니다.",
  "chat.popup_same_identity_over_seven_days_description": "기존 유저이므로 일반 포션을 사용해 무료 대화를 나누실 수 있습니다.",
  "chat.popup_newbie_shampoo_history_exist_description": "해당 계정으로 이미 매직 포션 혜택을 받았기 때문에 일반 포션을 사용해 무료 대화를 나누실 수 있습니다.",
  "chat.popup_newbie_to_oldbie_title": "매직 포션 이용이 종료되었습니다.",
  "chat.popup_newbie_to_oldbie_description": "이제부터는 일반 포션을 사용해 무료 대화를 나누실 수 있습니다.",
  "chat.popup_newbie_to_oldbie_description_purchase": "지금 추가 구매 하시겠어요?",
  "chat.popup_shampoo_limit_message": "포션을 모두 사용했습니다.<br/>이제부터는 포인트를 사용해 대화하실 수 있습니다.",
  "chat.conversation_menu_charging_station": "포인트 충전하기",
  "chat.popup_persona_in_use": "사용 중인 페르소나 모드",
  "chat.popup_persona_notes": "메모",
  "chat.popup_persona_notes_placeholder": "페르소나에 대해 간단히 메모하세요.",
  "chat.popup_persona_pass_message": "지금 포션을 업그레이드하고 확장된 페르소나를 이용해보세요.",
  "chat.popup_persona_pass_alert_message": "현재 이용권의 글자 수 제한을 초과한 페르소나입니다.<br/>이용권을 구매하거나 페르소나의 글자 수를 조정해주세요.",
  "chat.popup_persona_content_empty": "설정된 페르소나가 없습니다.",
  "chat.popup_persona_deleted_title": "삭제된 페르소나를 사용 중입니다.",
  "chat.popup_persona_deleted_description": "페르소나를 변경하시면 다시 복구할 수 없습니다. <br/>페르소나를 변경하시겠습니까?",
  "chat.popup_usernote_title": "유저노트",
  "chat.popup_usernote_in_use": "사용 중인 유저노트",
  "chat.popup_usernote_pass_message": "지금 포션을 업그레이드 하고 확장된 유저노트를 이용해보세요.",
  "chat.popup_usernote_pass_alert_message": "현재 이용권의 글자 수 제한을 초과한 유저노트 입니다.<br/>이용권을 구매하시거나 유저노트의 글자 수를 조정해주세요.",
  "chat.popup_usernote_content_title": "내용",
  "chat.popup_usernote_content_placeholder": "캐릭터가 기억했으면 하는 내용을 입력해주세요",
  "chat.popup_usernote_toggle": "대화에 적용하기",
  "chat.popup_usernote_save": "저장",
  "chat.popup_usernote_save_fail_message": "저장에 실패했어요.",
  "chat.popup_usernote_fail_message": "유저노트를 불러오는데 실패했어요.",
  "chat.popup_usernote_copied_toast": "유저노트의 내용이 복사되었어요.",
  "chat.popup_usernote_copied_failed_toast": "유저노트 복사에 실패했습니다.<br/>다시 시도해주세요.",
  "chat.popup_edit_user_message_title": "내가 보낸 메시지",
  "chat.popup_edit_character_message_title": "캐릭터가 보낸 메시지",
  "chat.popup_edit_edit_button": "수정",
  "chat.popup_edit_placeholder": "내용을 입력해주세요.",
  "chat.popup_edit_deleted_message": "삭제된 메시지예요.",
  "chat.popup_rpm_limit_description_one": "메시지 전송에 실패했습니다. {{int_seconds}}초 후 다시 시도해 주세요.",
  "chat.popup_rpm_limit_description_other": "메시지 전송에 실패했습니다. {{int_seconds}}초 후 다시 시도해 주세요.",
  "chat.popup_exit_title": "대화방에서 나가시겠어요?",
  "chat.popup_exit_description": "선택한 캐릭터와 나눈 모든 대화가 사라집니다.",
  "chat.bottom_exit_title": "대화방 나가기",
  "chat.popup_purchase_title": "포인트가 부족해서 대화를 계속 할 수 없어요.",
  "chat.popup_purchase_description": "포인트 충전 후 캐릭터와 계속 대화해보세요.",
  "chat.popup_purchase_event_per_chat": "1챗당",
  "chat.popup_purchase_button": "충전하러 가기",
  "chat.conversation_send_message_placeholder": "메시지 보내기 (지문은 * * 사이에)",
  "chat.conversation_shampoo_refill_alert_toast": "포션이 {{int_number}}%이하에요!",
  "chat.conversation_shampoo_refill_alert_toast_button": "포션 리필",
  "chat.conversation_current_shampoo_refill_message_modal": "현재 포션",
  "chat.conversation_current_shampoo_refill_description1_modal": "앗! 포션이 바닥 나버렸어요!🫣",
  "chat.conversation_current_shampoo_refill_description2_modal": "지금 리필하면 매끄럽게 이어갈 수 있어요.",
  "chat.conversation_current_super_shampoo_refill_description3_modal": "매직 포션의 기간 연장 없이 즉시 충전만 이루어지는 상품이에요.",
  "chat.conversation_current_hyper_shampoo_refill_description3_modal": "드림 포션의 기간 연장 없이 즉시 충전만 이루어지는 상품이에요.",
  "chat.conversation_current_shampoo_refill_description5_modal": "현재 이용권의 최대 글자 수를 초과했어요.",
  "chat.conversation_current_shampoo_refill_description6_modal": "현재 이용권으로는 최대 <strong>{{string_textCount}}자</strong>까지 밖에 적용되지 않아요.<br/>이용권을 구매하시거나 유저노트의 글자 수를 조정해주세요.",
  "chat.conversation_current_shampoo_refill_description7_modal": "현재 이용권으로는 최대 <strong>{{string_textCount}}자</strong>까지 밖에 적용되지 않아요.<br/>이용권을 구매하시거나 페르소나의 글자 수를 조정해주세요.",
  "chat.conversation_current_shampoo_refill_description8_modal": "포션이 소진되어 사용 가능한 글자 수가 줄어들었어요.",
  "chat.conversation_current_shampoo_refill_description9_modal": "현재 상태에서는 최대 {{string_textCount}}자까지 밖에 적용되지 않아요.<br/>포션을 리필하시거나 유저노트의 글자 수를 조정해주세요.",
  "chat.conversation_current_shampoo_refill_description10_modal": "현재 상태에서는 최대 {{string_textCount}}자까지 밖에 적용되지 않아요.<br/>포션을 리필하시거나 페르소나의 글자 수를 조정해주세요.",
  "chat.conversation_current_shampoo_refill_description11_modal": "사용 중인 페르소나와 유저노트가 정상적으로 반영되지 않을 수 있어요.",
  "chat.conversation_expired_ai_model_change_modal": "해당 모델의 서비스가 종료되었습니다.<br/>다른 모델을 선택해 주세요.",
  "chat.conversation_ai_model_change_modal": "대화방에서 사용 중인 모델의<br/>서비스가 종료되었습니다.",
  "chat.conversation_ai_model_change_description_modal": "우측 상단 아이콘 클릭 후,<br/>‘사용 중인 AI 모델’을 변경해 주세요.",
  "chat.conversation_ai_model_change_alert_toast": "서비스가 종료된 모델이에요.<br/>‘사용 중인 AI 모델’을 변경해 주세요.",
  "chat.conversation_ai_model_pass_modal_title": "포션 업그레이드가 필요합니다",
  "chat.conversation_ai_model_pass_modal_description1": "현재 이용권으로는 선택하신 모델을 사용할 수 없습니다.",
  "chat.conversation_ai_model_pass_modal_description2": "이용권을 구매하고 더욱 다양한 모델로 대화를 나눠보세요.",
  "chat.conversation_ai_model_pass_modal_back_button": "돌아가기",
  "chat.conversation_ai_model_change_modal2_title": "현재 이용권의 상태로 이용할 수 없는 모델이에요.",
  "chat.conversation_ai_model_change_modal2_description": "우측 상단 아이콘 클릭 후, ‘사용 중인 AI 모델’을 변경해주세요.",
  "chat.conversation_ai_model_change_alert_toast2": "현재 이용권의 상태로 이용할 수 없는 모델이에요.<br/>‘사용 중인 AI 모델’을 변경해 주세요.",
  "chat.conversation_image_unlock_popup_message": "새로운 이미지를 획득하셨습니다!",
  "chat.conversation_delete_alert_message": "정말로 메시지를 삭제하시겠어요?",
  "chat.conversation_delete_alert_message_cancel": "취소",
  "chat.conversation_delete_alert_message_delete": "삭제",
  "chat.conversation_delete_message": "메시지가 삭제됐어요.",
  "chat.conversation_text_input_limit_message": "메시지는 최대 2000자까지 입력할 수 있어요.",
  "chat.conversation_send_message_fail_message": "메시지 전송에 실패했어요.",
  "chat.conversation_edit_message_fail_message": "메시지 수정에 실패했어요.",
  "chat.conversation_delete_message_fail_message": "메시지 삭제에 실패했어요.",
  "chat.conversation_send_message_fallback_message": "메시지 수신에 실패했습니다.<br/>대화방에 재진입 해주세요.",
  "chat.conversation_edit_message_latest_message": "최신 메시지만 수정이 가능합니다.",
  "chat.conversation_delete_message_latest_message": "최신 메시지만 삭제가 가능합니다.",
  "chat.conversation_reroll_message_latest_message": "최신 메시지만 리롤이 가능합니다.",
  "chat.conversation_new_chat_deleted_character": "삭제된 캐릭터가 포함되어 있어 대화를 할 수 없어요.",
  "chat.conversation_new_chat_deleted_universe": "삭제된 서사가 포함되어 있어 대화를 할 수 없어요.",
  "chat.conversation_new_chat_deleted_scene": "삭제된 테마가 포함되어 있어 대화를 할 수 없어요.",
  "chat.conversation_load_fail_message": "대화를 불러오는데 실패했어요.",
  "chat.conversation_action": "지문",
  "chat.conversation_image_alert_deleted": "삭제된 이미지입니다.",
  "chat.conversation_image_alert_failed_pin": "이미지 고정에 실패했어요.",
  "chat.conversation_select_model": "모델을 선택해 주세요",
  "chat.conversation_chat_title": "대화창",
  "chat.conversation_alert_animated_image": "해당 브라우저에서는 움직이는 이미지 재생이 지원되지 않습니다.",
  "chat.conversation_alert_load_persona_failed": "페르소나 정보를 불러오는데 실패했어요.",
  "chat.conversation_select_persona": "페르소나를 선택해 주세요",
  "chat.conversation_failed_load_message": "메시지를 불러오는데 실패했어요.",
  "chat.conversation_copied_toast": "복사되었습니다.",
  "chat.conversation_sidebar_ai_model": "사용 중인 AI 모델",
  "chat.conversation_sidebar_my_persona": "내 페르소나",
  "chat.conversation_sidebar_character": "캐릭터",
  "chat.conversation_sidebar_universe": "서사",
  "chat.conversation_sidebar_scene": "테마",
  "chat.conversation_sidebar_bubbles": "포인트",
  "chat.conversation_sidebar_free_charging_station": "무료 충전소",
  "chat.conversation_sidebar_next_refill": "다음 리필",
  "chat.conversation_sidebar_full_refill": "전부 리필",
  "chat.conversation_sidebar_memory": "메모리",
  "chat.conversation_sidebar_settings": "환경 설정",
  "chat.conversation_sidebar_output_settings": "출력 설정",
  "chat.conversation_modal_shampoo_refill_regular_description": "10배 빠른 리필, 10배 용량! 매직 포션으로 업그레이드하세요!",
  "chat.conversation_modal_shampoo_refill_title": "리필까지 남은 시간",
  "chat.conversation_modal_shampoo_refill_count": "남은 시간",
  "chat.conversation_modal_shampoo_refill_count_day": "{{int_numbers}}일",
  "chat.conversation_modal_shampoo_refill_count_hour": "{{int_numbers}}시간",
  "chat.conversation_modal_shampoo_refill_count_minute": "{{int_numbers}}분",
  "chat.conversation_modal_shampoo_refill_count_second": "{{int_numbers}}초",
  "chat.conversation_modal_tag_first_buy": "1회 한정",
  "chat.conversation_modal_tag_n_buy": "{{int_numbers}}회 한정",
  "chat.conversation_modal_topup_button": "충전소 바로가기",
  "chat.conversation_modal_Hold_on": "잠깐만요!",
  "chat.conversation_sidebar_long_term_memory": "장기기억",
  "chat.conversation_long_term_memory_title": "장기기억",
  "chat.conversation_long_term_memory_auto_summary": "자동 요약",
  "chat.conversation_long_term_memory_content_label": "내용",
  "chat.conversation_long_term_memory_content_placeholder": "캐릭터가 기억했으면 하는 내용을 입력해주세요",
  "chat.conversation_long_term_memory_history_button": "히스토리",
  "chat.conversation_long_term_memory_ok_button": "확인",
  "chat.conversation_long_term_memory_history_title": "이전 기억들을 확인하고 불러올 수 있어요",
  "chat.conversation_long_term_memory_history_latest": "최신순",
  "chat.conversation_long_term_memory_history_earliest": "오래된 순",
  "chat.conversation_long_term_memory_history_back": "나가기",
  "chat.conversation_long_term_memory_history_save": "저장",
  "chat.conversation_long_term_memory_history_empty": "저장된 기억 히스토리가 없습니다.",
  "chat.conversation_long_term_memory_edit_content": "내용",
  "chat.conversation_long_term_memory_failed_delete": "삭제가 완료되지 않았습니다. 잠시 후 다시 시도해 주세요.",
  "chat.conversation_long_term_memory_delete": "삭제",
  "chat.conversation_long_term_memory_cancel": "취소",
  "chat.conversation_long_term_memory_edit_title": "장기기억 수정",
  "chat.conversation_long_term_memory_failed_save": "저장에 실패했어요.",
  "chat.conversation_long_term_memory_select_history": "항목 선택",
  "chat.conversation_long_term_memory_setting": "설정",
  "chat.conversation_long_term_memory_next_summary_in": "다음 요약까지",
  "chat.conversation_long_term_memory_turn_zero": "턴",
  "chat.conversation_long_term_memory_turn_one": "턴",
  "chat.conversation_long_term_memory_turn_other": "턴",
  "chat.conversation_long_term_memory_summary_settings": "요약 설정",
  "chat.conversation_long_term_memory_summary_frequency": "요약 주기",
  "chat.conversation_long_term_memory_character_limit": "글자 수 제한",
  "chat.conversation_long_term_memory_characters": "자",
  "chat.conversation_long_term_memory_character_limit_description": "요약된 내용이 글자 수 제한에 도달하면 전체 기억이 압축되어 저장되고 히스토리가 생성됩니다.",
  "chat.conversation_long_term_memory_summary_prompt_title": "요약 프롬프트",
  "chat.conversation_long_term_memory_character_auto_button": "자동",
  "chat.conversation_long_term_memory_character_custom_button": "직접 입력",
  "chat.conversation_long_term_memory_character_custom_description": "*설정된 내용은 모든 대화방에 일괄적으로 적용됩니다.",
  "chat.conversation_long_term_memory_auto_summary_toast": "요약 내용은 누적으로 저장되며, 일정 글자 수에 도달하면 자동으로 압축돼요.",
  "chat.conversation_long_term_memory_replace_history_alert": "기존 내용이 선택된 히스토리로 변경됩니다. 적용하시겠어요?",
  "chat.conversation_long_term_memory_apply_button": "적용",
  "chat.conversation_long_term_memory_unsaved_alert_message": "저장되지 않은 수정사항이 있어요. 그래도 이동하시겠어요?",
  "chat.conversation_long_term_memory_apply_failed_toast": "적용 중 문제가 발생했어요. 다시 시도해 주세요.",
  "chat.conversation_output_environment_title": "출력 설정",
  "chat.conversation_output_environment_control_memory_title": "기억력 조절",
  "chat.conversation_output_environment_control_max_output_title": "최대 출력량 조절",
  "chat.conversation_output_environment_description1": "기억력이 올라갈수록 소모되는 재화의 양이 많아집니다.",
  "chat.conversation_output_environment_description2": "기억력 설정이 장기기억의 요약 주기보다 짧으면 중요한 대화를 잊을 수 있습니다. 같거나 더 길게 설정하는 것을 권장해요.",
  "chat.conversation_output_environment_description3": "출력량이 늘어날수록 소모되는 재화의 양이 많아집니다.",
  "chat.conversation_output_environment_description4": "변경된 설정은 다음 출력부터 적용됩니다.",
  "chat.conversation_output_environment_description5": "설정된 내용은 모든 대화방에 일괄적으로 적용됩니다.",
  "chat.conversation_output_environment_save_modal_title": "변경된 내용을 저장하시겠어요?",
  "chat.conversation_output_environment_save_modal_description": "변경사항은 모든 대화방에 적용됩니다.",
  "chat.conversation_chat_settings_image_display": "이미지 뷰어",
  "chat.conversation_chat_settings_image_display_text": "텍스트",
  "chat.conversation_image_unlock_locked_image": "비공개 이미지예요",
  "chat.conversation_image_unlock_with_bubbles": "포인트로 해금하기",
  "chat.conversation_image_unlock_no_with_bubbles": "포인트로 해금 불가",
  "chat.conversation_image_unlock_image_title": "이미지 해금하기",
  "chat.conversation_image_unlock_your_bubbles": "보유 포인트",
  "chat.conversation_image_unlock_unlocked_image": "해금된 이미지",
  "chat.conversation_image_unlock_unlockable_image": "해금 가능",
  "chat.conversation_image_unlock_no_bubble_unlock": "해금 불가",
  "chat.conversation_image_unlock_selected_image": "선택한 이미지",
  "chat.conversation_image_unlock_all_unlockable_image": "해금 가능한 모든 이미지",
  "chat.conversation_image_unlock_refund_bubble_description": "이미지 해금에 사용된 포인트는 환불이 불가합니다.",
  "chat.conversation_image_unlock_not_enough_bubbles": "포인트가 부족해서<br/>이미지를 해금할 수 없어요.",
  "chat.conversation_image_unlock_top_up_bubbles": "포인트 충전 후 이미지를 해금해 보세요.",
  "chat.conversation_image_unlock_current_bubbles": "현재 포인트",
  "chat.conversation_image_unlock_required_bubbles": "해금에 필요한 포인트",
  "chat.conversation_image_unlock_missing_bubbles": "부족한 포인트",
  "chat.conversation_image_unlock_cancel_button": "닫기",
  "chat.conversation_image_unlock_top_up_button": "충전하러 가기",
  "chat.conversation_image_unlock_failed": "이미지 해금에 실패하였습니다.",
  "chat.conversation_image_unlock_failed_description": "다시 시도해주세요.",
  "chat.conversation_image_unlock_failed_button": "확인",
  "chat.conversation_image_unlock_already_unlocked": "이미 해금한 이미지입니다.",
  "chat.conversation_image_unlock_already_unlocked_button": "확인",
  "chat.conversation_streaming_mode_off_alert_toast": "현재 대화는 기존 채팅 모드로 제공되며<br/>타이핑 모드는 복구 중입니다.",
  "chat.conversation_streaming_mode_on_alert_toast": "타이핑 모드가 다시 활성화 되었습니다.",
  "chat.conversation_markdown_mode_on_alert_toast": "마크다운 사용이 활성화되었습니다.",
  "chat.conversation_markdown_mode_off_alert_toast": "마크다운이 비활성화 되었으며 복구 중입니다.",
  "chat.conversation_message_send_error_alert_toast": "메시지 수신에 실패했습니다.<br/>포인트는 차감되지 않았어요.",
  "chat.conversation_streaming_message_error_alert_toast": "요청을 처리하는 중 문제가 발생했어요.<br/>잠시 후 다시 시도해 주세요.",
  "chat.conversation_prohibited_content_error_toast": "AI 모델이 응답 생성을 거부했습니다. 포인트/포션은 차감되지 않으며, 차감된 경우 고객센터로 문의해 주세요.",
  "chat.conversation_prohibited_content_no_charge_toast": "AI 콘텐츠 필터로 인해 메시지 수신에 실패했습니다. 포인트/포션은 차감되지 않습니다.",
  "chat.conversation_chat_new_conversation_button": "새로 대화하기",
  "chat.conversation_chat_new_conversation_modal_select_title": "도입부 선택",
  "chat.conversation_chat_new_conversation_modal_start_conversation_button": "대화하기",
  "chat.conversation_chat_copy_button": "대화방 복사하기",
  "chat.conversation_chat_copied_toast": "대화방이 최근 대화 목록에 복사되었습니다.",
  "chat.conversation_chat_copied_failed_toast": "대화방 복사에 실패했습니다.",
  "chat.conversation_reconnect_toast": "새 응답이 표시되지 않는다면 네트워크 연결을 확인하고 다시 입장해 주세요.",
  "chat.conversation_limit_toast": "포션이 모두 소진되어 유저노트와 페르소나의 적용 범위가 제한될 수 있습니다.",
  "chat.conversation_usernote_limit_toast": "포션이 모두 소진되어 유저노트의 적용 범위가 제한됩니다.(최대 500자)",
  "chat.conversation_persona_limit_toast": "포션이 모두 소진되어 페르소나의 적용 범위가 제한됩니다. (최대 250자)",
  "chat.conversation_bookmark": "북마크",
  "chat.conversation_bookmark_number": "북마크 {{int_numbers}}",
  "chat.conversation_bookmark_button": "대화로 이동하기",
  "chat.conversation_bookmark_add_title": "북마크 추가",
  "chat.conversation_bookmark_edit_title": "북마크 수정",
  "chat.conversation_bookmark_note": "메모",
  "chat.conversation_bookmark_note_placeholder": "자유롭게 입력해주세요.",
  "chat.conversation_bookmark_note_description": "* 작성된 내용은 대화에 영향을 미치지 않습니다.",
  "chat.conversation_bookmark_empty": "저장된 북마크가 없습니다.",
  "chat.conversation_bookmark_no_content": "리롤 혹은 삭제로 인해 존재하지 않는 내용입니다.",
  "chat.conversation_bookmark_delete_success": "북마크가 삭제되었습니다.",
  "chat.conversation_bookmark_delete_failed": "북마크 삭제에 실패했습니다.",
  "chat.conversation_bookmark_edit_success": "북마크가 수정되었습니다.",
  "chat.conversation_bookmark_edit_failed": "북마크 수정에 실패했습니다.",
  "chat.conversation_export_as_txt": "TXT 내보내기",
  "chat.conversation_export_as_txt_modal_description": "대화 내용 전체를 텍스트 파일로 추출하시겠습니까?",
  "chat.conversation_sidebar_extra_settings": "추가 설정",
  "chat.conversation_extra_settings_mask_my_name": "내 이름 가리기",
  "chat.conversation_mask_my_name_user": "유저",
  "chat.custom_modal_preview_character_dialogue": "캐릭터의 대사입니다.",
  "chat.custom_modal_preview_character_dialogue_mask_on": "당신을 유저로 부르고 있어요.",
  "chat.custom_modal_preview_character_dialogue_mask_off": "당신을 {{user}}로 부르고 있어요.",
  "chat.custom_modal_preview_character_narration": "캐릭터의 지문입니다.",
  "chat.custom_modal_preview_user_dialogue": "유저의 대사입니다.",
  "chat.custom_modal_preview_user_narration": "유저의 지문입니다.",
  "chat.custom_modal_viewer_settings": "뷰어 설정",
  "chat.custom_modal_viewer": "뷰어",
  "chat.custom_modal_viewer_background": "배경",
  "chat.custom_modal_transparency": "투명도",
  "chat.custom_modal_text_settings": "텍스트 설정",
  "chat.custom_modal_text_size": "크기",
  "chat.custom_modal_color_settings": "색상 설정",
  "chat.custom_modal_color_settings_reset_button": "초기화",
  "chat.custom_modal_preset_button": "프리셋",
  "chat.custom_modal_custom_button": "직접 지정",
  "chat.custom_modal_theme_dark": "다크",
  "chat.custom_modal_theme_light": "라이트",
  "chat.custom_modal_theme_default": "팅글",
  "chat.custom_modal_label_character_dialogue": "캐릭터 대사",
  "chat.custom_modal_label_user_dialogue": "유저 대사",
  "chat.custom_modal_label_character_narration": "캐릭터 지문",
  "chat.custom_modal_label_user_narration": "유저 지문",
  "chat.custom_modal_label_character_bubble": "캐릭터 말풍선",
  "chat.custom_modal_label_user_bubble": "유저 말풍선",
  "chat.custom_modal_color_picker_recent_colors": "최근 색상",
  "chat.custom_modal_color_picker_default_custom_button": "기본",
  "chat.custom_modal_color_picker_custom_button": "직접 지정",
  "chat.custom_modal_apply_chat_all_alert_title": "변경사항은 대화형 대화방에만 적용돼요",
  "chat.custom_modal_apply_story_all_alert_title": "변경사항은 소설형 대화방에만 적용돼요",
  "chat.custom_modal_apply_all_alert_description": "그래도 저장하시겠어요?",
  "chat.custom_modal_unsaved_alert_title": "저장되지 않은 수정사항이 있어요.",
  "chat.custom_modal_unsaved_alert_description": "그래도 종료하시겠어요?",
  "chat.custom_modal_reset_alert_title": "색상값이 모두 초기화돼요",
  "chat.custom_modal_reset_alert_description": "그래도 계속하시겠어요?",
  "chat.conversation_suggested_messages_title": "추천 메시지",
  "chat.conversation_suggested_messages_description": "캐릭터에게 보낼 메시지를 선택해보세요",
  "chat.message_card_title": "메시지 카드",
  "chat.message_card_select_message_deselect": "선택 해제",
  "chat.message_export_title": "대화 내보내기",
  "chat.message_card_select_message": "메시지 선택",
  "chat.message_card_private_unavailable": "비공개 캐릭터로 생성한 대화방은 메시지 카드를 제작할 수 없습니다.",
  "chat.message_card_select_text_guide": "메시지 카드에 넣을 문구를 선택하세요.",
  "chat.message_card_edit": "메시지 카드 편집",
  "chat.message_card_card_design": "카드 디자인",
  "chat.message_card_style": "스타일",
  "chat.message_card_bg_background": "배경",
  "chat.message_card_bg_cutscene": "컷씬",
  "chat.message_card_bg_text": "텍스트",
  "chat.message_card_ratio": "비율",
  "chat.message_card_ratio_portrait": "세로형",
  "chat.message_card_ratio_landscape": "가로형",
  "chat.message_card_ratio_square": "정방형",
  "chat.message_card_image": "이미지",
  "chat.message_card_edit_text": "텍스트 편집",
  "chat.message_card_save_success": "메시지 카드가 기기에 저장되었습니다.",
  "chat.message_card_save_failed": "메시지 카드 저장에 실패했습니다. 다시 시도해주세요.",
  "chat.nsfw_character_not_available_toast_message": "팅글모드 캐릭터는 앱에서 이용할 수 없습니다.",
  "chat.nsfw_universe_not_available_toast_message": "팅글모드 서사는 앱에서 이용할 수 없습니다.",
  "chat.nsfw_scene_not_available_toast_message": "팅글모드 테마는 앱에서 이용할 수 없습니다.",
  "payment.charging_station_title": "스토어",
  "payment.charging_station_shampoo": "포션",
  "payment.charging_station_paid_bubble": "포인트",
  "payment.charging_station_free_bubble": "무료 충전",
  "payment.charging_station_pass": "이용권",
  "payment.page_topup": "충전하기",
  "payment.page_history": "이용내역",
  "payment.page_topup_history": "충전내역",
  "payment.page_topup_history_earned": "충전/지급",
  "payment.page_topup_history_used": "사용",
  "payment.page_topup_balance": "보유현황",
  "payment.page_topup_expiry_date": "만료일",
  "payment.page_topup_remaining": "잔여 포인트",
  "payment.charging_station_toast_success": "구매가 완료되었습니다.",
  "payment.charging_station_toast_failed": "결제에 실패했어요. 다시 시도해 주세요.",
  "payment.charging_station_shampoo_purchase_modal": "매직 포션을<br/>구매하시겠어요?",
  "payment.charging_station_super_shampoo_menu_title": "매직 포션 구매",
  "payment.charging_station_hyper_shampoo_menu_title": "드림 포션 구매",
  "payment.charging_station_shampoo_menu_your_bubbles": "보유 포인트",
  "payment.charging_station_shampoo_super_shampoo": "매직 포션",
  "payment.charging_station_shampoo_days_zero": "{{int_days}}일",
  "payment.charging_station_shampoo_days_one": "{{int_days}}일",
  "payment.charging_station_shampoo_days_other": "{{int_days}}일",
  "payment.charging_station_shampoo_hours_zero": "{{int_hours}}시간",
  "payment.charging_station_shampoo_hours_one": "{{int_hours}}시간",
  "payment.charging_station_shampoo_hours_other": "{{int_hours}}시간",
  "payment.charging_station_shampoo_purchase_complete": "구매가 완료되었습니다!",
  "payment.charging_station_shampoo_purchase_ok": "확인",
  "payment.charging_station_shampoo_not_enough_bubbles_title": "포인트가 부족해서<br/>포션을 구매할 수 없어요.",
  "payment.charging_station_shampoo_not_enough_bubbles_description": "포인트 충전 후 포션을 구매해 보세요.",
  "payment.charging_station_shampoo_modal_your_bubbles": "현재 포인트",
  "payment.charging_station_shampoo_modal_required": "구매에 필요한 포인트",
  "payment.charging_station_shampoo_modal_missing": "부족한 포인트",
  "payment.charging_station_shampoo_modal_cancel": "닫기",
  "payment.charging_station_shampoo_modal_topup": "충전하러 가기",
  "payment.charging_station_shampoo_purchase_failed_title": "구매에 실패하였습니다.",
  "payment.charging_station_shampoo_purchase_failed_description": "다시 시도해주세요.",
  "payment.charging_station_shampoo_modal_account_verification": "본인인증 후<br/>구매할 수  있는 상품이에요",
  "payment.charging_station_shampoo_modal_verify": "본인인증 하기",
  "payment.charging_station_shampoo_modal_already_in_use": "이미 포션을 사용중이에요!",
  "payment.charging_station_shampoo_modal_already_in_use_description1": "이용기간 중 일부를 소진하여<br/>포션을 바로 완충할 수 있어요!<br/>충전하시겠어요?",
  "payment.charging_station_shampoo_modal_already_in_use_description2": "* 완충하기를 선택한 포션은<br/>추후 환불이 어려울 수 있습니다.",
  "payment.charging_station_shampoo_modal_already_in_use_cancel": "아니오",
  "payment.charging_station_shampoo_modal_already_in_use_recharge": "완충하기",
  "payment.charging_station_shampoo_pass_info": "현재 이용권 정보",
  "payment.charging_station_shampoo_purchase_pass": "이용권 구매",
  "payment.charging_station_shampoo_pass_description1": "일반 포션 {{int_value}}배 용량",
  "payment.charging_station_shampoo_pass_description2": "페르소나 {{string_textCount}}자",
  "payment.charging_station_shampoo_pass_description3": "유저노트 {{string_textCount}}자",
  "payment.charging_station_shampoo_tooltip_title1": "✅ 포션이란?",
  "payment.charging_station_shampoo_tooltip_description1": "팅글은 매일 일정량의 무료채팅을 제공합니다.",
  "payment.charging_station_shampoo_tooltip_description2": "무료 채팅량을 시각적으로 나타내주는 아이콘을 ‘포션’이라고 부릅니다.",
  "payment.charging_station_shampoo_tooltip_description3": "최초 채팅 시작 시간을 기준으로 6시간마다 25%씩 충전됩니다.",
  "payment.charging_station_shampoo_tooltip_title2": "📌 참고해 주세요!",
  "payment.charging_station_shampoo_tooltip_description4": "포션 종류에 따라 소진되는 속도가 다릅니다.",
  "payment.charging_station_shampoo_tooltip_description5": "대화방 스타일과 AI모델에 따라 포션의 소모량이 다를 수 있습니다.",
  "payment.charging_station_shampoo_tooltip_description6": "프롬프트의 양, 채팅 입력량 및 출력량에 따라 차감되는 정도가 다를 수 있습니다.",
  "payment.charging_station_shampoo_tooltip_title3": "✅ 이용권 안내",
  "payment.charging_station_shampoo_tooltip_description7": "매직 포션",
  "payment.charging_station_shampoo_tooltip_description8": "매직 포션은 일반 포션보다 {{int_value}}배 더 많이 대화할 수 있는 상품입니다.",
  "payment.charging_station_shampoo_tooltip_description9": "매직 포션 이용 기간 중에는 리필 상품과 유저노트, 페르소나의 확장 기능을 이용할 수 있습니다.",
  "payment.charging_station_shampoo_tooltip_description10": "드림 포션",
  "payment.charging_station_shampoo_tooltip_description11": "드림 포션은 일반 포션보다 {{int_value}}배 더 많이 대화할 수 있는 상품입니다.",
  "payment.charging_station_shampoo_tooltip_description12": "드림 포션 이용 기간 중에는 추가된 리필 상품과 더욱 강력해진 유저노트, 페르소나 확장 기능을 이용할 수 있습니다.",
  "payment.charging_station_shampoo_tooltip_description13": "이용권 추가 구매 시 현재 이용권의 잔량은 리필되지 않습니다.",
  "payment.charging_station_shampoo_tooltip_description14": "잔량을 채워야 할 경우 반드시 리필을 구매하세요.",
  "payment.charging_station_shampoo_tooltip_description15": "리필 상품은 포션이 {{int_number}}% 미만으로 떨어지게 될 경우, 스토어와 대화방에서 확인할 수 있습니다.",
  "payment.footer_msg_0": "서비스 정보",
  "payment.footer_msg_1": "충전된 포인트의 유효기간은 충전 후 1년입니다.",
  "payment.footer_msg_2": "사용되지 않은 포인트에 대해서는 7일 이내 청약철회가 가능합니다.",
  "payment.footer_msg_3": "포인트를 사용한 이후 환불할 수 없으며, 부정하게 환불받은 경우 사전 동의 없이 회원이 보유한 재화를 회수할 수 있고, 계정 이용을 정지당할 수 있습니다.",
  "payment.footer_msg_4": "이벤트나 프로모션 등으로 지급된 무료 재화는 환불받을 수 없으며 유효기간은 지급 후 6개월 이내입니다.",
  "payment.footer_msg_5": "리워드로 지급된 유료 재화는 환불받을 수 없습니다.",
  "payment.footer_msg_6": "프로모션 상품은 환불 시 재구매가 어려울 수 있습니다.",
  "payment.footer_msg_7": "자세한 사항은 팅글 이용약관에서 확인할 수 있습니다.",
  "payment.footer_msg_8": "궁금하신 사항은 <link1>고객센터 문의하기 </link1>로 문의해 주세요.",
  "payment.footer_msg_9": "휴대폰결제의 경우 당월 결제 시 당월 취소 및 본인 계좌로만 환불됩니다.",
  "payment.footer_exchange_rate_msg_bt_6_7_except_kr": "위 상품 가격표는 환율 변동에 따라 조정될 수 있습니다.",
  "payment.shampoo_footer_msg_0": "서비스 정보 - 유료 포션 이용권",
  "payment.shampoo_footer_msg_1": "상품 안내",
  "payment.shampoo_footer_msg_2": "매직 포션 이용권은 구매 즉시 사용 가능한 디지털 상품으로, 3일/7일권 각각 유효기간이 적용됩니다.",
  "payment.shampoo_footer_msg_3": "이용권 활성화는 결제 완료 시점부터 자동으로 시작되며, 유효기간 내 이용 가능합니다.",
  "payment.shampoo_footer_msg_4": "초회권은 본인인증된 계정에 한해 구매 가능하며, 본인 명의 당 1회만 구매 가능합니다.",
  "payment.shampoo_footer_msg_5": "환불 정책",
  "payment.shampoo_footer_msg_6": "매직 포션 구매 후 잔량 차감이 전혀 없는 경우에 한해 청약 철회가 가능합니다.",
  "payment.shampoo_footer_msg_7": "매직 포션 이용 중 추가 구매한 이용권은 해당 추가 구매분의 유효 기간이 차감되기 전까지 청약 철회가 가능합니다.",
  "payment.shampoo_footer_msg_8": "시스템 오류로 정상 이용이 불가능한 경우, 고객센터 문의하기를 통해 문제 해결 및 보상을 받으실 수 있습니다.",
  "payment.shampoo_footer_msg_9": "유의 사항",
  "payment.shampoo_footer_msg_10": "이벤트로 지급된 무료 이용권 및 할인 프로모션 상품은 환불 대상에서 제외됩니다.",
  "payment.shampoo_footer_msg_11": "부당한 방법으로 환불을 시도하거나 이용권을 남용할 경우, 사전 고지 없이 재화 회수 및 계정 이용이 제한될 수 있습니다.\n",
  "payment.shampoo_footer_msg_12": "프로모션 상품은 환불 후 동일 조건으로 재구매가 제한될 수 있으니 신중한 구매를 부탁드립니다.",
  "payment.shampoo_footer_msg_13": "반복적인 구매-환불 패턴이 감지될 경우 어뷰징으로 간주되어 계정 이용이 제한될 수 있습니다.",
  "payment.shampoo_footer_msg_14": "탈퇴 후 재가입을 통한 중복 혜택 수령은 시스템에 의해 감지되며, 이용 제한 조치가 적용될 수 있습니다",
  "payment.shampoo_footer_msg_15": "매직 포션 리필은 상품의 기간 연장 없이 즉시 충전만 이루어지는 상품입니다.",
  "payment.shampoo_footer_msg_16": "매직 포션 상태에서 매직 포션 추가 구매 시 잔량 충전 없이 유효기간만 연장됩니다.",
  "payment.shampoo_footer_msg_17": "매직 포션에서 드림 포션으로 업그레이드 시, 매직 포션의 남은 기간은 5:1 비율로 환산되어 드림 포션 기간에 추가됩니다.",
  "payment.shampoo_footer_msg_18": "리필 상품은 매직 포션을 구매한 이용자만 구매할 수 있습니다.",
  "payment.shampoo_footer_msg_19": "이외 기타 문의사항은 고객센터 문의하기를 이용해주세요.",
  "payment.shampoo_footer_msg_20": "매직 포션의 퍼센티지가 0% 미만일 경우, 글자 수는 기존 250자(페르소나)·500자(유저노트)까지만 적용됩니다.",
  "payment.shampoo_footer_msg_21": "휴대폰결제의 경우 당월 결제 시 당월 취소 및 본인 계좌로만 환불됩니다.",
  "payment.history_bubblechat": "팅글",
  "payment.history_unlock_image": "이미지 해금",
  "payment.history_payment": "결제",
  "payment.history_referrer_registration": "추천인 등록",
  "payment.history_payment_no_record": "유료구매한 내역이 없어요",
  "payment.history_used_no_record": "내역이 없어요.",
  "payment.failed_button_description": "결제 페이지로 돌아가기",
  "payment.super_shampoo_refill_expired_message_modal": "매직 포션의 사용 기한이 만료되어<br/>리필에 실패했습니다.",
  "payment.super_shampoo_refill_expired_description_modal": "매직 포션을 구매해보세요.",
  "payment.super_shampoo_refill_expired_message_modal_button": "매직 포션 구매하기",
  "payment.super_shampoo_refill_message_modal": "매직 포션 리필",
  "payment.super_shampoo_refill_description1_modal": "매직 포션의 사용 기한이 지나면<br/>다 못 쓴 분량은 사라져요.",
  "payment.super_shampoo_refill_description2_modal": "그래도 리필하시겠어요?",
  "payment.hyper_shampoo_refill_expired_message_modal": "드림 포션의 사용 기한이 만료되어<br/>리필에 실패했습니다.",
  "payment.hyper_shampoo_refill_expired_description_modal": "드림 포션을 구매해보세요.",
  "payment.hyper_shampoo_refill_expired_message_modal_button": "드림 포션 구매하기",
  "payment.hyper_shampoo_refill_message_modal": "드림 포션 리필",
  "payment.hyper_shampoo_refill_description1_modal": "드림 포션의 사용 기한이 지나면<br/>다 못 쓴 분량은 사라져요.",
  "payment.shampoo_refill_message_modal_button": "포션 리필하기",
  "payment.shampoo_refill_complete_message_modal": "포션 리필 완료!",
  "payment.shampoo_refill_complete_description1_modal": "포션이 리필되었어요. 대화를 이어가보세요!",
  "payment.shampoo_refill_failed_message_modal": "포인트가 부족해서<br/>포션을 리필할 수 없어요.",
  "payment.shampoo_refill_failed_description1_modal": "리필에 필요한 포인트",
  "payment.payletter_modal_title": "결제하기",
  "payment.payletter_modal_selected_item": "선택한 상품",
  "payment.payletter_modal_payment_method": "결제수단",
  "payment.payletter_modal_card_button": "신용·체크카드",
  "payment.payletter_modal_transfer_button": "실시간 계좌이체",
  "payment.payletter_modal_billing_button": "휴대폰 결제",
  "payment.payletter_modal_pay_button": "결제하기",
  "payment.payletter_modal_success_title": "결제 성공",
  "payment.payletter_modal_success_description": "결제가 완료되었어요.",
  "payment.payletter_modal_fail_title": "결제 실패",
  "payment.payletter_modal_fail_description": "결제에 실패했습니다.",
  "payment.payletter_modal_fail_description_sub": "다시 시도해 주세요.",
  "payment.ad_free_modal_title": "광고 제거하고 더욱 몰입감 높은 서사를 이어가세요",
  "payment.ad_free_product_name": "위브 플러스",
  "payment.ad_free_product_price_subscription": "월 / {{string_N}}",
  "payment.ad_free_product_price_1day": "1일 / {{string_N}}",
  "payment.ad_free_product_price_30days": "30일 / {{string_N}}",
  "payment.ad_free_modal_description1": "광고 제거",
  "payment.ad_free_modal_description2": "더욱 빨라진 답변 속도",
  "payment.ad_free_modal_description3": "더욱 늘어난 출력량",
  "payment.ad_free_modal_description4": "유저노트 제공",
  "payment.ad_free_modal_description5": "{{int_number}} 포인트 지급",
  "payment.ad_free_modal_description_inactived": "웹 결제는 준비 중이에요.<br/>지금은 앱에서 구매하실 수 있어요.<br/>앱 → 스토어 → 이용권",
  "payment.ad_free_modal_description_inactived_button": "앱에서 구매하기",
  "payment.ad_free_product_name_subscription": "정기 구독",
  "payment.ad_free_product_name_day": "1일",
  "payment.ad_free_product_recommended_web_top_up_title": "웹에서는 정기구독이 월 / {{int_number}}",
  "payment.ad_free_product_recommended_web_top_up_title2": "웹에서 더욱 저렴하게, ₩1,500 부터",
  "payment.ad_free_product_recommended_web_top_up_button": "바로가기",
  "payment.ad_free_product_purchase": "구매하기",
  "payment.ad_free_product_price_day2": "{{int_number}}으로 위브 플러스 하루 체험",
  "payment.ad_free_modal_description6": "1일권은 포인트가 지급되지 않아요.",
  "payment.ad_free_urchase_modal_title1": "{{string_productName}}을 구매할까요?",
  "payment.ad_free_urchase_modal_title_completed": "{{string_productName}} 구매가 완료되었습니다!",
  "payment.ad_free_urchase_modal_title_failed": "{{string_productName}} 구매에 실패하였습니다.",
  "payment.ad_free_chatroom_banner_title": "방해없이 대화에 몰입하고 싶다면?",
  "payment.ad_free_chatroom_banner_remove_Ads": "광고 제거하기",
  "payment.ad_free_product_infomation_subscription_date": "결제 예정일",
  "payment.ad_free_product_infomation_subscription": "구독 중",
  "payment.ad_free_product_infomation_subscribe": "구독하기",
  "payment.ad_free_product_infomation_cancellation_date": "해지 예정일",
  "payment.ad_free_product_infomation_cancellation": "해지 예정",
  "payment.ad_free_product_infomation_undo_cancellation": "구독 해지 철회",
  "payment.ad_free_product_infomation_cancel_Subscription": "구독 해지하기",
  "payment.ad_free_product_infomation_expiration_date": "사용 기한",
  "payment.ad_free_product_infomation_Inactive_pass": "이용권이 없어요",
  "payment.ad_free_cancel_subscription_error_title1": "웹 페이지에서 해지가 가능해요.",
  "payment.ad_free_cancel_subscription_error_description1": "웹: 스토어 > 이용권 > 현재 이용권 정보 > 구독 해지하기",
  "payment.ad_free_cancel_subscription_error_title2": "Play 스토어에서 해지가 가능해요.",
  "payment.ad_free_cancel_subscription_error_description2": "AOS: Play 스토어 > 프로필 > 결제 및 정기 결제 > 정기 결제 > 앱 선택 > 구독 해지하기",
  "payment.ad_free_cancel_subscription_error_title3": "앱 스토어에서 해지가 가능해요.",
  "payment.ad_free_cancel_subscription_error_description3": "iOS: 설정 > Apple ID > 구독 > 앱 선택 > 구독 해지하기",
  "payment.ad_free_resubscribe_error_title1": "구독을 다시 시작하시려면 웹 페이지에서 진행해주세요.",
  "payment.ad_free_resubscribe_error_title2": "구독을 다시 시작하시려면 앱스토어에서 진행해주세요.",
  "payment.ad_free_resubscribe_error_title3": "구독을 다시 시작하시려면 Google Play에서 진행해주세요.",
  "payment.ad_free_perchase_error_title": "이미 사용 중인 이용권이 있어요.",
  "payment.ad_free_perchase_error_description": "{{string_productName}} 종료 후 구매할 수 있어요",
  "payment.ad_free_chatroom_sidemenu_active": "이용 중",
  "payment.ad_free_footer_msg_1": "서비스 정보 - 위브 플러스 이용권",
  "payment.ad_free_footer_msg_2": "상품 안내",
  "payment.ad_free_footer_msg_3": "위브 플러스 이용권은 결제 즉시 사용 가능한 디지털 상품으로, 1일권 / 30일권 각각 유효기간(혜택 기간)이 적용됩니다.",
  "payment.ad_free_footer_msg_4": "위브 플러스 이용권은 결제 즉시 사용 가능한 디지털 상품으로, 1일권 / 정기 구독권(1개월) 각각 유효기간(혜택 기간)이 적용됩니다.",
  "payment.ad_free_footer_msg_5": "혜택은 결제 완료 시점부터 자동으로 시작되며, 유효기간 내 무료 모델 \"위브\" 이용 시 광고 제거 · 답변 속도 상승 · 출력량 상승 · 유저노트 기능을 제공합니다.",
  "payment.ad_free_footer_msg_6": "보너스 포인트는 30일권 구매 시 지급되며, 1일권에는 지급되지 않습니다.",
  "payment.ad_free_footer_msg_7": "보너스 포인트는 30일권,정기 구독권 구매 시 지급되며, 1일권에는 지급되지 않습니다.",
  "payment.ad_free_footer_msg_8": "이용권은 중복 보유할 수 없으며, 현재 이용 중인 이용권이 종료된 후 다른 이용권을 구매할 수 있습니다.",
  "payment.ad_free_footer_msg_9": "첫 구매 전용 상품은 본인인증된 계정에 한해 본인 명의당 1회만 구매할 수 있습니다.",
  "payment.ad_free_footer_msg_10": "정기 구독(1개월권) 안내",
  "payment.ad_free_footer_msg_11": "이용 요금: 월 {{int_number}}원 (부가가치세 VAT 포함)",
  "payment.ad_free_footer_msg_12": "위브 플러스 1개월권은 30일 단위로 자동 갱신되는 구독 상품으로, 해지 전까지 매 갱신 예정일에 등록하신 결제 수단으로 자동 결제됩니다.",
  "payment.ad_free_footer_msg_13": "구독은 다음 결제 예정일 전까지 언제든 해지할 수 있으며, 해지 시 남은 이용 기간까지는 혜택이 유지됩니다.",
  "payment.ad_free_footer_msg_14": "앱 내 구매 건은 구독 기간 종료 24시간 이전에 해지하지 않으면 동일 금액으로 자동 갱신·결제됩니다. 구독 관리 및 해지는 설정 > 계정 > 구독 또는 Play 스토어 > 정기 결제에서 하실 수 있습니다.",
  "payment.ad_free_footer_msg_15": "환불 정책",
  "payment.ad_free_footer_msg_16": "위브 플러스 이용권은 결제 즉시 혜택이 제공되어 그 효용이 발생하는 디지털 콘텐츠로, 「전자상거래 등에서의 소비자보호에 관한 법률」에 따라 결제 후 환불(청약철회)이 제한됩니다.",
  "payment.ad_free_footer_msg_17": "결제 후 이용권의 혜택을 전혀 사용하지 않은 경우, 즉 (1) 무료 모델을 단 한 차례도 이용하지 않아 광고 제거 혜택이 적용된 적이 없고, (2) 지급된 보너스 포인트를 전혀 사용하지 않은 경우에 한하여, 결제일로부터 7일 이내에 청약철회 및 환불을 요청하실 수 있습니다. 위 혜택 중 어느 하나라도 이용이 개시된 경우에는 콘텐츠 제공이 시작된 것으로 보아 환불이 제한됩니다.",
  "payment.ad_free_footer_msg_18": "앱 내 구매 건은 각 스토어(App Store, Google Play)의 환불 정책을 따릅니다.",
  "payment.ad_free_footer_msg_19": "시스템 오류 등으로 정상적인 이용이 불가능한 경우, 고객센터 문의하기를 통해 문제 해결을 도와드립니다.",
  "payment.ad_free_footer_msg_20": "유의 사항",
  "payment.ad_free_footer_msg_21": "이벤트로 지급된 무료 이용권 및 할인 프로모션 상품은 환불 대상에서 제외됩니다.",
  "payment.ad_free_footer_msg_22": "부당한 방법으로 환불을 시도하거나 이용권을 남용할 경우, 사전 고지 없이 재화 회수 및 계정 이용이 제한될 수 있습니다.",
  "payment.ad_free_footer_msg_23": "프로모션 상품은 환불 후 동일 조건으로 재구매가 제한될 수 있으니 신중한 구매를 부탁드립니다.",
  "payment.ad_free_footer_msg_24": "반복적인 구매-환불 패턴이 감지될 경우 어뷰징으로 간주되어 계정 이용이 제한될 수 있습니다.",
  "payment.ad_free_footer_msg_25": "탈퇴 후 재가입을 통한 중복 혜택 수령은 시스템에 의해 감지되며, 이용 제한 조치가 적용될 수 있습니다.",
  "payment.ad_free_footer_msg_26": "이외 기타 문의사항은 고객센터 문의하기로 문의해 주세요.",
  "payment.ad_watch_incomplete_toast": "광고 시청이 완료되지 않았습니다. 메시지를 다시 전송해 주세요.",
  "payment.app_only_guide_title": "결제 기능은 앱에서만 이용 가능합니다.",
  "payment.app_only_guide_description": "웹에서도 이용하실 수 있도록 빠른 시일 내에 지원할 예정입니다.",
  "chat.profile_my_title": "마이 페이지",
  "chat.profile_other_title": "제작자 페이지",
  "chat.profile_writername": "닉네임",
  "chat.profile_username": "아이디",
  "chat.profile_followers_zero": "팔로워",
  "chat.profile_followers_one": "팔로워",
  "chat.profile_followers_other": "팔로워",
  "chat.profile_my_following": "팔로잉",
  "chat.profile_my_following_modal_title": "팔로잉",
  "chat.profile_my_following_modal_description": "팔로잉을 해보세요.",
  "chat.profile_others_follow_button": "팔로우",
  "chat.profile_others_following_button": "팔로잉",
  "chat.profile_introduction": "소개글",
  "chat.profile_my_introduction_empty": "나의 소개글을 작성해보세요.",
  "chat.profile_other_introduction_empty": "등록된 소개글이 없어요.",
  "chat.profile_username_copy_message": "아이디가 복사되었습니다.",
  "chat.profile_my_personas": "페르소나",
  "chat.profile_my_personas_my_personas_zero": "내 페르소나",
  "chat.profile_my_personas_my_personas_one": "내 페르소나",
  "chat.profile_my_personas_my_personas_other": "내 페르소나",
  "chat.profile_my_personas_empty": "만든 페르소나가 없어요.",
  "chat.profile_character": "캐릭터",
  "chat.profile_my_characters_my_characters_zero": "내 캐릭터",
  "chat.profile_my_characters_my_characters_one": "내 캐릭터",
  "chat.profile_my_characters_my_characters_other": "내 캐릭터",
  "chat.profile_my_characters_empty": "내가 만든 캐릭터가 없어요.",
  "chat.profile_others_characters_empty": "캐릭터가 없어요.",
  "chat.profile_universe": "서사",
  "chat.profile_my_universes_my_universes_zero": "내 서사",
  "chat.profile_my_universes_my_universes_one": "내 서사",
  "chat.profile_my_universes_my_universes_other": "내 서사",
  "chat.profile_my_universes_empty": "내가 만든 서사가 없어요.",
  "chat.profile_others_universes_empty": "서사가 없어요.",
  "chat.profile_scene": "테마",
  "chat.profile_my_scenes_my_scenes_zero": "내 테마",
  "chat.profile_my_scenes_my_scenes_one": "내 테마",
  "chat.profile_my_scenes_my_scenes_other": "내 테마",
  "chat.profile_my_scenes_empty": "내가 만든 테마가 없어요.",
  "chat.profile_others_scenes_empty": "테마가 없어요.",
  "chat.profile_assets_count_zero": "애셋",
  "chat.profile_assets_count_one": "애셋",
  "chat.profile_assets_count_other": "애셋",
  "chat.profile_my_rewards": "리워드",
  "chat.profile_my_shampoo": "포션",
  "chat.profile_others_nsfw_toggle": "팅글모드",
  "chat.profile_my_edit_title": "프로필 수정",
  "chat.profile_my_edit_modal_edit_writername": "닉네임 변경",
  "chat.profile_my_edit_modal_profile_introduction": "제작자 소개",
  "chat.profile_my_edit_writername": "닉네임",
  "chat.profile_my_edit_username": "아이디",
  "chat.profile_my_edit_introduction": "소개글",
  "chat.profile_my_edit_introduction_empty": "나의 소개글을 작성해 주세요.",
  "chat.profile_my_edit_email": "이메일",
  "chat.profile_my_edit_email_verify_message": "이메일을 인증해 주세요.",
  "chat.profile_my_edit_password": "비밀번호",
  "chat.profile_my_edit_password_set_message": "비밀번호를 설정해주세요.",
  "chat.profile_my_edit_password_completed_message": "비밀번호 설정이 완료되었어요.",
  "chat.profile_my_edit_identify_verification": "본인 인증",
  "chat.profile_my_edit_verify_identity": "본인 인증을 해주세요.",
  "chat.profile_my_edit_identify_verification_completed_message": "본인 인증이 완료되었습니다.",
  "chat.profile_my_edit_edit_button": "변경하기",
  "chat.profile_my_edit_edit_verify_button": "인증하기",
  "chat.profile_my_edit_edit_verify_completed_button": "인증완료",
  "chat.profile_my_edit_country_content_options_change_toast": "국가를 변경했어요.",
  "chat.profile_my_edit_content_display_settings_change_toast": "콘텐츠 보기 설정을 변경했어요.",
  "chat.profile_my_edit_country_content_options": "국가 및 콘텐츠",
  "chat.profile_my_edit_view_content_other_languages": "타 국가의 콘텐츠 보기",
  "chat.profile_my_edit_view_content_other_languages_thai": "태국어",
  "chat.profile_my_edit_view_content_other_languages_korean": "한국어",
  "chat.profile_my_edit_view_content_other_languages_taiwanese": "대만어",
  "chat.profile_my_edit_view_content_other_languages_japanese": "일본어",
  "chat.profile_my_edit_view_content_display_settings": "콘텐츠 보기 설정",
  "chat.profile_my_edit_view_content_current_country": "현재 국가",
  "chat.profile_my_edit_view_content_all_countries": "모든 국가",
  "chat.profile_my_edit_country_settings": "국가 설정",
  "chat.profile_my_edit_language_settings": "언어 설정",
  "chat.profile_my_edit_language_settings_popup_title": "언어 설정",
  "chat.profile_my_edit_language_settings_popup_subtitle": "언어 선택",
  "chat.profile_no_exist": "존재하지 않는 유저입니다.",
  "chat.profile_number_of_people": "{{int_numbers}}명",
  "chat.profile_my_create_no_personas": "내가 만든 페르소나가 없어요.",
  "chat.profile_my_create_no_scenes": "만든 테마가 없어요.",
  "chat.profile_my_create_no_universes": "만든 서사가 없어요.",
  "chat.profile_my_create_no_characters": "만든 캐릭터가 없어요.",
  "chat.profile_my_favorite_no_scenes": "즐겨찾기한 테마가 없어요.",
  "chat.profile_my_favorite_no_universes": "즐겨찾기한 서사가 없어요.",
  "chat.profile_my_favorite_no_characters": "즐겨찾기한 캐릭터가 없어요.",
  "chat.profile_my_recently_played_no_scenes": "최근 플레이한 테마가 없어요.",
  "chat.profile_my_recently_played_no_universes": "최근 플레이한 서사가 없어요.",
  "chat.profile_my_recently_played_no_characters": "최근 플레이한 캐릭터가 없어요.",
  "chat.profile_my_like_find_scenes": "마음에 드는 테마를 찾아보세요.",
  "chat.profile_my_like_find_universes": "마음에 드는 서사를 찾아보세요.",
  "chat.profile_my_like_find_characters": "마음에 드는 캐릭터를 찾아보세요.",
  "chat.profile_my_contest_tab_title": "공모전",
  "chat.profile_my_contest_tab_ongoing": "진행 중",
  "chat.profile_my_contest_tab_past_entries": "지난 참여작",
  "chat.profile_my_contest_participate_button": "참여하기",
  "chat.profile_my_contest_badge_button": "심사 중",
  "chat.profile_my_contest_view_button": "공모전 확인하기",
  "chat.profile_my_contest_view_results_button": "결과 확인하기",
  "chat.profile_my_contest_no_ongoing_contests": "진행 중인 공모전이 없어요.",
  "chat.profile_my_contest_ongoing_contests": "공모전 진행 중!<br/>지금 캐릭터를 만들고 공모전에 참여해보세요.",
  "chat.profile_my_contest_entered_null": "참여한 공모전이 없어요.",
  "chat.profile_my_set_password": "설정하기",
  "chat.profile_my_same_verified_email": "기존에 인증된 이메일과 동일해요.",
  "chat.profile_my_already_verified": "이미 인증된 명의입니다.",
  "chat.profile_my_verify_adult_verification_toast_title": "성인 인증을 위해<br/>본인 인증을 진행해 주세요.",
  "chat.profile_my_verify_adult_reverification_toast_title": "성인 인증 유효기간이<br/>만료되었습니다.",
  "chat.profile_my_verify_adult_reverification_toast_description": "성인 인증은 「청소년보호법 시행령 제17조 제2항」에 따라 최초 인증 후 1년이 지나면 다시 본인 여부를 확인해야 하는 법적 절차입니다.<br/><br/>안전하고 합법적인 이용을 위해 재인증을 진행해주세요. ",
  "chat.profile_my_verify_youth_protection_toast_title": "미성년자 이용불가",
  "chat.profile_my_verify_adult_verification_identity_verification": "본인 인증하기",
  "chat.profile_my_verify_adult_verification_identity_reverification": "재인증하기",
  "chat.profile_my_verify_youth_protection_toast": "이 정보 내용은 청소년 유해매체물로서<br/>정보통신망 이용 촉진 및 정보 보호 등에 관한<br/>법률 및 청소년 보호법의 규정에 의하여<br/>19세 미만의 청소년이 이용할 수 없습니다.",
  "chat.profile_my_edit_verify_modal_personal_information": "<link1>개인 정보 수집 및 이용</link1>에 동의합니다.",
  "chat.profile_my_edit_verify_modal_personal_information_transfer": "수집한 개인정보가 도용 방지를 목적으로 한국인터넷진흥원 e프라이버시 클린서비스에 전달되는 것에 동의합니다.",
  "chat.profile_my_edit_verify_modal_legally_responsible": "타인의 명의를 도용하거나 본인의 개인 정보가 아닐 경우 법적 책임을 다할 것에 동의합니다.",
  "chat.profile_my_edit_verify_modal_termination_suspension": "명의 도용으로 판단되는 경우 서비스 이용이 제한될 수 있음에 동의합니다.",
  "chat.profile_my_edit_verify_modal_one_identify": "1개의 계정당 1개의 명의로만 본인 인증이 가능합니다.",
  "chat.profile_my_edit_verify_modal_adult_content": "본인 인증을 통해 성인임이 확인되면 성인용 컨텐츠를 제작하거나 이용할 수 있습니다.",
  "chat.profile_my_edit_verify_modal_valid": "성인 인증 내역은 1년간 유효합니다.",
  "chat.profile_my_edit_verify_modal_penalties": "본인 인증에 타인의 명의를 사용할 경우, 법적 제재 및 서비스 이용 제한 등의 불이익이 있을 수 있습니다.",
  "chat.profile_delete_account_rewards": "회원 탈퇴 시, 리워드 수익금은 모두 사라지며 복구가 불가능합니다.",
  "chat.profile_delete_account_delete_assets": "회원 탈퇴 시에도 기존에 생성한 캐릭터, 서사, 테마는 삭제되지 않습니다. 삭제를 원하시는 경우 직접 삭제해 주시기 바랍니다.",
  "chat.profile_delete_account_personal_info": "회원 탈퇴 후에도 주식회사 버블탭 개인정보처리방침에 따라 개인 정보는 일정 기간 보관 후에 파기하게 됩니다.",
  "chat.profile_delete_account_verification": "본인 인증 후 회원 탈퇴 시, 7일간 해당 명의로 다시 본인 인증이 불가능합니다.",
  "chat.profile_delete_account_benefits": "신규 회원으로서 매직 포션 혜택을 받은 후 회원 탈퇴 시, 해당 명의로 다시 매직 포션 혜택을 받을 수 없습니다.",
  "chat.profile_delete_account_enter_password": "본인 확인을 위한 계정의 비밀번호를 입력해주세요.",
  "chat.profile_delete_account_current_password": "현재 사용 중인 비밀번호를 입력해 주세요.",
  "chat.profile_delete_account_password_combination": "영어, 숫자 또는 특수문자로 8~25글자를 입력해 주세요.",
  "chat.profile_delete_account_agree_all": "모두 동의해주세요",
  "chat.profile_delete_account_agree_all_delete": "모든 내용에 동의 후 계정을 삭제할 수 있습니다.",
  "chat.profile_delete_account_password_incorrect": "비밀번호가 틀렸습니다.",
  "chat.profile_delete_account_set_password": "진행하기 전에 먼저 비밀번호를 설정하세요.",
  "chat.profile_delete_account_delete_success": "계정이 성공적으로 삭제되었습니다.",
  "chat.profile_my_upload_image_button": "이미지 업로드",
  "chat.profile_my_decorate_profile_button": "프로필 꾸미기",
  "chat.profile_my_decorater_profile_edit_message": "프로필 이미지를 변경하면 적용된 데코터가 해제됩니다",
  "chat.profile_my_decorater_upload_profile_message": "프로필 이미지 등록 후 이용 가능합니다.",
  "chat.profile_my_edit_referrer_title": "추천인",
  "chat.profile_my_edit_referrer_register_code_title": "코드 등록",
  "chat.profile_my_edit_referrer_register_code_button": "등록",
  "chat.profile_my_edit_referrer_copy_code_title": "코드 복사",
  "chat.profile_my_edit_referrer_register_code_description": "추천인 코드를 입력하고<br/><highlight>{{int_numbers}} 포인트</highlight> <bold>받아가세요!</bold>",
  "chat.profile_my_edit_referrer_register_code_input_placeholder": "추천인 코드 입력",
  "chat.profile_my_edit_referrer_register_code_remaining_time_label": "남은 등록 가능 시간",
  "chat.profile_my_edit_referrer_register_code_remaining_time_format": "{{int_day}}일 {{int_time}}:{{int_minute}}:{{int_second}}",
  "chat.profile_my_edit_referrer_notice_title": "유의사항",
  "chat.profile_my_edit_referrer_notice_description1": "본인인증 완료된 계정만 추천인으로 등록될 수 있습니다.",
  "chat.profile_my_edit_referrer_notice_description2": "본인인증 완료된 계정만 추천인 등록이 가능합니다.",
  "chat.profile_my_edit_referrer_notice_description3": "추천인 등록 시 등록한 유저에게 {{int_refereeAmount}} 포인트, 추천인 유저에게 {{int_referrerAmount}} 포인트가 지급됩니다.",
  "chat.profile_my_edit_referrer_copy_code_description": "내 추천인 코드를 유저가 등록하면<br/>나에게 {{int_referrerAmount}} 포인트, 등록한 유저에게 {{int_refereeAmount}} 포인트 즉시 지급",
  "chat.profile_my_edit_referrer_register_code_completed_prefix": "등록 완료 :",
  "chat.profile_my_edit_referrer_verification_required_description": "본인 인증 완료 후 추천인 등록이 가능해요",
  "chat.profile_my_edit_referrer_copy_code_toast": "추천인 코드가 복사되었습니다",
  "chat.profile_my_edit_referrer_register_code_expired": "등록 기간 만료",
  "chat.profile_my_edit_referrer_error_unverified_account": "본인인증되지 않은 계정의 추천인 코드는 추천인으로 등록할 수 없어요.",
  "chat.profile_my_edit_referrer_error_user_not_found": "존재하지 않는 유저입니다.",
  "chat.profile_my_edit_referrer_error_self_register": "본인 계정은 추천인으로 등록할 수 없습니다.",
  "chat.profile_my_edit_referrer_error_period_expired": "입력 가능 기간이 지났습니다",
  "chat.profile_my_edit_referrer_registration_error_other_country": "타 국가 유저의 추천인 코드는 추천인으로 등록할 수 없어요.",
  "chat.profile_my_edit_referrer_registration_completed": "추천인 등록이 완료되었어요.",
  "chat.profile_my_edit_referrer_registered_referrer": "등록한 추천인 : ",
  "chat.profile_my_edit_referrer_registration_period_expired": "추천인 등록은 본인 인증 후 {{deadline_time}}일 이내에만 가능합니다.",
  "chat.profile_my_edit_referrer_benefit_title": "혜택",
  "chat.profile_my_edit_referrer_benefit_registration": "추천인 등록 가능",
  "chat.profile_my_edit_referrer_benefit_condition": "등록 시",
  "chat.profile_my_edit_referrer_benefit_reward": "3,000 포인트 지급",
  "chat.profile_setting_account_settings": "계정 설정",
  "chat.profile_setting_service_settings": "서비스 설정",
  "chat.profile_setting_country_content_settings": "국가 및 콘텐츠 설정",
  "chat.profile_setting_blocked_list": "차단 목록 관리",
  "chat.profile_setting_creator_support": "창작자 지원",
  "chat.profile_setting_account": "계정",
  "chat.profile_setting_service_support": "서비스 지원",
  "chat.profile_my_mileage_convert_menu_title": "마일리지",
  "chat.profile_my_mileage_convert_sheet_title": "마일리지 전환",
  "chat.profile_my_mileage_convert_sheet_description": "마일리지 1점은 1포인트로 전환돼요",
  "chat.profile_my_mileage_convert_balance_label": "보유 중인 마일리지",
  "chat.profile_my_mileage_convert_input_label": "전환할 마일리지",
  "chat.profile_my_mileage_convert_input_max": "최대",
  "chat.profile_my_mileage_convert_input_placeholder": "{{int_numbers}}점 단위로 전환할 수 있어요.",
  "chat.profile_my_mileage_convert_input_error_unit": "* {{int_numbers}}점 단위로만 전환할 수 있어요.",
  "chat.profile_my_mileage_convert_info_title": "마일리지란?",
  "chat.profile_my_mileage_convert_info_description_1": "{{int_numbers}}점부터 포인트로 전환이 가능하며 전환된 포인트는 일반 포인트와 동일한 용도로 사용할 수 있습니다.",
  "chat.profile_my_mileage_convert_info_description_2": "마일리지에서 전환된 포인트의 유효기간은 1년이며 교환·환불이 불가능합니다.",
  "chat.profile_my_mileage_convert_info_description_3": "크리에이터 인증이 완료된 유저의 마일리지는 리워드로 변경됩니다.",
  "chat.profile_my_mileage_convert_submit_button": "포인트로 전환하기",
  "chat.profile_my_mileage_convert_confirm_modal_title": "마일리지를 전환할까요?",
  "chat.profile_my_mileage_convert_confirm_modal_description": "전환된 포인트는 마일리지로 되돌릴 수 없으며, 지급된 포인트의 유효기간은 1년입니다.",
  "chat.profile_my_mileage_convert_confirm_modal_submit": "전환하기",
  "chat.profile_my_mileage_convert_complete_modal_title": "전환 완료",
  "chat.profile_my_mileage_convert_complete_modal_description": "{{int_numbers}} 포인트가 지급됐어요",
  "chat.profile_my_mileage_convert_my_bubble_label": "보유 포인트",
  "chat.profile_my_mileage_convert_remaining_label": "남은 마일리지",
  "chat.profile_my_mileage_load_failed": "로딩 실패",
  "chat.profile_my_mileage_reward_view": "확인하기",
  "chat.studio_create_image": "이미지 생성",
  "chat.studio_create_story": "스토리 생성",
  "chat.create_create_preset_create_description": "캐릭터부터 서사까지 한 번에 만들어 보세요.",
  "chat.create_create_custom_create_description": "다양한 서사, 테마와 조합하여 사용하는 캐릭터를 만들어 보세요.",
  "chat.create_create_universe_create_description": "캐릭터와 나에 관한 서사를 만들어 보세요.",
  "chat.create_create_scene_create_description": "대화의 배경이나 설정을 만들어 보세요.",
  "chat.create_create_preset": "통합형",
  "chat.create_create_preset_title": "캐릭터×서사×테마",
  "chat.create_create_custom": "조합형",
  "chat.create_create_preset_tooltip_title": "✅ 통합형이란?",
  "chat.create_create_preset_tooltip_description1": "캐릭터·서사·테마를 한 번에 제작하는 방식입니다.",
  "chat.create_create_preset_tooltip_description2": "넓은 프롬프트 범위와 기능을 활용해 완성도 높은 캐릭터를 빠르게 만들 수 있습니다.",
  "chat.create_create_preset_tooltip_description3": "통합형으로 만든 애셋은 조합형 애셋과 함께 사용할 수 없습니다.",
  "chat.create_create_preset_tooltip_description4": "한 번 통합형으로 생성하면, 조합형으로 바꿀 수 없습니다.",
  "chat.create_create_custom_tooltip_title": "✅ 조합형이란?",
  "chat.create_create_custom_tooltip_description1": "캐릭터·서사·테마를 단계별로 나누어 제작하고 연결하는 방식입니다.",
  "chat.create_create_custom_tooltip_description2": "각 요소를 개별로 만들고 수정할 수 있어 확장성과 재사용성이 높습니다.",
  "chat.create_create_custom_tooltip_description3": "조합형 애셋끼리만 함께 사용할 수 있습니다.",
  "chat.create_create_custom_tooltip_description4": "통합형으로 만든 애셋은 조합형과 함께 사용할 수 없습니다.",
  "chat.create_preset_lorebook_placeholder": "제목은 본문 글자 수에 포함되지 않습니다.",
  "chat.create_preset_character_details": "인물 설명",
  "chat.create_preset_character_details_placeholder": "입력하는 인물 설명은 비공개 영역에 저장되며, 일반 사용자에게 노출되지 않습니다.",
  "chat.create_preset_background_details": "배경 설명",
  "chat.create_preset_background_details_public_placeholder": "캐릭터의 배경 스토리와 서사를 자유롭게 설정하세요.<br/><br/>예시:<br/>{{assistant}}는 어릴 때 사고로 크게 다쳤다.<br/>{{assistant}}는 보육원에서 자랐다.",
  "chat.create_preset_background_details_private_placeholder": "입력하는 배경 설명은 비공개 영역에 저장되며, 일반 사용자에게 노출되지 않습니다.",
  "chat.create_asset_relationship_placeholder": "관계 중 공개하고 싶지 않은 내용은 이곳에 작성해주세요.",
  "chat.create_asset_details_placeholder": "추가설명 중 공개하고 싶지 않은 내용은 이곳에 작성해주세요.",
  "chat.create_asset_lorebook_placeholder": "입력하는 설정집 내용은 비공개 영역에 저장되며, 일반 사용자에게 노출되지 않습니다.",
  "chat.create_create_button": "생성",
  "chat.create_character_profile_img": "프로필 이미지",
  "chat.create_character_name_placeholder1": "서진우",
  "chat.create_character_name_placeholder2": "레온 에델하이트",
  "chat.create_character_name_placeholder3": "아르카스",
  "chat.create_introduction_label": "소개문구",
  "chat.create_character_introduction_placeholder1": "차가운 듯 다정한 선배",
  "chat.create_character_introduction_placeholder2": "왕국의 명예로운 성기사",
  "chat.create_character_introduction_placeholder3": "감정을 느끼기 위해 만들어진 인공 생명체",
  "chat.create_character_introduction_help_text": "* 소개문구는 캐릭터 작동에 영향을 미치지 않습니다.",
  "chat.create_tags_label": "태그",
  "chat.create_character_tags_description": "캐릭터와 어울리는 태그를 선택해 주세요",
  "chat.create_tags_placeholder": "태그를 검색해 보세요",
  "chat.create_tags_add": "신규 태그 추가",
  "chat.create_tags_minimum_fail_message": "태그는 최소 1개 이상 선택해 주세요.",
  "chat.create_tags_repeated_fail_message": "태그는 중복으로 선택할 수 없어요.",
  "chat.create_tags_maximum_fail_message": "태그는 최대 5개까지 입력할 수 있어요.",
  "chat.create_tags_maximum_fail_message_a": "태그는 최대 {{int_tagNumbers}}개까지 입력할 수 있어요.",
  "chat.create_tags_no_match_scenes": "태그에 맞는 테마가 없어요.",
  "chat.create_tags_no_match_universes": "태그에 맞는 서사가 없어요.",
  "chat.create_tags_no_match_characters": "태그에 맞는 캐릭터가 없어요.",
  "chat.create_sharing_option_label": "공개 여부",
  "chat.create_sharing_option_private_title": "비공개",
  "chat.create_sharing_option_private_description": "나만 사용할 수 있어요.",
  "chat.create_sharing_option_public_title": "공개",
  "chat.create_sharing_option_public_description": "다른 유저들도 사용할 수 있어요.",
  "chat.create_tap_specifics": "상세 정보",
  "chat.create_age_minimum_fail_message": "나이는 0 이상만 가능합니다.",
  "chat.create_age_maximum_fail_message": "나이는 10억 이하만 가능합니다.",
  "chat.create_character_job_placeholder1": "대학생",
  "chat.create_character_job_placeholder2": "성기사",
  "chat.create_character_job_placeholder3": "실험실에서 도망쳐 나온 피험자",
  "chat.create_character_character_placeholder1": "논리적, 차분함, 은근히 다정함",
  "chat.create_character_character_placeholder2": "정의로움, 책임감이 강함",
  "chat.create_character_character_placeholder3": "감정을 배우고 싶어 함, 순수함, 경계심이 강함",
  "chat.create_character_speaking_style_placeholder1": "규칙은 지키라고 있는 거야, 너도 알잖아., \"오늘은 지각 안 했네?\"",
  "chat.create_character_speaking_style_placeholder2": "이 검은 왕국과... 그리고 당신을 지키기 위해 존재합니다., \"조심하십시오.\"",
  "chat.create_character_speaking_style_placeholder3": "내가 무섭지 않아?, \"나도 인간이 될 수 있을까?\"",
  "chat.create_character_interests_placeholder1": "학생회 업무, 법과 정치, 클래식 음악",
  "chat.create_character_interests_placeholder2": "검술 연마, 왕국의 평화 유지, 신념을 지키는 것",
  "chat.create_character_interests_placeholder3": "감정 연구, 인간, 자신에 대한 고찰",
  "chat.create_details_help_text": "{{assistant}}를 쓰면 캐릭터의 이름으로 대체됩니다.{{user}}를 쓰면 대화중인 유저의 이름으로 대체됩니다.",
  "chat.create_tap_background": "대화 환경",
  "chat.create_tooltip_title": "도움말",
  "chat.create_tooltip_universe_description": "서사 '생성하기' 또는 '추가하기'를 통해 캐릭터에 맞는 서사를 기본으로 세팅해 놓을 수 있습니다.",
  "chat.create_tooltip_scene_description": "테마 '생성하기' 또는 '추가하기'를 통해 캐릭터에 맞는 테마를 기본으로 세팅해 놓을 수 있습니다.",
  "chat.create_first_sentence_description": "캐릭터와의 대화 도입부를 작성해 주세요.",
  "chat.create_first_sentence_placeholder1": "*서류를 정리하던 진우가 고개를 들었다* 학생회실 와본 적 없지?",
  "chat.create_first_sentence_placeholder2": "*빛나는 갑옷을 입은 레온이 말에서 내려 손을 내밀었다.* 괜찮으십니까? 늦어서 죄송합니다.",
  "chat.create_first_sentence_placeholder3": "*비 오는 밤, 실험실에서 도망쳐 나온 아르카스가 폐허 속에서 당신을 발견하고 조심스럽게 다가온다.* …날 숨겨줘. 부탁이야.",
  "chat.create_first_sentence_int_numbers": "도입부 {{int_numbers}}",
  "chat.create_first_sentence_add_button": "도입부 추가하기",
  "chat.create_first_sentence_title": "제목",
  "chat.create_first_sentence_description1": "* 최대 3개까지 작성할 수 있습니다.",
  "chat.create_first_sentence_description2": "* 도입부는 프롬프트의 글자 수에 포함되지 않습니다.",
  "chat.create_first_sentence_delete_confirm_message": "도입부를 삭제하시겠어요?",
  "chat.create_creator_comment_label": "제작자 코멘트",
  "chat.create_creator_comment_placeholder": "유저들에게 전달하고 싶은 메세지를 입력해 보세요.",
  "chat.create_prompt_label": "프롬프트",
  "chat.create_basic_info_label": "필수 정보",
  "chat.create_media_label": "미디어",
  "chat.create_extra_info_label": "추가 정보",
  "chat.create_prompt_characters_toast": "프롬프트는 합쳐서 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_creator_comment_characters_toast": "제작자 코멘트는 합쳐서 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_creator_first_sentence_characters_toast": "도입부는 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_creator_lorebook_characters_toast": "설정집은 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_creator_keywordbook_characters_toast": "키워드북 {{int_keywordbookNumbers}} 내용은 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_creator_description_characters_toast": "상황 설정은 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_character_create_fail_message": "캐릭터 생성에 실패했습니다.<br/>다시 시도해 주세요.",
  "chat.create_alert_message_name": "이름을 입력해주세요.",
  "chat.create_alert_message_image": "이미지를 첨부해주세요.",
  "chat.create_modal_gif_description": "GIF 이미지는 편집 기능을 제공하지 않습니다.",
  "chat.create_alert_message_tags": "태그를 최소 1개 이상 선택해 주세요.",
  "chat.create_alert_message_introduction": "소개 문구를 입력해주세요.",
  "chat.create_alert_message_age": "나이를 입력해주세요.",
  "chat.create_alert_message_nsfw": "팅글모드 서사/테마는 팅글모드 캐릭터에만 적용할 수 있어요.",
  "chat.create_alert_message_private": "선택하신 서사/테마가 비공개로 설정되어 있어 공개 캐릭터로 생성할 수 없어요.\n비공개 캐릭터로 생성할까요?",
  "chat.create_alert_message_cancel": "취소",
  "chat.create_private_character": "비공개 캐릭터로 생성",
  "chat.create_universe_name_help_text": "* 타인의 권리를 침해하는 서사를 제작하는 행위는 금지돼요.",
  "chat.create_universe_details_placeholder": "캐릭터의 서사에 대해 작성해 주세요.<br/>예시:<br/>{{assistant}}는 어릴 때 사고로 크게 다쳤다.<br/>{{assistant}}는 보육원에서 자랐다.",
  "chat.create_universe_create_fail_message": "서사 생성에 실패했습니다.<br/>다시 시도해 주세요.",
  "chat.create_scene_name_help_text": "* 타인의 권리를 침해하는 테마를 제작하는 행위는 금지돼요.",
  "chat.create_global_availability_title": "타 국가 공개 여부",
  "chat.create_global_availability_global": "글로벌",
  "chat.create_global_availability_global_description": "모든 국가의 리워드와 댓글을 받을 수 있어요",
  "chat.create_global_availability_domestic": "국내",
  "chat.create_global_availability_domestic_description": "현재 국가의 리워드와 댓글만 받을 수 있어요",
  "chat.create_global_availability_help_text": "* 글로벌 공개 시, 타 국가에서는 설정집의 내용이 반영되지 않습니다.",
  "chat.create_global_availability_auto_translation_help_text": "* 자동번역을 통해 제공됩니다.",
  "chat.create_character_failed_domestic_universe_scene": "선택하신 서사/테마의 ‘타 국가 공개 여부’가 국내로 설정되어 있어 글로벌 캐릭터로 생성할 수 없어요.<br/>글로벌 서사/테마를 선택해 주세요.",
  "chat.modify_character_failed_domestic_universe_scene": "선택하신 서사/테마의 ‘타 국가 공개 여부'가 국내로 설정되어 있어 글로벌 캐릭터로 수정할 수 없어요.<br/>글로벌 서사/테마를 선택해 주세요.",
  "chat.modify_character_alert_domestic_universe": "‘타 국가 공개 여부'를 국내로 변경 시, 타 국가에서는 해당 서사가 기본으로 설정된 캐릭터에서 제외돼요.<br/>그래도 수정하시겠어요?",
  "chat.modify_character_alert_domestic_scene": "‘타 국가 공개 여부'를 국내로 변경 시, 타 국가에서는 해당 테마가 기본으로 설정된 캐릭터에서 제외돼요.<br/>그래도 수정하시겠어요?",
  "chat.create_setup_label": "공간 설정",
  "chat.create_scene_create_fail_message": "테마 생성에 실패했습니다.<br/>다시 시도해 주세요.",
  "chat.create_draft_button": "임시저장",
  "chat.create_draft_asset_in_progress_modal_title": "제작 중인 애셋이 있어요.",
  "chat.create_draft_asset_in_progress_modal_description": "이어서 만드시겠어요?",
  "chat.create_draft_save_fail_storage_full_modal_title": "지금 만드는 애셋은 임시저장이 불가능해요",
  "chat.create_draft_save_fail_storage_full_modal_description": "저장 공간이 가득 차서 생성만 가능합니다<br/>임시저장 애셋들을 정리하거나 생성 후 이용할 수 있어요",
  "chat.create_draft_save_fail_storage_full_modal_manage_drafts_button": "임시저장 정리하기",
  "chat.create_draft_save_modal_title": "제작 중인 애셋을 임시 저장하시겠어요?",
  "chat.create_draft_save_modal_description": "임시저장은 최대 {{count}}개까지만 가능하며 저장하지 않은 내용은 삭제됩니다.",
  "chat.create_draft_save_fail_maximum_limit_modal_title": "최대 {{count}}개까지만 임시저장이 가능합니다.",
  "chat.create_draft_save_success_toast": "임시 저장에 성공하였습니다.",
  "chat.create_draft_save_fail_toast": "임시 저장에 실패하였습니다. 다시 시도해주세요.",
  "chat.create_draft_edit_option": "이어서 만들기",
  "chat.create_draft_delete_success_toast": "임시저장 애셋을 삭제했습니다.",
  "chat.create_draft_delete_fail_toast": "임시저장 애셋 삭제에 실패했습니다.<br/>다시 시도해주세요.",
  "chat.create_draft_empty": "제작 중인 내역이 없어요",
  "chat.create_draft_noname": "No name",
  "chat.create_create_title": "만들기",
  "chat.create_create_character": "캐릭터",
  "chat.create_create_universe": "서사",
  "chat.create_create_scene": "테마",
  "chat.create_create_character_header": "캐릭터 만들기",
  "chat.create_create_universe_header": "서사 만들기",
  "chat.create_create_scene_header": "테마 만들기",
  "chat.create_add_image_help_text_square": "정방형으로 편집 시 가장 적합하게 노출됩니다.",
  "chat.create_create_character_create": "캐릭터 만들기",
  "chat.create_create_character_create_description": "대화하고 싶은 캐릭터를 만들어 보세요.",
  "chat.create_create_character_my_characters": "내 캐릭터",
  "chat.create_create_character_my_characters_empty": "나만의 캐릭터를 만들어 보세요.",
  "chat.create_create_universe_create": "서사 만들기",
  "chat.create_create_universe_my_universes": "내 서사",
  "chat.create_create_universe_my_universes_empty": "나만의 서사를 만들어 보세요.",
  "chat.create_create_scene_create": "테마 만들기",
  "chat.create_create_scene_my_scenes": "내 테마",
  "chat.create_create_scene_my_scenes_empty": "나만의 테마를 만들어 보세요.",
  "chat.create_character_creation_guide": "캐릭터 생성 가이드를 꼭 읽어주세요!",
  "chat.create_character_add_thumbnail_image_button": "이미지 추가",
  "chat.create_add_image_failed": "이미지 추가에 실패했습니다.",
  "chat.create_character_basics_label": "기본 정보",
  "chat.create_character_basics_name": "이름",
  "chat.create_character_basics_name_help_text": "* 타인의 권리를 침해하는 캐릭터를 제작하는 행위는 금지돼요. 자세한 내용은 운영정책을 참고해주세요.",
  "chat.create_character_basics_gender_label": "성별",
  "chat.create_character_basics_gender_male": "남자",
  "chat.create_character_basics_gender_female": "여자",
  "chat.create_character_basics_gender_other": "기타",
  "chat.create_character_basics_age_rating_label": "연령 등급",
  "chat.create_character_basics_age_rating_normal_mode": "일반모드",
  "chat.create_character_basics_age_verification": "팅글모드 캐릭터는 성인인증 후 만들 수 있어요.",
  "chat.create_character_basics_age_rating_normal_mode_description": "모든 유저가 사용할 수 있어요.",
  "chat.create_character_basics_age_rating_nsfw_mode": "팅글모드",
  "chat.create_character_basics_age_rating_nsfw_mode_description": "성인 유저만 사용할 수 있어요.",
  "chat.create_character_basics_age_rating_nsfw_mode_toast": "19세 이하의 캐릭터는 팅글모드 캐릭터로 생성할 수 없어요.",
  "chat.create_character_basics_age_rating_help_text": "* 일반모드 선택 시 생성 단계에서 팅글모드 서사/테마를 적용할 수 없어요.",
  "chat.create_character_Information_label": "상세정보",
  "chat.create_character_Information_optional": "선택",
  "chat.create_character_Information_description": "캐릭터를 상세하게 묘사할 수 있어요.",
  "chat.create_character_Information_age": "나이",
  "chat.create_character_Information_job": "직업",
  "chat.create_character_Information_character": "성격",
  "chat.create_character_Information_speaking_style": "말투",
  "chat.create_character_Information_interests": "관심사",
  "chat.create_character_details_label": "추가설명",
  "chat.create_character_details_toast": "추가설명은 합쳐서 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_character_details_public": "공개 설명",
  "chat.create_character_details_placeholder": "캐릭터의 성격이나 외형 등을 작성해 주세요.<br/><br/>예시:<br/>\n{{assistant}}는 훤칠한 키에 은발 머리, 푸른 눈을 가졌다.<br/>\n{{assistant}}는 냉정하고 가차없다.",
  "chat.create_character_details_private": "비공개 설명",
  "chat.create_character_details_character_button": "캐릭터",
  "chat.create_character_details_user_button": "나",
  "chat.create_character_multi_images_title": "멀티 이미지",
  "chat.create_character_image_name_title": "이미지 제목 {{int_imageNumbers}}",
  "chat.create_character_image_name_placeholder1": "조용한 도서관",
  "chat.create_character_image_name_placeholder2": "피아노 치는 진우",
  "chat.create_character_image_name_placeholder3": "검을 든 레온",
  "chat.create_character_image_name_placeholder4": "존재에 대한 의문",
  "chat.create_character_image_name_placeholder5": "구원",
  "chat.create_character_add_multi_image_button": "이미지 추가",
  "chat.create_character_delete_multi_image_button": "이미지 삭제",
  "chat.create_character_context_title": "상황 설정",
  "chat.create_character_context_tooltip_message": "이름, 표정, 감정, 장소, 옷, 동작 형태로 입력할수록 이미지 노출 확률이 높아집니다.\n아래 예시를 참고해 주세요.<br/>- 서진우, 미소, 여유로움, 도서관 창가 자리, 얇은 안경, 책 읽는 중<br/>- 레온 에델하이트, 단호한 눈빛, 왕국 성문 앞, 갑옷, 검을 들고있음<br/>- 아르카스, 호기심 어린 표정, 달빛이 스며든 방, 거울을 보고 있음",
  "chat.create_character_context_placeholder1": "서진우, 미소, 여유로움, 도서관 창가 자리, 얇은 안경, 책 읽는 중",
  "chat.create_character_context_placeholder2": "서진우, 차분한 눈빛, 고요한 분위기, 음악실 피아노 앞, 피아노 연주 중",
  "chat.create_character_context_placeholder3": "레온 에델하이트, 단호한 눈빛, 왕국 성문 앞, 갑옷, 검을 들고있음",
  "chat.create_character_context_placeholder4": "아르카스, 호기심 어린 표정, 달빛이 스며든 방, 거울을 보고 있음",
  "chat.create_character_context_placeholder5": "아르카스, 애절한 시선, 외로움, 낡은 창고 안, 흙 묻은 손, 상대에게 손을 뻗음",
  "chat.create_character_multi_images_help_text": "업로드된 이미지 검수 후, 규정에 따라 캐릭터가 팅글모드 전용으로 변경되거나 비공개될 수 있습니다.",
  "chat.create_character_add_multi_images_button": "여러 장 올리기",
  "chat.create_character_multi_images_modal_title": "이미지 추가",
  "chat.create_character_multi_images_modal_my_ai_images": "나의 AI 이미지",
  "chat.create_character_multi_images_modal_upload_images": "내 장치",
  "chat.create_character_multi_images_modal_help_text": "가로형(16:9)으로 편집 시 가장 적합하게 노출됩니다.",
  "chat.create_character_multi_images_modal_edit": "편집하기",
  "chat.create_character_multi_images_modal_edit_done": "완료",
  "chat.create_character_multi_images_modal_edit_zoom": "확대",
  "chat.create_character_multi_images_modal_edit_reset": "초기화",
  "chat.create_character_multi_images_modal_edit_square": "정방형",
  "chat.create_character_multi_images_modal_edit_landscape": "가로형",
  "chat.create_character_multi_images_modal_edit_portrait": "세로형",
  "chat.create_character_multi_images_context_error_msg_a": "*이미지 {{int_imageNumbers}}의 상황 설정을 입력해주세요.",
  "chat.create_character_multi_images_context_error_msg_b": "*이미지 {{int_imageNumbers}}의 상황 설정이 중복되지 않도록 입력해주세요.",
  "chat.create_character_multi_images_main_image_badge": "대표 이미지",
  "chat.create_character_multi_images_main_image_description": "대표 이미지를 등록해주세요.",
  "chat.create_character_multi_images_image_title_description": "이미지 제목을 입력해주세요.",
  "chat.create_character_multi_images_describe_image": "상황 설정을 입력해주세요.",
  "chat.create_character_multi_images_edit_info_button": "정보 수정",
  "chat.create_character_multi_images_edit_info_modal_title": "정보 수정",
  "chat.create_character_multi_images_delete_image_button": "이미지 삭제",
  "chat.create_character_multi_images_max_size": "최대 {{int_size}}",
  "chat.create_character_multi_images_edit_info_modal_public_toggle": "이미지 공개",
  "chat.create_character_multi_images_edit_info_modal_main_image_description": "대표 이미지는 1장만 등록 가능합니다.",
  "chat.create_character_multi_images_edit_info_modal_save_button": "등록",
  "chat.create_character_context_placeholder6": "상황 설정이 간단할수록 이미지가 쉽게 열리고, 복잡할수록 열기 어려워집니다.<br/><br/>간단한 예시) 방에서 거울을 보고 있는 상황<br/>복잡한 예시) 달빛이 스며든 조용한 방 안, 호기심 어린 표정으로 거울을 응시하는 아르카스",
  "chat.create_character_multi_images_set_public": "이미지 전체 공개",
  "chat.create_character_multi_images_modal_delete_description": "이미지와 함께 입력된 정보도 모두 삭제돼요.",
  "chat.create_character_multi_images_modal_delete_cancel": "취소",
  "chat.create_character_multi_images_modal_delete_delete": "삭제",
  "chat.create_character_multi_images_modal_set_unlock_bubbles": "해금 포인트 설정",
  "chat.create_character_multi_images_modal_unlock_available_images": "비공개 이미지만 설정이 가능합니다.",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert1": "해금 포인트를 설정해주세요.",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert2": "100포인트 단위로 입력 가능합니다.",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert": "해금 포인트를 설정해주세요.<br/>100포인트 단위로 입력 가능합니다.",
  "chat.create_character_multi_images_modal_unlock_bubbles": "포인트",
  "chat.create_character_multi_images_no_unlock_bubble_set": "해금 포인트가 설정되지 않았습니다.",
  "chat.create_character_multi_images_tooltip_title1": "멀티 이미지란?",
  "chat.create_character_multi_images_tooltip_description1": "멀티 이미지는 대화 중 특정 키워드나 상황이 나타나면, 그에 어울리는 이미지를 자연스럽게 보여주는 기능이에요.",
  "chat.create_character_multi_images_tooltip_description2": "상황설정이 단순할수록 이미지가 쉽게 열려요.",
  "chat.create_character_multi_images_tooltip_title2": "참고해 주세요!",
  "chat.create_character_multi_images_tooltip_description3": "비공개 이미지는 대화 중 설정된 상황이 만들어질 때 열 수 있어요.",
  "chat.create_character_multi_images_tooltip_description4": "해금 포인트는 최소 100포인트부터 설정할 수 있고, 캐릭터의 리워드 수익에 포함돼요.",
  "chat.create_character_multi_images_tooltip_description5": "비공개 이미지에 대한 수익 배분율은 50%에요.",
  "chat.create_character_multi_images_title_placeholder": "이미지 제목을 입력하세요.(선택)",
  "chat.create_character_multi_images_upload_title": "이미지를 업로드해주세요.",
  "chat.create_character_multi_images_add_title1": "이미지 추가하기",
  "chat.create_character_multi_images_add_title2": "({{int_numbers}}/200)",
  "chat.create_character_multi_images_add_description1": "클릭하거나 드래그 앤 드랍하여 이미지를 업로드하세요.",
  "chat.create_character_multi_images_add_description2": "최대 {{int_numbers}}장까지 동시에 업로드할 수 있습니다.",
  "chat.create_character_multi_images_add_description3": "이미지 1장 당 최대 15MB까지만 업로드할 수 있습니다.",
  "chat.create_character_multi_images_upload_fail_size_toast": "용량 초과로 {{int_numbers}}장의 이미지가 업로드에 실패했어요.",
  "chat.create_character_multi_images_upload_fail_toast": "{{int_numbers}}장의 이미지가 업로드에 실패했어요.",
  "chat.create_character_multi_images_upload_fail_size": "• 용량 초과",
  "chat.create_character_multi_images_upload_fail_format": "• 지원하지 않는 포맷",
  "chat.create_character_multi_images_upload_fail_limit": "• 업로드 개수 초과",
  "chat.create_character_multi_images_upload_limit_toast": "이미지 업로드는 한번에 {{int_numbers}}장까지만 가능합니다.",
  "chat.create_character_multi_images_uploading": "이미지 업로드 중...",
  "chat.create_character_multi_images_bulk_edit_modal_title": "일괄편집",
  "chat.create_character_multi_images_bulk_edit_modal_image_settings_title": "이미지 설정",
  "chat.create_character_multi_images_bulk_edit_modal_privacy_settings_title": "공개 설정",
  "chat.create_character_multi_images_bulk_edit_modal_bubble_unit_placeholder": "100포인트 단위로 입력해주세요.",
  "chat.create_character_multi_images_bulk_edit_modal_description": "대표 이미지는 공개 설정이 불가능합니다.",
  "chat.create_character_multi_images_bulk_edit_modal_delete_alert_description": "삭제한 이미지는 복구할 수 없어요.",
  "chat.create_character_multi_images_bulk_edit_modal_selected": "{{count}}개 선택됨",
  "chat.create_character_multi_images_bulk_edit_modal_select_all": "전체 선택",
  "chat.create_character_multi_images_bulk_edit_modal_deselect": "선택 해제",
  "chat.create_character_multi_images_bulk_edit_unable_to_set": "설정 불가",
  "chat.create_character_multi_images_upload_progress": "{{int_current}}/{{int_total}}장 업로드 중",
  "chat.create_character_multi_images_upload_cancel": "취소",
  "chat.create_character_multi_images_upload_cancel_confirm_title": "업로드를 취소할까요?",
  "chat.create_character_multi_images_upload_cancel_confirm": "이미 완료된 이미지는 그대로 유지됩니다.",
  "chat.create_character_multi_images_upload_failed_label": "업로드 실패",
  "chat.create_character_multi_images_upload_retry": "다시 시도",
  "chat.create_character_multi_images_upload_retry_all": "실패한 {{int_numbers}}장 다시 시도",
  "chat.create_character_multi_images_upload_partial_toast": "남은 슬롯만큼 {{int_numbers}}장만 추가했어요.",
  "chat.create_character_multi_images_upload_slot_full_toast": "슬롯이 가득 차 {{int_numbers}}장을 추가하지 못했어요.",
  "chat.create_character_multi_images_upload_in_progress_block": "이미지 업로드가 끝난 후 저장할 수 있어요.",
  "chat.create_character_multi_images_error_nav_prev": "이전 오류 이미지",
  "chat.create_character_multi_images_error_nav_next": "다음 오류 이미지",
  "chat.create_character_select_universe": "서사를 선택해 주세요",
  "chat.create_character_select_universe_optional": "선택",
  "chat.create_character_select_universe_add": "추가하기",
  "chat.create_character_select_universe_create": "생성하기",
  "chat.create_character_select_universe_change": "변경하기",
  "chat.create_character_select_scene": "테마를 선택해 주세요",
  "chat.create_character_select_scene_optional": "선택",
  "chat.create_character_select_scene_add": "추가하기",
  "chat.create_character_select_scene_create": "생성하기",
  "chat.create_character_select_scene_change": "변경하기",
  "chat.create_character_first_sentence": "도입부",
  "chat.create_character_first_sentence_optional": "선택",
  "chat.create_character_first_sentence_description": "대화가 시작되는 장면을 설정해 주세요.",
  "chat.create_character_create_character": "캐릭터 생성하기",
  "chat.create_character_link_only": "링크 공개",
  "chat.create_character_link_only_help_text": "* 링크 공개 캐릭터는 공개 혹은 비공개 상태로 수정할 수 없습니다.",
  "chat.create_character_link_only_description": "링크를 가진 유저만 사용할 수 있어요.",
  "chat.create_character_link_only_copied": "링크가 복사되었습니다.",
  "chat.create_character_link_only_copied_failed": "링크 복사에 실패했습니다.",
  "chat.create_character_keyword_book_title": "키워드북",
  "chat.create_character_keyword_book_number": "키워드북 {{int_numbers}}",
  "chat.create_character_keyword_book_keyword": "키워드",
  "chat.create_character_keyword_book_keyword_placeholder": "키워드 입력 후 엔터 (예시: 전학)",
  "chat.create_character_keyword_book_keyword_description": "키워드북 하나당 최대 5개의 키워드를 입력할 수 있어요.",
  "chat.create_character_keyword_book_max_toast": "키워드는 최대 5개까지 등록할 수 있어요.",
  "chat.create_character_keyword_book_keyword_alert": "키워드를 입력 후 엔터해 주세요.",
  "chat.create_character_keyword_book_content": "내용",
  "chat.create_character_keyword_book_content_placeholder": "키워드가 언급 되는 상황에서 불러올 내용들을 입력해 주세요.<br/>(예시: 서진우는 중학교 때 폭력 사건에 휘말려 한 차례 전학을 갔다.)",
  "chat.create_character_keyword_book_content_alert": "내용을 입력해 주세요.",
  "chat.create_character_keyword_book_add_keyword_book": "키워드북 추가하기",
  "chat.create_character_keyword_book_incomplete_toast": "입력 중인 키워드북 항목을 모두 채워주세요.",
  "chat.create_character_keyword_book_edit_modal_title": "키워드북 이름",
  "chat.create_character_keyword_book_edit_modal_cancel": "취소",
  "chat.create_character_keyword_book_edit_modal_done": "수정",
  "chat.create_character_keyword_book_delete_modal_title": "키워드북을 삭제하시겠어요?",
  "chat.create_character_keyword_book_delete_modal_cancel": "취소",
  "chat.create_character_keyword_book_delete_modal_delete": "삭제",
  "chat.create_character_keyword_book_tooltip_title1": "키워드북이란?",
  "chat.create_character_keyword_book_tooltip_description1": "키워드북은 대화 중 특정 키워드가 언급되면, 키워드에 대해 미리 작성한 내용을 불러오는 기능이에요.",
  "chat.create_character_keyword_book_tooltip_description2": "키워드가 정확히 일치하지 않으면 내용이 반영되지 않아요.",
  "chat.create_character_keyword_book_tooltip_title2": "참고해 주세요!",
  "chat.create_character_keyword_book_tooltip_description3": "중요한 키워드북을 위쪽으로 드래그 해주세요.",
  "chat.create_character_keyword_book_tooltip_description4": "하나의 키워드를 여러 키워드북에 등록했을 경우, 키워드 언급 시 상위 10개까지의 키워드북만 적용돼요.",
  "chat.create_character_keyword_book_tooltip_description5": "여러 키워드 언급 시, 키워드가 가장 많이 일치한 키워드북이 우선 적용돼요.",
  "chat.create_character_keyword_book_tooltip_description6": "키워드북은 캐릭터와 유저의 메세지 모두 인식합니다.",
  "chat.create_universe_creation_guide": "서사 생성 가이드를 꼭 읽어주세요!",
  "chat.create_universe_profile_img": "썸네일 이미지",
  "chat.create_universe_basics_label": "기본 정보",
  "chat.create_universe_add_thumbnail_image_button": "이미지 추가",
  "chat.create_universe_basics_name": "이름",
  "chat.create_universe_basics_name_placeholder1": "학생회장과의 인연",
  "chat.create_universe_basics_name_placeholder2": "주군과 기사",
  "chat.create_universe_basics_name_placeholder3": "감정을 원하는 실험체",
  "chat.create_universe_introduction": "소개문구",
  "chat.create_universe_introduction_help_text": "* 소개문구는 서사 작동에 영향을 미치지 않습니다.",
  "chat.create_universe_introduction_placeholder1": "나에게만 차가운 학생회장의 비밀을 알게 됐다.",
  "chat.create_universe_introduction_placeholder2": "늘 한결같던 그 기사가, 요즘 따라 미묘하게 낯설다.",
  "chat.create_universe_introduction_placeholder3": "감정을 배우려는 인공 생명체가 나에게 집착하기 시작했다.",
  "chat.create_universe_tags_label": "태그",
  "chat.create_universe_tags_description": "서사와 어울리는 태그를 선택해 주세요",
  "chat.create_universe_tags_placeholder": "태그를 검색해 보세요",
  "chat.create_universe_sharing_options_label": "공개 여부",
  "chat.create_universe_sharing_options_private": "비공개",
  "chat.create_universe_sharing_options_private_description": "나만 사용할 수 있어요",
  "chat.create_universe_sharing_options_public": "공개",
  "chat.create_universe_sharing_options_public_description": "다른 유저들도 사용할 수 있어요.",
  "chat.create_universe_age_rating_label": "연령 등급",
  "chat.create_universe_age_rating_normal_mode": "일반모드",
  "chat.create_universe_age_verification": "팅글모드 서사는 성인인증 후 만들 수 있어요.",
  "chat.create_universe_age_rating_normal_mode_description": "모든 유저가 사용할 수 있어요.",
  "chat.create_universe_age_rating_nsfw_mode": "팅글모드",
  "chat.create_universe_age_rating_nsfw_mode_description": "성인 유저만 사용할 수 있어요.",
  "chat.create_universe_relationship_label": "캐릭터와 나의 관계",
  "chat.create_universe_relationship_label2": "관계",
  "chat.information_universe_relationship_toast_characters": "캐릭터와 나의 관계는 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_universe_relationship_public": "공개 설명",
  "chat.create_universe_relationship_private": "비공개 설명",
  "chat.create_universe_relationship_character_button": "캐릭터",
  "chat.create_universe_relationship_user_button": "나",
  "chat.create_universe_relationship_placeholder": "캐릭터와 나의 관계에 대해 작성해 주세요.<br/><br/>예시:<br/>{{assistant}}는 {{user}}의 친구다.<br/>{{assistant}}와 {{user}}는 최근 크게 싸우고 어색한 사이가 되었다.",
  "chat.create_universe_details_label": "추가설명",
  "chat.create_universe_details_public": "공개 설명",
  "chat.create_universe_details_private": "비공개 설명",
  "chat.create_universe_details_character_button": "캐릭터",
  "chat.create_universe_details_user_button": "나",
  "chat.create_universe_create_universe": "서사 생성하기",
  "chat.create_universe_lorebook_label": "설정집",
  "chat.create_universe_lorebook_description1": "입력한 내용을 이해해 대화 중 자연스럽게 인용하거나 맥락에 맞게 반영해요.",
  "chat.create_universe_lorebook_title": "제목",
  "chat.create_universe_lorebook_title_placeholder": "백야회 입단기",
  "chat.create_universe_lorebook_content": "내용",
  "chat.create_universe_lorebook_content_placeholder": "고아 출신으로 길거리 생활 중 간부의 눈에 띄어 조직에 들어갔다. 처음 1년은 주로 총을 썼지만, 이후 근거리 제압에 강점을 보여 무기가 칼로 바뀌었다.<br/>열여덟에 항구 쪽 정리 건으로 처음 큰 사고에 투입됐고, 그때 왼쪽 옆구리에 칼을 맞았다.",
  "chat.create_universe_lorebook_description2": "설정집의 추가, 변경 및 삭제는 기존 대화방에도 영향을 미칩니다.",
  "chat.create_universe_lorebook_description3": "설정집의 제목은 서사 작동에 영향을 미치지 않습니다.",
  "chat.create_universe_lorebook_incomplete_title_alert": "제목을 입력해주세요.",
  "chat.create_universe_lorebook_incomplete_content_alert": "내용을 입력해주세요.",
  "chat.create_universe_lorebook_incomplete_toast": "입력 중인 설정집 항목을 모두 채워주세요.",
  "chat.create_scene_creation_guide": "테마 생성 가이드를 꼭 읽어주세요!",
  "chat.create_scene_basics_label": "기본 정보",
  "chat.create_scene_add_thumbnail_image_button": "이미지 추가",
  "chat.create_scene_basics_name": "이름",
  "chat.create_scene_basics_name_placeholder1": "청운 고등학교",
  "chat.create_scene_basics_name_placeholder2": "중세 판타지 세계관",
  "chat.create_scene_basics_name_placeholder3": "어느 날 호감도가 보이기 시작했다",
  "chat.create_scene_introduction_placeholder1": "청운고 학생회실에서 캐릭터와 마주쳤다.",
  "chat.create_scene_introduction_placeholder2": "중세 판타지, 산 중턱에 위치한 기사단 본부",
  "chat.create_scene_introduction_placeholder3": "격리 구역 07에서 벌어진 아포칼립스",
  "chat.create_scene_introduction_help_text": "*소개문구는 테마 작동에 영향을 미치지 않습니다.",
  "chat.create_scene_tags_label": "태그",
  "chat.create_scene_tags_description": "테마와 어울리는 태그를 선택해 주세요",
  "chat.create_scene_tags_placeholder": "태그를 검색해 보세요",
  "chat.create_scene_sharing_options_label": "공개 여부",
  "chat.create_scene_sharing_options_private": "비공개",
  "chat.create_scene_sharing_options_private_description": "나만 사용할 수 있어요",
  "chat.create_scene_sharing_options_public": "공개",
  "chat.create_scene_sharing_options_public_description": "다른 유저들도 사용할 수 있어요.",
  "chat.create_scene_age_rating_label": "연령 등급",
  "chat.create_scene_age_rating_normal_mode": "일반모드",
  "chat.create_scene_age_verification": "팅글모드 테마는 성인인증 후 만들 수 있어요.",
  "chat.create_scene_age_rating_normal_mode_description": "모든 유저가 사용할 수 있어요.",
  "chat.create_scene_age_rating_nsfw_mode": "팅글모드",
  "chat.create_scene_age_rating_nsfw_mode_description": "성인 유저만 사용할 수 있어요.",
  "chat.create_scene_time": "시대적 배경",
  "chat.create_scene_place": "공간적 배경",
  "chat.create_scene_place_placeholder1": "학생회실",
  "chat.create_scene_place_placeholder2": "기사단 본부",
  "chat.create_scene_place_placeholder3": "격리 구역 07",
  "chat.create_scene_time_placeholder1": "현대",
  "chat.create_scene_time_placeholder2": "중세",
  "chat.create_scene_time_placeholder3": "근미래",
  "chat.create_scene_optional": "선택",
  "chat.create_scene_details_label": "추가설명",
  "chat.create_scene_details_public": "공개 설명",
  "chat.create_scene_details_private": "비공개 설명",
  "chat.create_scene_details_character_button": "캐릭터",
  "chat.create_scene_details_user_button": "나",
  "chat.create_scene_details_placeholder": "대화의 배경이나 설정을 작성해 주세요.<br/><br/>예시:<br/>좀비 아포칼립스 시대.<br/>{{user}}의 체력이 0%가 되기 전 치료제를 개발해야 한다.",
  "chat.create_scene_create_universe": "테마 생성하기",
  "chat.create_persona_title": "페르소나 만들기",
  "chat.create_persona_placeholder1": "서진우, 17세, 남자, 고등학생, 학생회장, 논리적, 차분함, 은근히 다정함, 관심사: 학생회 업무, 법과 정치, 클래식 음악",
  "chat.create_persona_placeholder2": "레온 에델하이트, 20세, 남자, 성기사, 정의로움, 책임감이 강함, 관심사: 검술 연마, 왕국의 평화 유지, 신념을 지키는 것",
  "chat.create_persona_placeholder3": "아르카스, 18세, 남자, 실험실에서 도망쳐 나온 피험자, 감정을 배우고 싶어 함, 순수함, 경계심이 강함, 관심사: 감정 연구, 인간, 자신에 대한 고찰",
  "chat.create_persona_create_failed": "페르소나 생성에 실패했습니다. 다시 시도해주세요.",
  "chat.create_persona_done": "완료",
  "chat.create_persona_create": "직접 만들기",
  "chat.create_persona_add_image": "이미지 추가",
  "chat.create_persona_optional": "선택",
  "chat.create_persona_name_label": "이름",
  "chat.create_persona_name_placeholder": "서진우",
  "chat.create_persona_name_help_text": "* 타인의 권리를 침해하는 페르소나를 제작하는 행위는 금지돼요. 자세한 내용은 운영정책을 참고해주세요.",
  "chat.create_persona_gender_label": "성별",
  "chat.create_persona_gender_male": "남자",
  "chat.create_persona_gender_female": "여자",
  "chat.create_persona_gender_other": "기타",
  "chat.create_persona_age_label": "나이",
  "chat.create_persona_job_label": "직업",
  "chat.create_persona_job_placeholder": "고등학생, 학생회장",
  "chat.create_persona_character": "성격",
  "chat.create_persona_personality_placeholder": "논리적, 차분함, 은근히 다정함",
  "chat.create_persona_interests_label": "관심사",
  "chat.create_persona_interests_placeholder": "학생회 업무, 법과 정치, 클래식 음악",
  "chat.create_persona_import": "캐릭터로 만들기",
  "chat.create_persona_search": "검색어를 입력해주세요.",
  "chat.create_persona_select_tags_button": "태그 선택",
  "chat.create_persona_select_tags_modal_title": "태그 선택",
  "chat.create_persona_select_tags_modal_search": "태그를 검색해 보세요",
  "chat.create_persona_select_tags_modal_trending_tags": "실시간 인기태그",
  "chat.create_persona_select_tags_modal_selected_tags": "선택한 태그",
  "chat.create_persona_select_tags_modal_reset_button": "초기화",
  "chat.create_persona_select_tags_modal_apply_tags_button": "태그 적용하기",
  "chat.create_persona_select_tags_button_selected": "{{int_tagNumbers}}개 선택",
  "chat.create_persona_chat_list_relevancy": "관련도순",
  "chat.create_persona_chat_list_order_recent": "최신순",
  "chat.create_persona_chat_list_order_liked": "좋아요 많은 순",
  "chat.create_persona_chat_list_order_played": "플레이 많은 순",
  "chat.create_persona_create_toast": "페르소나가 생성되었습니다.",
  "chat.create_persona_age_limit": "나이는 10억 이하, -10억 이상만 가능합니다.",
  "chat.create_add_multiple_images_toast": "중간의 빈 슬롯을 모두 채워야 여러 장 올리기가 가능합니다.",
  "chat.create_tags_characters_toast": "태그는 {{int_characters}}자 이하로 입력해주세요.",
  "chat.modify_change_thumbnail_image_button": "이미지 변경",
  "chat.modify_persona": "페르소나 수정",
  "chat.modify_persona_failed": "페르소나 수정에 실패했습니다. 다시 시도해주세요.",
  "chat.modify_character_modify_fail_message": "캐릭터 수정에 실패했습니다.<br/>다시 시도해 주세요.",
  "chat.modify_universe_modify_fail_message": "서사 수정에 실패했습니다.<br/>다시 시도해 주세요.",
  "chat.modify_scene_modify_fail_message": "테마 수정에 실패했습니다.<br/>다시 시도해 주세요.",
  "chat.general_connect_fail_message": "서비스에 접속할 수 없습니다. 새로고침을 하거나 잠시 후 다시 접속해 주시기 바랍니다.",
  "chat.modify_character_header": "캐릭터 수정하기",
  "chat.modify_universe_header": "서사 수정하기",
  "chat.modify_scene_header": "테마 수정하기",
  "chat.modify_character_modify_save": "캐릭터 수정하기",
  "chat.modify_universe_modify_save": "서사 수정하기",
  "chat.modify_scene_modify_save": "테마 수정하기",
  "chat.modify_modal_unsaved_changes_title": "저장하지 않은 변경 사항이 있어요.",
  "chat.modify_modal_excluded_character_universe": "비공개 시, 해당 서사가 기본으로 설정된 모든 캐릭터에서 제외돼요.<br/>그래도 수정하시겠어요?",
  "chat.modify_modal_excluded_character_scene": "비공개 시, 해당 테마가 기본으로 설정된 모든 캐릭터에서 제외돼요.<br/>그래도 수정하시겠어요?",
  "chat.modify_toast_blocked_universe": "비공개 처리된 서사는 공개 상태로 수정할 수 없습니다.",
  "chat.modify_toast_blocked_scene": "비공개 처리된 테마는 공개 상태로 수정할 수 없습니다.",
  "chat.modify_toast_created_only_character": "본인이 만든 캐릭터만 수정할 수 있어요.",
  "chat.modify_toast_created_only_universe": "본인이 만든 서사만 수정할 수 있어요.",
  "chat.modify_toast_created_only_scene": "본인이 만든 테마만 수정할 수 있어요.",
  "chat.modify_toast_nsfw_character": "팅글모드 캐릭터의 나이는 19세 이하로 수정할 수 없어요.",
  "chat.modify_modal_unsaved_changes_description": "작성중인 내용은 저장되지 않아요. <br/>이 페이지에서 나가시겠어요?",
  "chat.modify_modal_unsaved_changes_cancel_button": "취소",
  "chat.modify_modal_unsaved_changes_leave_button": "나가기",
  "chat.modify_no_change_private_character": "비공개 처리된 캐릭터는 공개 상태로 수정할 수 없습니다.",
  "chat.modify_persona_deleted": "페르소나를 삭제했습니다.",
  "chat.modify_persona_deleted_failed": "페르소나 삭제에 실패했습니다.",
  "chat.search_title": "무엇을 찾고 계신가요?",
  "chat.search_search_description_characters": "캐릭터 검색",
  "chat.search_search_description_universes": "서사 검색",
  "chat.search_search_description_scenes": "테마 검색",
  "chat.search_search_toggle_menu_characters": "캐릭터",
  "chat.search_search_toggle_menu_universes": "서사",
  "chat.search_search_toggle_menu_scenes": "테마",
  "chat.search_search_modal_recent_searches": "최근 검색어",
  "chat.search_search_modal_delete_all": "전체 삭제",
  "chat.search_select_tags_button": "태그 선택",
  "chat.search_select_tags_modal_title": "태그 선택",
  "chat.search_select_tags_modal_search": "태그를 검색해 보세요",
  "chat.search_select_tags_modal_trending_tags": "실시간 인기태그",
  "chat.search_select_tags_modal_selected_tags": "선택한 태그",
  "chat.search_select_tags_modal_reset_button": "초기화",
  "chat.search_select_tags_modal_apply_tags_button": "태그 적용하기",
  "chat.search_select_tags_button_selected": "{{int_tagNumbers}}개 선택",
  "chat.search_nsfw_toggle": "팅글모드",
  "chat.search_chat_list_relevancy": "관련도순",
  "chat.search_chat_list_order_recent": "최신순",
  "chat.search_chat_list_order_liked": "좋아요 많은 순",
  "chat.search_chat_list_order_played": "플레이 많은 순",
  "chat.search_no_results": "검색 결과가 없어요.",
  "chat.search_search_description_writername": "닉네임 검색",
  "chat.search_search_toggle_menu_writername": "닉네임",
  "chat.rewards_revenue_information": "수익 정보",
  "chat.rewards_revenue_information_total_revenue": "누적 수익",
  "chat.rewards_revenue_information_total_withdrawals": "누적출금액",
  "chat.rewards_revenue_information_last months_withdrawal": "지난 달 수익",
  "chat.rewards_revenue_information_withdrawable_revenue": "출금 가능 수익",
  "chat.rewards_revenue_information_withdrawable_revenue_help_text": "순수익에서 수익배분율에 따라 정산된 금액입니다.<br/>매달 15일에 금액이 갱신됩니다.",
  "chat.rewards_revenue_information_profit_sharing_rate": "수익배분율",
  "chat.rewards_revenue_information_request_a_withdrawal": "출금신청하기",
  "chat.rewards_revenue_converted_amount_help_text": "한 번 전환되어 차감된 금액은 신청 취소가 불가능합니다.",
  "chat.rewards_creator_information": "제작자 정보",
  "chat.rewards_creator_information_username": "아이디",
  "chat.rewards_creator_information_identity_verification": "본인 인증",
  "chat.rewards_creator_information_completed_button": "인증완료",
  "chat.rewards_creator_information_email": "이메일",
  "chat.rewards_creator_information_edit": "수정",
  "chat.rewards_creator_information_account_verification": "계좌 인증",
  "chat.rewards_creator_information_verify": "인증하기",
  "chat.rewards_tracking_revenue": "수익금 추이",
  "chat.rewards_tracking_revenue_total": "전체",
  "chat.rewards_tracking_revenue_characters": "캐릭터",
  "chat.rewards_tracking_revenue_universes": "서사",
  "chat.rewards_tracking_revenue_scenes": "테마",
  "chat.rewards_tracking_revenue_day_button": "일별",
  "chat.rewards_tracking_revenue_week_button": "주별",
  "chat.rewards_tracking_revenue_month_button": "월별",
  "chat.rewards_monthly_sales": "월 매출",
  "chat.rewards_monthly_sales_my_assets": "내 애셋",
  "chat.rewards_monthly_sales_total": "전체",
  "chat.rewards_monthly_sales_characters_button": "캐릭터",
  "chat.rewards_monthly_sales_universes_button": "서사",
  "chat.rewards_monthly_sales_scenes_button": "테마",
  "chat.home_require_alert_login_age_verification_character": "로그인 및 성인인증이 필요한 캐릭터예요.",
  "chat.home_require_alert_login_age_verification_universe": "로그인 및 성인인증이 필요한 서사예요.",
  "chat.home_require_alert_login_age_verification_scene": "로그인 및 성인인증이 필요한 테마예요.",
  "chat.home_require_alert_age_verification_character": "성인인증이 필요한 캐릭터예요.",
  "chat.home_require_alert_age_verification_universe": "성인인증이 필요한 서사예요.",
  "chat.home_require_alert_age_verification_scene": "성인인증이 필요한 테마예요.",
  "chat.modify_modal_select_public_description": "선택하신 서사/테마가 비공개로 설정되어 있어 공개 캐릭터로 수정할 수 없어요.<br/>공개된 서사/테마를 선택해 주세요.",
  "chat.rewards_convert_bubbles_button": "포인트전환하기",
  "chat.rewards_convert_bubbles_modal_title": "포인트 전환하기",
  "chat.rewards_convertible_bubbles": "전환 가능 포인트",
  "chat.rewards_bubbles_to_convert": "전환 신청 포인트",
  "chat.rewards_convert_bubbles_description_calculated": "* 전환 가능 포인트는 출금 가능 수익에서 세금 3.3%를 정산한 값입니다.",
  "chat.rewards_convert_bubbles_description_refund": "한 번 전환되어 차감된 포인트는 신청 취소 혹은 환불이 불가능합니다. (여신전문금융업법 제70조의제3항제2호에 의거)",
  "chat.rewards_convert_bubbles_description_units": "포인트 전환은 1,000포인트 단위로 가능하며, 신청 즉시 차감됩니다.",
  "chat.rewards_convert_bubbles_alert_units": "전환은 1,000포인트 단위로 가능해요.",
  "chat.rewards_convert_bubbles_alert_limit": "전환은 한 번에 150만포인트까지 가능해요.",
  "chat.rewards_notification_profit_application": "수익 출금 접수 안내",
  "chat.rewards_notification_subtitle_first": "안녕하세요. 크리에이터님, 팅글입니다. ",
  "chat.rewards_notification_subtitle_second": "수익 출금 결과에 대해 알려드립니다.",
  "chat.rewards_notification_profit_application_description": "아래와 같이 수익 출금이 접수되었습니다.",
  "chat.rewards_notification_request_amount": "신청금액",
  "chat.rewards_notification_request_date": "출금 신청일",
  "chat.rewards_notification_withdrawal_date": "출금(예정)일",
  "chat.rewards_notification_status": "상태",
  "chat.rewards_notification_pending": "대기",
  "chat.rewards_notification_completed": "완료",
  "chat.rewards_notification_rejected": "거절",
  "chat.rewards_notification_hold": "보류",
  "chat.rewards_notification_deposit_amount": "입금액",
  "chat.rewards_notification_note": "비고",
  "chat.rewards_notification_deposit_tax": "입금액은 사업소득 (3.3%) 공제 후 금액입니다.",
  "chat.rewards_notification_contact_us": "본 안내메일 내용에 대하여 추가로 궁금하신 사항이 있으시면 고객센터 문의하기를 통해 문의해 주세요. 감사합니다.",
  "chat.rewards_notification_profit_completion": "수익 출금 완료 안내",
  "chat.rewards_notification_profit_completion_description": "아래와 같이 수익 출금이 완료되었습니다.",
  "chat.rewards_notification_profit_reject": "수익 출금 거절 안내",
  "chat.rewards_notification_profit_reject_description": "아쉽게도 이번 출금 요청은 거절 처리되었습니다.",
  "chat.rewards_notification_profit_reject_reasons": "출금 거절은 아래와 같은 사유가 발생할 시 거절됩니다.",
  "chat.rewards_notification_profit_reject_reasons_copyright": "캐릭터/서사/테마가 저작권을 위반한 경우",
  "chat.rewards_notification_profit_reject_reasons_policy": "기타 팅글 정책을 위반한 경우",
  "chat.rewards_notification_profit_reject_amount": "거절 처리된 금액은 {{int_amount}}원입니다.",
  "chat.rewards_notification_profit_reject_amount_description": "해당 금액은 출금 가능 금액에 재반영되며, 문제가 해결된 이후 다시 출금 신청하실 수 있습니다.",
  "chat.rewards_notification_profit_hold": "수익 출금 보류 안내",
  "chat.rewards_notification_profit_hold_description": "아쉽게도 이번 출금 신청은 보류 처리되었습니다.",
  "chat.rewards_notification_profit_hold_reasons": "출금 보류는 아래와 같은 사유가 발생할 시 보류됩니다.",
  "chat.rewards_notification_profit_hold_amount": "보류 처리된 금액은 {{int_amount}}원입니다.",
  "chat.rewards_notification_conversion_completion": "포인트 전환하기 완료 안내",
  "chat.rewards_notification_conversion_completion_description": "아래와 같이 포인트 전환하기가 완료되었습니다.",
  "chat.rewards_notification_conversion_amount": "포인트 전환 신청 금액",
  "chat.rewards_notification_conversion_date": "포인트 전환일",
  "chat.rewards_notification_conversion_number": "지급된 포인트 수",
  "chat.rewards_notification_conversion_tax": "신청 금액에 사업소득 (3.3%) 공제 후 포인트가 지급됩니다.",
  "chat.rewards_top_sales_monthly": "{{int_month}}월 매출 TOP",
  "chat.rewards_profit_sharing_terms": "창작자 이용약관",
  "chat.rewards_terms_of_service": "이용약관",
  "chat.rewards_privacy_policy": "개인정보처리방침",
  "chat.rewards_operational_policy": "운영정책",
  "chat.rewards_juvenile_protection_policy": "청소년보호정책",
  "chat.rewards_verify_identify_email_account": "계좌 인증을 위해 본인 인증 및 이메일 인증을 먼저 진행해주세요.",
  "charging_stn_free_modal_allow_web_tracking_title": "웹 추적 허용 동의",
  "charging_stn_free_modal_allow_web_tracking_description": "웹 추적을 위한 광고 식별자를 사용하도록<br/>허용하시겠습니까?",
  "charging_stn_free_modal_allow_web_tracking_allow": "동의",
  "charging_stn_free_modal_allow_web_tracking_decline": "거절",
  "chat.rewards_currency_krw": "(원)",
  "chat.rewards_confirmation_email": "전환 내역은 이메일로 안내드립니다.",
  "chat.rewards_account_holder": "예금주",
  "chat.rewards_bank": "은행",
  "chat.rewards_account_number": "계좌번호",
  "chat.rewards_account_info_update": "계좌 정보 변경",
  "chat.rewards_legal_responsibility": "타인의 명의를 도용하거나 본인의 개인 정보가 아닐 경우 법적 책임을 다할 것에 동의합니다.",
  "chat.rewards_real name_id": "본인 인증 명의와 동일한 실명을 입력해 주세요.",
  "chat.rewards_digit_number": "-' 없이 숫자 13자리를 입력해 주세요.",
  "chat.rewards_only_number": "-' 없이 숫자만 입력해 주세요.",
  "chat.rewards_account_holder_name_description": "예금주명은 이름과 동일해야 해요.",
  "chat.rewards_verify_button": "인증하기",
  "chat.rewards_account_verification": "계좌 인증",
  "chat.rewards_agree_personal_information": "<link1>개인 정보 수집 및 이용</link1>에 동의합니다.",
  "chat.rewards_available_withdrawal_amount": "출금 가능 금액",
  "chat.rewards_withdrawal_request_amount": "출금 신청 금액",
  "chat.rewards_withdrawal_amount_deduction": "* 출금 가능 금액은 출금 가능 수익에서 세금 3.3%를 정산한 값입니다.",
  "chat.rewards_withdrawal_increments": "출금은 10,000원 단위로 가능하며, 신청 즉시 차감됩니다.",
  "chat.rewards_requests_made_date": "당월 15일 이전에 출금 신청한 금액은 당월 25일에 입금되고, 당월 15일 혹은 그 이후에 신청한 금액은 익월 25일 입금됩니다. 입금 완료 시 이메일로 안내드리겠습니다.",
  "chat.rewards_withdrawal_request_cancel": "취소",
  "chat.rewards_withdrawal_request_submit": "신청하기",
  "chat.rewards_modal_reclaimed": "비공개 처리된 캐릭터/서사/테마가 있어 수익의 일부가 회수되었습니다. 궁금하신 사항은 <link1>고객센터 문의하기</link1>로 문의해 주세요.",
  "chat.rewards_modal_reclaimed_button": "확인",
  "chat.rewards_currency_bubbles_zero": "포인트",
  "chat.rewards_currency_bubbles_one": "포인트",
  "chat.rewards_currency_bubbles_other": "포인트",
  "chat.rewards_withdrawal_title": "출금 신청하기",
  "chat.rewards_withdrawal_currency_krw": "원",
  "chat.rewards_agree_legal_terms": "법적 책임에 동의해 주세요.",
  "chat.rewards_select_bank": "은행을 선택해 주세요.",
  "chat.rewards_correct_rrn": "정확한 주민등록번호를 입력해 주세요.",
  "chat.rewards_consent_collect_personal_info": "개인 정보 수집 및 이용에 동의해 주세요.",
  "chat.rewards_enter_bank_code": "은행 코드를 입력해 주세요.",
  "chat.rewards_bubble_conversion_verify_complete": "본인 인증과 이메일 인증, 계좌 인증을 모두 완료 후 전환 신청이 가능해요",
  "chat.rewards_withdrawal_verify_complete": "본인 인증과 이메일 인증, 계좌 인증을 모두 완료 후 출금 신청이 가능해요",
  "chat.rewards_account_verification_help_text": "계좌 인증을 위해 본인 인증 및 이메일 인증을 먼저 진행해주세요.",
  "chat.rewards_modal_unsaved_content_title": "저장하지 않은 내용이 있어요.",
  "chat.rewards_modal_unsaved_content_description": "작성된 정보가 모두 사라져요.<br/>그래도 나가시겠어요?",
  "chat.rewards_modal_unsaved_content_cancel": "취소",
  "chat.rewards_modal_unsaved_content_back": "나가기",
  "chat.rewards_withdrawal_request_completed": "출금 신청이 완료되었습니다.",
  "chat.rewards_withdrawal_request_failed": "출금 신청이 실패했습니다.",
  "chat.rewards_bubble_conversion_request_completed": "전환 신청이 완료되었습니다.",
  "chat.rewards_bubble_conversion_request_failed": "전환 신청이 실패했습니다.",
  "chat.rewards_total_revenue_time_update_alert_title": "누적 수익 업데이트 주기 변경",
  "chat.rewards_total_revenue_time_update_alert_description": "시스템 개선 및 안정화를 위해 하루 1회<br/>24시간 기준으로 업데이트 되었습니다.<br/><br/>이용에 참고 부탁드립니다.",
  "chat.rewards_total_revenue_time_update_alert_button1": "다시 보지 않기",
  "chat.rewards_total_revenue_time_update_alert_button2": "확인",
  "chat.rewards_total_revenue_time_update_tooltip": "하루 1회, 24시간 기준으로 금액이 갱신됩니다.",
  "chat.rewards_no_transferable_alert_title": "[9/26~9/30]<br/>포인트 전환 일시 중단 안내",
  "chat.rewards_no_transferable_alert_description": "10월 초 원활한 소득세 신고 및 정산을 위해 9월 26일 00:00부터 9월 30일 23:59까지 포인트 전환 서비스가 일시적으로 중단됩니다.",
  "chat.rewards_no_transferable_alert_ok_button": "확인",
  "chat.content_moderation_word_create_validation_message": "부적절한 단어가 포함되어 있습니다. {{string_words}}",
  "chat.content_moderation_word_create_failed_message": "부적절한 단어가 포함되어 있습니다. 수정 후 다시 시도해 주세요.",
  "chat.content_moderation_word_multi_image_error_message": "이미지 {{int_imageNumbers}}에 부적절한 단어가 포함되어 있습니다.",
  "chat.content_moderation_word_multi_image_validation_message": "부적절한 단어가 포함되어 있습니다. {{string_words}}",
  "chat.content_moderation_word_conversation_toast": "부적절한 단어가 포함되어 있습니다.<br/>{{string_words}}",
  "chat.content_moderation_word_create_failed_message_button": "확인",
  "chat.content_moderation_word_keyword_book_error_message": "키워드북 {{int_keywordbookNumbers}}에 부적절한 단어가 포함되어 있습니다.",
  "chat.home_sidebar_support_center": "고객센터",
  "chat.support_center_top_title": "FAQ",
  "chat.support_center_unresolved_issues": "여전히 해결되지 않는 문제가 있나요?",
  "chat.support_center_contact_button": "문의하기",
  "chat.support_center_contact_history_button": "문의 내역",
  "chat.support_center_contact_submit_alert": "문의가 접수되었어요.",
  "chat.notification_contact_title": "문의하기",
  "chat.notification_contact_reply": "문의에 대한 답변이 완료되었어요. 72시간 내에 추가 문의가 없으실 경우 문의가 종료됩니다.",
  "chat.notification_contact_reply_additional_inquiry": "추가 문의에 대한 답변이 완료되었어요. 72시간 내에 추가 문의가 없으실 경우 문의가 종료됩니다.",
  "chat.support_center_contact_information_title": "1:1 문의 안내",
  "chat.support_center_contact_information_description1": "답변은 평일 09:00~17:00 사이에 순차적으로 진행됩니다.",
  "chat.support_center_contact_information_description2": "동일한 문의에 대해 추가로 궁금하신 점이 있으시다면 '추가 문의하기'를 통해 이어서 남겨주세요.",
  "chat.support_center_contact_information_description3": "문의가 구체적일수록 보다 정확한 안내가 가능합니다.",
  "chat.support_center_contact_information_description4": "추가 문의는 최대 4회까지 등록하실 수 있으며, 다른 유형의 내용은 새로운 문의로 등록해주시기 바랍니다",
  "chat.support_center_contact_category_title": "분류",
  "chat.support_center_contact_category_placeholder": "문의 내용 선택",
  "chat.support_center_contact_user_environment_title": "사용자 환경",
  "chat.support_center_contact_user_environment_app": "App",
  "chat.support_center_contact_user_environment_web": "Web",
  "chat.support_center_contact_user_environment_manual": "직접 입력",
  "chat.support_center_contact_user_environment_placeholder": "사용자 환경을 선택해 주세요.",
  "chat.support_center_contact_inquiry_title": "제목",
  "chat.support_center_contact_inquiry_placeholder": "문의 제목을 입력해주세요.",
  "chat.support_center_contact_inquiry_detail": "문의 내용",
  "chat.support_center_contact_inquiry_detail_placeholder": "문의하실 내용을 편하게 말씀해주세요!",
  "chat.support_center_contact_add_image_optional": "이미지 첨부(선택)",
  "chat.support_center_contact_add_image_format": "JPEG/PNG/WEBP/GIF",
  "chat.support_center_contact_add_image_size": "최대 10MB",
  "chat.support_center_contact_input_category_alert": "분류를 선택해 주세요",
  "chat.support_center_contact_user_environment_input_alert": "사용자 환경을 선택해 주세요",
  "chat.support_center_contact_subject_title_input_alert": "제목을 입력해 주세요",
  "chat.support_center_contact_subject_detail_input_alert": "내용을 입력해 주세요",
  "chat.support_center_contact_status_inquiry_completed": "등록완료",
  "chat.support_center_contact_status_reply_completed": "답변완료",
  "chat.support_center_contact_status_reply_closed": "문의종료",
  "chat.support_center_contact_view": "상세보기",
  "chat.support_center_contact_view_no_inquiry_history": "문의 내역이 없어요.",
  "chat.support_center_contact_view_success_inquiry_message": "문의가 정상적으로 등록되었어요.<br/>현재 접수해주신 내용을 확인 중이며, 빠른 시일 내에 답변드릴게요.<br/>답변은 평일 09:00~17:00 사이에 순차적으로 진행됩니다.",
  "chat.support_center_contact_view_inquiry_delete_modal": "문의를 취소하시겠어요?",
  "chat.support_center_contact_view_inquiry_delete_modal_description": "문의한 내용이 삭제됩니다.",
  "chat.support_center_contact_modify": "문의 수정",
  "chat.support_center_contact_unresolved_issue_alert_modal": "아직 문제가 해결되지 않으셨나요?",
  "chat.support_center_contact_unresolved_issue_alert_modal_description1": "추가 문의하기로 계속 질문하실 수 있어요!",
  "chat.support_center_contact_unresolved_issue_alert_modal_description2": "추가 문의하기는 최대 4번까지 가능해요!",
  "chat.support_center_contact_unresolved_issue_alert_modal_description3": "다른 종류의 문의는 새로 접수해주셔야 정확하게 도와드릴 수 있어요!",
  "chat.support_center_contact_unresolved_issue_alert_modal_button": "추가 문의",
  "chat.support_center_contact_response_check_title": "문의에 대한 답변이 도움이 되셨나요?",
  "chat.support_center_contact_response_additional_inquiry_button": "추가 문의하기",
  "chat.support_center_contact_response_closed_inquiry_button": "문의 종료하기",
  "chat.support_center_contact_previous_inquiry_title": "이전 문의와 답변",
  "chat.support_center_contact_hide_button": "접기",
  "chat.support_center_contact_see_more_button": "자세히보기",
  "chat.support_center_contact_success_inquiry_closed_toast": "문의가 정상적으로 종료되었어요.",
  "chat.support_center_contact_resolved_inquiry_message": "해결된 문의사항입니다.",
  "chat.support_center_contact_fail_submit_toast": "문의 등록에 실패하였습니다. 다시 시도해주세요.",
  "chat.support_center_contact_fail_update_toast": "문의 수정에 실패하였습니다. 다시 시도해주세요.",
  "chat.support_center_contact_fail_additional_submit_toast": "추가 문의 등록에 실패하였습니다. 추가 문의는 4회까지만 가능해요.",
  "chat.support_center_contact_fail_closed_toast": "문의 종료에 실패하였습니다. 다시 시도해주세요.",
  "chat.support_center_contact_fail_cancel_toast": "문의 취소에 실패하였습니다. 다시 시도해주세요.",
  "chat.support_center_contact_user_environment_manual_placeholder": "사용자 환경을 직접 입력해주세요.",
  "chat.support_center_contact_user_environment_manual_input_alert": "사용자 환경을 직접 입력해주세요.",
  "chat.support_center_contact_cancel_success_toast": "문의 취소가 완료되었어요.",
  "chat.support_center_contact_inquiry_complete_success_toast": "문의가 정상적으로 종료되었어요.",
  "chat.support_center_contact_view_inquiry_support_team": "팅글 고객센터",
  "chat.support_center_contact_enter_title_input_alert": "제목은 50자 이내로 입력해주세요.",
  "chat.support_center_contact_view_inquiry_cancel_inquiry": "문의 취소",
  "chat.support_center_contact_view_inquiry_attached_image": "첨부한 이미지",
  "statistic_list_title": "통계",
  "statistic_domestic": "국내",
  "statistic_international": "해외",
  "statistic_identity_verification_modal_title": "통계는 본인인증 후 확인할 수 있습니다.",
  "statistic_payment_history_rewards_button": "리워드",
  "statistic_period_record_title": "최근 <span>{{string_time}}</span> {{string_name}}님의 {{string_assets}}에서 나눈 총 대화 수는 <span>'{{int_numbers}}챗'</span>이에요!",
  "statistic_all_record_title": "{{string_name}}님의 {{string_assets}}에서 나눈 총 대화 수는 <span>'{{int_numbers}}챗'</span>이에요!",
  "statistic_help_information": "집계는 1시간 주기로 갱신됩니다.<br/>100 챗 미만의 애셋은 집계되지 않아요.",
  "statistic_history_no_record": "100 챗 이상의 {{string_name}}만 노출돼요.",
  "manual_identity_verification": "본인 인증",
  "manual_identity_verification_notify1": "개인 정보 수집 및 이용에 동의합니다.",
  "manual_identity_verification_notify2": "타인의 명의를 도용하거나 본인의 개인 정보가 아닐 경우 법적 책임을 다할 것에 동의합니다.",
  "manual_identity_verification_id_card": "주민등록증",
  "manual_identity_verification_id_card_tooltip": "신분증은 주민등록증만 인정됩니다.",
  "manual_identity_verification_id_card_file_format": "JPEG/PNG/WEBP/GIF",
  "manual_identity_verification_id_card_file_size": "최대 10MB",
  "manual_identity_verification_id_card_name_placeholder": "이름",
  "manual_identity_verification_id_card_name_guide_th": "이름은 태국어 또는 영어로 입력해 주세요.",
  "manual_identity_verification_id_card_number_placeholder": "주민등록번호",
  "manual_identity_verification_id_card_address_placeholder": "주소",
  "manual_identity_verification_id_card_address_guide": "주민등록상 주소와 일치하지 않을 경우 인증에 실패할 수 있습니다.",
  "manual_identity_verification_id_card_email_placeholder": "이메일",
  "manual_identity_verification_id_card_birthdate_placeholder": "생년월일",
  "manual_identity_verification_submit_button": "제출하기",
  "manual_identity_verification_request_complete_title_modal": "본인 인증 신청 완료",
  "manual_identity_verification_request_complete_description_modal": "제출해주신 내용은 영업일 기준 3일 이내에<br/>확인 후 처리됩니다.",
  "manual_identity_verification_ok_button": "확인",
  "manual_identity_verification_pending_title_modal": "본인 인증 대기중",
  "manual_identity_verification_pending_description_modal": "제출하신 자료가 정상적으로 접수되었으며,<br/>검토 후 영업일 기준 3일 이내 처리됩니다.",
  "manual_identity_verification_verifying_description": "이미 본인 인증 요청된 명의입니다.",
  "manual_identity_verification_complete_title_modal": "본인 인증 완료",
  "manual_identity_verification_complete_description_modal": "{{string_date}}에 본인 인증이<br/>완료되었습니다.",
  "manual_identity_verification_waiting_menu": "대기중",
  "web_tracking_consent_alert_modal_title": "웹 추적 허용 동의",
  "web_tracking_consent_alert_modal_description": "웹 추적을 위한 광고 식별자를 사용하도록<br/>허용하시겠습니까?",
  "web_tracking_consent_alert_modal_decline_button": "거절",
  "web_tracking_consent_alert_modal_allow_button": "동의",
  "chat.contest_page_submit_button": "캐릭터 제출하러 가기",
  "chat.contest_modal_title": "공모전 제출",
  "chat.contest_modal_description": "참여조건에 맞는 캐릭터만 목록에 표시됩니다.",
  "chat.contest_modal_tooltip_title": "참여 조건",
  "chat.contest_modal_tooltip_description1": "{{int_year}}년 {{int_month}}월 {{int_day}}일 {{int_hour}}시 {{int_minute}}분 이후 최초공개한 캐릭터",
  "chat.contest_modal_tooltip_description2": "멀티이미지 {{int_number}}개 이상인 캐릭터",
  "chat.contest_modal_submitted_character": "제출 완료",
  "chat.contest_modal_character_empty": "조건에 맞는 캐릭터가 없어요.",
  "chat.contest_modal_production_grant_title": "제작지원금을 신청합니다.",
  "chat.contest_modal_production_grant_description1": "총 {{int_number}}개 이상의 캐릭터 제출 시 신청 가능합니다.",
  "chat.contest_modal_production_grant_description2": "캐릭터 제출 시 유의사항에 동의한 것으로 간주됩니다.",
  "chat.contest_modal_submit_button": "제출하기",
  "chat.contest_modal_production_grant_title_complete": "제작지원금 신청이 완료되었습니다.",
  "chat.contest_modal_submit_alert_title": "캐릭터를 제출하시겠어요?",
  "chat.contest_modal_submit_alert_description": "제출 후에는 취소할 수 없어요.",
  "chat.contest_modal_submit_successful_title": "캐릭터 제출이 완료되었습니다.",
  "chat.contest_submission_period_ended_alert_title": "제출 기간이 종료되었습니다.",
  "chat.information_selected_persona_title": "현재 페르소나",
  "chat.information_selected_persona_login_to_use": "로그인 후 이용",
  "chat.information_conversation_mode_title": "대화 모드",
  "chat.information_conversation_mode_messenger": "채팅형",
  "chat.information_persona_bottomsheet_title": "어떤 페르소나로 대화할까요?",
  "chat.information_persona_bottomsheet_description": "페르소나 없이도 바로 대화할 수 있어요",
  "chat.information_conversation_mode_bottomsheet_title": "어떤 방식으로 대화할까요?",
  "chat.information_conversation_mode_bottomsheet_description": "소설형으로 몰입감있는 대화를,<br/>채팅형으로 쉽고 부담없는 대화를 즐겨 보세요",
  "chat.information_conversation_mode_bottomsheet_example1": "캐릭터가 인사했다.",
  "chat.information_conversation_mode_bottomsheet_example2": "안녕하세요",
  "chat.information_conversation_mode_bottomsheet_example3": "유저가 답했다.",
  "chat.conversation_menu_my_balance": "내 재화",
  "chat.conversation_long_term_memory_current_memory": "현재 기억",
  "chat.conversation_long_term_memory_current_memory_title": "현재 대화방에 적용 중인 기억이에요",
  "chat.conversation_long_term_memory_current_memory_description": "설정한 요약 주기마다 지금까지 나눈 대화를 자동으로 요약해 업데이트해요.",
  "chat.conversation_long_term_memory_current_memory_auto_update_toggle": "자동 업데이트",
  "chat.conversation_long_term_memory_current_memory_next_update_label": "다음 업데이트까지",
  "chat.conversation_long_term_memory_current_memory_turns_remaining": "{{int_number}}턴 남음",
  "chat.conversation_long_term_memory_history_description1": "원하는 기억을 선택해 현재 기억에 불러올 수 있어요.",
  "chat.conversation_long_term_memory_history_description2": "기억이 20개를 초과하면 오래된 기억부터 삭제돼요. ({{int_numbers}}/20)",
  "chat.conversation_long_term_memory_summary_settings_title": "캐릭터의 기억이 요약되는 방식을 설정해 보세요",
  "chat.conversation_long_term_memory_summary_settings_description": "캐릭터의 기억을 얼마나 자주, 얼마나 많이<br/>그리고 어떤 기준으로 요약할지 설정할 수 있어요.",
  "chat.conversation_long_term_memory_summary_settings_interval_caption": "{{int_numbers}}턴마다 기억을 요약해요.",
  "chat.conversation_long_term_memory_summary_settings_length_caption": "기억을 {{int_numbers}}자까지 요약해요.",
  "chat.conversation_long_term_memory_summary_settings_summary_instructions": "요약 지침",
  "chat.conversation_long_term_memory_summary_settings_guideline_placeholder": "요약 지침을 입력해 주세요.",
  "chat.conversation_long_term_memory_summary_settings_auto_guideline_info": "기억을 요약하는 지침을 자동으로 설정해요.",
  "chat.conversation_output_environment_header_title": "출력되는 대화의 품질과 분량을 설정해 보세요",
  "chat.conversation_output_environment_header_description": "기억력과 출력량이 높을수록 소모되는 재화가 많아져요.",
  "chat.conversation_output_environment_memory_title": "기억력",
  "chat.conversation_output_environment_memory_description": "캐릭터가 최근 대화를 얼마나 많이 기억할지 설정해요.",
  "chat.conversation_output_environment_memory_limit_caption": "{{int_numbers}}턴까지 기억해요.",
  "chat.conversation_output_environment_memory_warning_description": "기억력이 요약주기보다 짧아 캐릭터가 중요 내용을 잊을 수 있어요.",
  "chat.conversation_output_environment_response_length_title": "출력량",
  "chat.conversation_output_environment_response_length_description": "캐릭터가 한 번에 얼마나 길게 답변할지 설정해요.",
  "chat.conversation_output_environment_response_length_short_button": "적게",
  "chat.conversation_output_environment_response_length_medium_button": "보통",
  "chat.conversation_output_environment_response_length_long_button": "많게",
  "chat.conversation_output_environment_response_length_short_description": "지문과 대사가 핵심 위주로 간결하게 출력돼요.",
  "chat.conversation_output_environment_response_length_medium_description": "지문과 대사가 적절한 길이로 균형 있게 출력돼요.",
  "chat.conversation_output_environment_response_length_long_description": "지문과 대사가 섬세한 묘사로 풍성하게 출력돼요.",
  "chat.conversation_free_limit_modal_title1": "더 뛰어난 모델, 더 깊은 몰입감",
  "chat.conversation_free_limit_modal_description1": "흐름을 끊는 광고 없이,<br/>이야기에 온전히 빠져들어 보세요.",
  "chat.conversation_free_limit_modal_miru_description": "정교한 추론으로 몰입도 높은 서사를 구현하는 모델",
  "chat.conversation_free_limit_modal_ads_title": "광고 제거",
  "chat.conversation_free_limit_modal_persona_title": "페르소나 확장",
  "chat.conversation_free_limit_modal_persona_description": "최대 {{string_chars}}자",
  "chat.conversation_free_limit_modal_usernote_title": "유저노트 확장",
  "chat.conversation_free_limit_modal_usernote_description": "최대 {{string_chars}}자",
  "chat.conversation_free_limit_modal_memory_title": "장기기억 확장",
  "chat.conversation_free_limit_modal_memory_description": "최대 {{string_chars}}자, 요약 주기 커스텀",
  "chat.conversation_free_limit_modal_output_title": "출력 설정 커스텀",
  "chat.conversation_free_limit_modal_output_description": "기억력, 출력량 조절",
  "chat.conversation_free_limit_modal_upgrade_button": "{{string_signature}}로 변경",
  "chat.conversation_free_limit_modal_ad_button": "광고 보고 무료 대화하기",
  "chat.conversation_convert_to_free_modal_title_suffix": "{{string_modelname}}로 대화가 진행됩니다",
  "chat.conversation_convert_to_free_modal_subtitle": "일부 기능의 범위가 축소돼요",
  "chat.conversation_convert_to_free_modal_persona_from": "페르소나 {{string_chars}}자",
  "chat.conversation_convert_to_free_modal_persona_to": "→ {{string_chars}}자",
  "chat.conversation_convert_to_free_modal_usernote_from": "유저노트 {{string_chars}}자",
  "chat.conversation_convert_to_free_modal_usernote_to": "→ 사용 불가",
  "chat.conversation_convert_to_free_modal_memory_from": "장기기억 {{string_chars}}자",
  "chat.conversation_convert_to_free_modal_memory_to": "→ {{string_chars}}자",
  "chat.conversation_convert_to_free_modal_output_settings_from": "출력 환경 설정 가능",
  "chat.conversation_convert_to_free_modal_output_settings_to": "→ 변경 불가",
  "chat.conversation_convert_to_free_modal_description1": "입력된 페르소나와 유저노트의 내용은 삭제되지 않지만 실제 대화에는 축소된 글자 수 만큼만 적용됩니다.",
  "chat.conversation_convert_to_free_modal_description2": "장기기억은 현재 적용된 요약 주기가 끝나면 변경된 설정 값이 적용됩니다.",
  "chat.conversation_convert_to_free_modal_confirm_button": "그래도 변경하기",
  "chat.conversation_free_model_chip": "무료",
  "chat.conversation_free_model_banner_title": "무료 모델을 사용 중입니다",
  "chat.conversation_free_model_banner_persona_limit_description": "무료 모델 사용 중 페르소나는 {{string_chars}}자까지만 적용됩니다.",
  "chat.conversation_free_model_banner_usernote_limit_description": "무료 모델 사용 중 유저노트는 {{string_chars}}자까지만 적용됩니다.",
  "chat.conversation_free_model_banner_memory_limit_description": "무료 모델 사용 중 장기기억은 {{string_chars}}자까지만 적용됩니다.",
  "chat.conversation_free_model_banner_feature_limit_description": "무료 모델 사용 중 기능이 제한됩니다.",
  "chat.popup_model_my_bubbles_label": "보유 포인트",
  "chat.popup_model_topup_button": "충전",
  "chat.bottomsheet_model_title": "AI 모델 선택",
  "chat.conversation_persona_no_set_persona_label": "설정된 페르소나가 없습니다.",
  "chat.conversation_persona_no_set_persona_description1": "선택된 페르소나가 없어요.",
  "chat.conversation_persona_no_set_persona_description2": "마이페이지에 등록된 닉네임으로 대화에 참여합니다.",
  "chat.conversation_paid_model_chip": "유료",
  "chat.bottomsheet_model_estimated_bubbles": "예상 {{int_value}} 포인트",
  "chat.conversation_output_environment_memory_paid_only_description": "기억력 조절 기능은 유료 모델 사용 중에만 조절할 수 있어요.",
  "chat.conversation_output_environment_response_length_paid_only_description": "출력량 조절 기능은 유료 모델 사용 중에만 조절할 수 있어요.",
  "chat.conversation_long_term_memory_summary_length_title": "요약 글자 수",
  "chat.conversation_long_term_memory_summary_length_description": "글자 수 초과 시 압축되어 히스토리에 저장돼요.",
  "chat.conversation_long_term_memory_summary_settings_custom_guideline_info": "기억을 요약하는 지침을 직접 입력해요.",
  "chat.conversation_long_term_memory_summary_interval_paid_only_description": "요약 주기 조절 기능은 유료 모델 사용 중에만 조절할 수 있어요.",
  "chat.conversation_long_term_memory_summary_length_paid_only_description": "요약 글자 수 조절 기능은 유료 모델 사용 중에만 조절할 수 있어요.",
  "chat.conversation_no_model_label": "모델 없음",
  "chat.free_model_ad_unavailable_toast": "광고를 불러올 수 없어요. 잠시 후 다시 시도해 주세요.",
  "chat.free_model_ad_loading_title": "광고 준비 중",
  "chat.free_model_ad_loading_desc": "잠시만 기다려 주세요...",
  "chat.conversation_free_limit_modal_ad_preparing_button": "광고 준비 중",
  "chat.information_conversation_mode_bottomsheet_character": "캐릭터",
  "chat.conversation_user_note_disabled_modal_title": "Weave 모델로는 이용할 수 없습니다.",
  "chat.conversation_user_note_disabled_modal_description": "다른 모델을 선택해주세요",
  "chat.creator_verification_create_not_verified_alert_description": "애셋을 만들기 위해서는 본인인증이 필요합니다.",
  "chat.creator_verification_create_not_verified_alert_identity_verify_button": "본인인증 하기",
  "chat.creator_verification_my_banner": "크리에이터 인증하고 현금 리워드 받으세요!",
  "chat.creator_verification_create_modal_description": "팅글 크리에이터 신청하고 현금 리워드 받으세요!",
  "chat.creator_verification_create_modal_view_benefits_button": "혜택 확인하기",
  "chat.creator_verification_verified_modal_description": "팅글의 크리에이터가 되셨습니다!",
  "chat.creator_verification_not_verified_modal_description": "크리에이터 지원 대상자가 아닙니다.",
  "chat.creator_verification_verified_modal_view_rewards_button": "리워드 보러가기",
  "chat.rewards_revenue_sharing_terms_agreement_title": "리워드 이용을 위하여 창작자 이용약관에 동의해주세요.",
  "chat.rewards_revenue_sharing_terms_agreement_checkbox": "창작자 이용약관에 동의합니다.",
  "chat.create_image_ai_generated_image_checkbox_description": "AI 생성 이미지",
  "chat.conversation_ai_generated_banner": "이 대화는 AI를 통해 생성된 내용입니다.",
  "dmm.point": "DMM 포인트",
  "dmm.charge_button": "충전하기",
  "dmm.bubble": "포인트",
  "dmm.point_owned": "보유 DMM 포인트",
  "dmm.not_enough_point_alert_description": "DMM 포인트가 부족해서 채팅을 계속할 수 없어요.",
  "dmm.not_enough_point_alert_charge_guide": "DMM 포인트를 충전하고 다시 시도해주세요.",
  "weave.daily_limit_indicator": "무료 {{int_current}}/{{int_max}}회",
  "weave.daily_limit_indicator_unlimited": "무료 ∞",
  "weave.daily_recharge_note": "매일 자정 충전",
  "weave.free_limit_reached_title": "무료 대화를 모두 사용했어요",
  "weave.limit_reached_alert_title": "Weave 모델의 일일 사용 횟수를 모두 사용했어요",
  "weave.limit_reached_alert_body": "Weave Pass로 무제한 대화를 즐겨보세요",
  "weave.limit_reached_alert_switch_to_model_cta": "스파크로 변경하고 대화하기",
  "weave.limit_reached_reset_notice": "무료 대화는 내일 자정에 다시 충전됩니다.",
  "weave.pass_product_name": "Weave Pass",
  "weave.pass_product_30days_title": "Weave Pass 30일",
  "weave.pass_product_1day_title": "Weave Pass 1일",
  "weave.pass_price_dmm": "{{int_numbers}} DMM 포인트",
  "weave.pass_benefit_1": "횟수 제한 없이 위브 무제한 대화",
  "weave.pass_purchase_confirm": "{{string_productName}}을(를) 구매할까요?",
  "weave.pass_purchase_success": "구매가 완료되었습니다!",
  "weave.pass_purchase_fail": "구매가 실패하였습니다. 다시 시도해주세요.",
  "weave.pass_purchase_insufficient_title": "DMM 포인트가 부족해서 {{string_productName}} 구매에 실패했어요",
  "weave.pass_purchase_insufficient_body": "DMM 포인트 충전 후 상품을 구매해 보세요.",
  "weave.pass_purchase_insufficient_current": "현재 DMM 포인트",
  "weave.pass_purchase_insufficient_required": "구매에 필요한 DMM 포인트",
  "weave.pass_purchase_insufficient_shortage": "부족한 DMM 포인트",
  "weave.pass_purchase_insufficient_cta": "충전하러 가기",
  "weave.pass_purchase_duplicate": "이미 사용 중인 이용권이 있어요. {{string_productName}} 종료 후 구매할 수 있어요",
  "weave.pass_active_badge": "Weave Pass 이용 중",
  "weave.pass_expired_title": "Weave Pass가 종료되었습니다",
  "weave.pass_expired_body": "이번 대화부터 적용되던 혜택이 사라져요.<br/>이용권을 재구매하고 쾌적한 대화를 계속 이어가세요!",
  "pwa.common_later": "다음에 하기",
  "pwa.install_headline": "앱 설치 없이,<br/>홈 화면에서 바로 {{appName}}",
  "pwa.install_banner_cta_install": "홈 화면에 추가",
  "pwa.install_banner_cta_open_browser": "브라우저로 열기",
  "pwa.install_banner_cta_open_safari": "Safari로 열기",
  "pwa.install_banner_inapp_text": "원활한 이용을 위해<br/>{{appName}}을 브라우저에서 열어주세요",
  "pwa.install_banner_aria": "앱 설치 안내",
  "pwa.push_pre_title": "{{appName}}의 새로운 소식을<br/>알림으로 받아보세요",
  "pwa.push_pre_desc": "관심 캐릭터의 새 메시지와<br/>공모전·이벤트 소식을 알려드려요.",
  "pwa.push_pre_bullet_1": "이벤트·공지·신규 애셋 소식",
  "pwa.push_pre_bullet_2": "팔로우·좋아요·댓글·답글 등 활동 알림",
  "pwa.push_pre_bullet_3": "포인트·포션·이용권 등 재화 알림",
  "pwa.push_pre_confirm": "알림 받기",
  "pwa.install_steps_title": "설치 방법",
  "pwa.install_steps_ios_1": "Safari 브라우저 하단의 [공유] 버튼 선택",
  "pwa.install_steps_ios_2": "홈 화면에 [추가] 선택",
  "pwa.install_steps_ios_3": "오른쪽 상단의 [추가] 선택",
  "pwa.install_steps_aos_1": "우측 상단 메뉴(⋮) 선택",
  "pwa.install_steps_aos_2": "홈 화면에 추가 선택",
  "pwa.install_steps_aos_3": "추가 선택",
  "pwa.inapp_guide_title": "{{targetBrowser}}에서 열어주세요",
  "pwa.inapp_guide_desc": "링크를 복사해 {{targetBrowser}}에서 연 뒤,<br/>아래 순서대로 설치해 주세요",
  "pwa.inapp_guide_copy": "링크 복사",
  "pwa.inapp_guide_default_browser": "기본 브라우저",
  "pwa.install_qr_caption": "휴대폰 카메라로 QR을 스캔하고 다운로드 하세요.",
  "pwa.install_qr_desktop_cta": "PC에 바로가기 설치",
  "pwa.offline_message": "네트워크 상태가 불안정해요.<br/>잠시 후 다시 시도해주세요.",
  "pwa.offline_reload": "새로고침",
  "pwa.toast_copy_success": "링크를 복사했어요",
  "pwa.toast_copy_fail": "링크 복사에 실패했어요",
  "pwa.toast_desktop_install_unsupported": "이 브라우저에서는 바로 설치를 지원하지 않아요. 주소창의 설치 아이콘을 이용해 주세요.",
  "pwa.push_default_title": "알림",
  "login.start_with_kakao": "카카오로 시작하기",
  "login.start_with_google": "구글로 시작하기",
  "login.start_with_apple": "애플로 시작하기",
  "login.start_with_line": "라인으로 시작하기",
  "login.start_with_dmm": "DMM으로 시작하기",
  "chat.onboarding_conversation_watch_ad_alert": "계속 대화하려면 광고를 시청해주세요",
  "chat.onboarding_chat_load_error_modal_description": "이전 대화를 가져오지 못했어요. 다시 시도할까요?",
  "chat.onboarding_chat_load_error_modal_not_now_button": "나중에",
  "chat.onboarding_character_recommendation_title": "대화할 캐릭터를 골라보세요",
  "chat.onboarding_character_recommendation_button": "대화하기",
  "chat.onboarding_conversation_watch_ad_alert_button": "광고 보기",
  "chat.onboarding_login_title": "간편하게 로그인하고<br/>설레는 로맨스를 이어가세요!",
  "general.chat": "팅글",
  "general.chatlist": "대화",
  "chat.home_install_pwa_button": "바로 추가하기",
  "chat.home_install_app_description": "새 소식은 앱에서 먼저",
  "chat.custom_character_title": "플레이할 캐릭터를 선택하세요",
  "chat.custom_universe_title": "플레이할 서사를 선택하세요",
  "chat.custom_scene_title": "플레이할 테마를 선택하세요",
  "chat.custom_character_browse_button": "캐릭터 보러가기",
  "chat.custom_universe_browse_button": "서사 보러가기",
  "chat.custom_scene_browse_button": "테마 보러가기",
  "chat.information_selected_persona_and_mode_description": "{{string_naming}} 페르소나로 {{string_type}} 대화를 시작해요.",
  "chat.information_conversation_mode_bottomsheet_information": "대화방을 만든 뒤에는 바꿀 수 없어요",
  "chat.information_conversation_mode_character_line_story": "“캐릭터의 대사예요. 길고 자세하게 이야기를 들려줘요.\"",
  "chat.information_conversation_mode_character_narrative_story": "상황을 설명하는 부분이에요. 채팅형보다 더 상세하고 긴 답변을 줘요.",
  "chat.information_conversation_mode_user_line": "“당신의 대사예요.\"",
  "chat.information_conversation_mode_user_narrative": "내가 입력한 행동이에요.",
  "chat.information_conversation_mode_character_line_messenger": "“캐릭터의 대사에요. 메신저처럼 짧게 주고받아요.\"",
  "chat.information_conversation_mode_character_narrative_messenger": "상황을 설명하는 부분이에요. ",
  "chat.information_conversation_mode_messenger_bottomsheet_start_talk": "채팅형으로 바로 대화",
  "chat.information_conversation_mode_story_bottomsheet_start_talk": "소설형으로 바로 대화",
  "chat.information_bottomsheet_back": "선택하고 돌아가기",
  "chat.information_persona_bottomsheet_hint": "페르소나는 대화방 안에서도 변경할 수 있어요",
  "chat.information_persona_bottomsheet_start": "이 페르소나로 바로 대화",
  "chat.information_persona_edit_button": "수정",
  "chat.information_persona_delete_button": "삭제",
  "chat.information_detail_cta_description": "'{{persona}}' 페르소나로 '{{mode}}' 대화를 시작해요",
  "chat.information_multi_image": "멀티이미지",
  "chat.information_multi_image_count": "{{int_count}}개",
  "chat.information_creator_title": "제작자",
  "chat.information_reviews_count": "댓글 {{int_count}}개",
  "chat.information_replies_expand": "답글 {{int_count}}개 더보기",
  "chat.information_replies_collapse": "답글 {{int_count}}개 접기",
  "chat.information_reply_mention_button": "답글 달기",
  "chat.information_comment_pin_aria": "고정",
  "chat.information_comment_unpin_aria": "고정 해제",
  "chat.information_comment_edit_aria": "댓글 수정",
  "chat.information_reply_edit_aria": "답글 수정",
  "general.back_aria": "뒤로",
  "general.share_aria": "공유",
  "general.previous_aria": "이전",
  "chat.information_asset_nsfw": "팅글",
  "chat.bottomsheet_model_section_featured": "추천 라인업",
  "chat.bottomsheet_model_section_others": "전체 모델",
  "chat.bottomsheet_model_chip_etc": "기타",
  "chat.bottomsheet_model_own_model_label": "팅글 자체 모델",
  "chat.bottomsheet_model_changed_toast": "{{string_modelName}}(으)로 변경되었습니다",
  "chat.guest_popup_signup_headline": "숨겨진 내 취향 캐릭터 한가득!",
  "chat.guest_popup_signup_subline": "로그인하고 나만의 서사를 직접 만들어보세요",
  "chat.guest_popup_memory_headline": "지금 나가면 날 잊어버려요…",
  "chat.guest_popup_memory_subline": "로그인하고 나에 대해 기억하게 만들어봐요!",
  "chat.guest_popup_app_install_headline": "매번 검색해서 들어올 거야?",
  "chat.guest_popup_app_install_subline": "앱으로 홈 화면에 고정하고 1초 접속!",
  "chat.guest_popup_ad_removal_headline": "대화가 끊기는 게 싫다면?",
  "chat.guest_popup_ad_removal_subline": "가입하고 광고 제거로 무제한 몰입해보세요!",
  "chat.guest_popup_watch_ad_button": "광고 보고 무료로 대화하기",
  "chat.guest_popup_app_download_button": "앱 다운로드 하기",
  "chat.profile_my_password_current_label": "현재 비밀번호",
  "chat.profile_my_password_new_label": "새로 설정할 비밀번호",
  "chat.profile_my_status_verified": "인증됨",
  "chat.profile_my_status_unverified": "미인증",
  "chat.profile_my_status_password_set": "설정됨",
  "chat.profile_my_status_password_unset": "미설정",
  "chat.profile_my_edit_view_content_current_country_description": "선택된 현재 국가에서 만들어진 콘텐츠만 볼 수 있어요",
  "chat.profile_my_edit_view_content_all_countries_description": "서비스되는 모든 국가에서 만들어진 콘텐츠를 볼 수 있어요",
  "chat.creator_verification_my_banner_button": "크리에이터 등록",
  "chat.conversation_unsupported_feature_modal_title": "이 기능을 사용하고 싶다면?",
  "chat.conversation_unsupported_feature_modal_current_label": "현재",
  "chat.conversation_unsupported_feature_modal_description1": "<model>{{string_modelName}}</model> 모델에서는 지원하지 않는 기능이에요.",
  "chat.conversation_unsupported_feature_modal_description2": "다른 모델로 전환하고 더욱 다양한 기능들을 사용해보세요!",
  "profile.decorator_expired": "만료",
  "general.no_products": "구매할 수 있는 상품이 없어요.",
  "general.loading": "로딩 중",
  "profile.user_blocked_alert_message": "차단하면 해당 유저의 댓글이 더 이상 보이지 않게 돼요.<br/>정말 차단할까요?",
  "chat.profile_my_decorator_apply_button": "적용하기",
  "chat.profile_my_decorator_title": "데코터",
  "chat.rewards_mg_title": "별지기 리워드",
  "chat.rewards_mg_current_month_revenue_pre_tax": "당월 총 리워드 (세전)",
  "chat.rewards_mg_current_month_revenue_after_tax": "당월 총 리워드 (세후)",
  "chat.rewards_mg_settlement_period": "산정 기간",
  "chat.rewards_mg_payout_date": "당월분 지급 예정일",
  "chat.rewards_mg_previous_month_payout_date": "전월분 지급 예정일",
  "chat.rewards_mg_previous_month_revenue_pre_tax": "전월 확정 리워드 (세전)",
  "chat.rewards_mg_previous_month_revenue_after_tax": "전월 확정 리워드 (세후)",
  "chat.rewards_mg_contract_amount": "약정 MG",
  "chat.rewards_mg_shortfall": "MG 차액",
  "chat.rewards_mg_notice": "당월 총 리워드 수익이 약정 MG 보다 적을 경우, 부족한 차액만큼 MG 가 맞춰져 지급됩니다.\n총 리워드가 MG 이상이면 차액은 없으며 초과분은 삭감되지 않습니다.\nMG 차액은 매월 말일 23:59 기준으로 산정하고 익월 10일에 지급합니다.\n지급일이 주말 또는 공휴일이면 날짜가 변경될 수 있습니다.\n말일 23:59 이후 발생한 리워드는 다음 달 산정에 포함됩니다.",
  "chat.rewards_creator_information_grade": "크리에이터 등급",
  "chat.creator_grade_stardust": "별가루",
  "chat.creator_grade_rising_star": "샛별",
  "chat.creator_grade_starkeeper": "별지기",
  "profile.user_unblocked_alert_message": "해당 유저의 차단을 해제 할까요?",
  "report.type.spam_text": "광고",
  "report.type.advertisement_text": "무허가 광고",
  "report.type.inappropriate_text": "부적절한 활동",
  "report.type.personal_info_text": "개인정보 유출",
  "report.type.other_text": "그 외",
  "payment.page_list_tag_sale_period": "추석 한정! {{date}}까지",
  "payment.page_list_bonus_expiration": "본 상품으로 지급되는 보너스 포인트의 유효기간은 {{int_days}}일입니다.",
  "chat.conversation_reroll_guidance_title": "리롤 지침",
  "chat.conversation_reroll_guidance_cost_tooltip": "리롤 지침 사용 시 재화가 추가 소모될 수 있습니다.",
  "chat.conversation_reroll_guidance_description": "어떻게 다시 써드릴까요?",
  "chat.conversation_reroll_guidance_description_sub": "출력 설정에서 리롤 지침 노출 설정을 변경할 수 있어요.",
  "chat.conversation_reroll_guidance_input_placeholder": "예) 상태창 포맷은 그대로 두고, 레이나의 반응을 더 차갑게",
  "chat.conversation_reroll_guidance_input_caption": "지침은 {{int_numbers}}자까지 입력할 수 있어요.",
  "chat.conversation_reroll_guidance_cost_info_button_label": "비용 안내 보기",
  "chat.conversation_reroll_guidance_reset_button": "초기화",
  "chat.conversation_reroll_guidance_skip_button": "지침 없이 리롤",
  "chat.conversation_reroll_guidance_submit_button": "리롤하기",
  "chat.conversation_reroll_guidance_discovery_toast": "매번 바로 리롤하려면 출력 설정에서 변경할 수 있어요.",
  "chat.conversation_reroll_guidance_setting_title": "리롤 지침",
  "chat.conversation_reroll_guidance_setting_description": "리롤할 때 다시 쓸 방향을 입력하는 창을 띄워요.",
  "chat.conversation_reroll_guidance_setting_on_caption": "리롤을 누르면 지침 창이 떠요.",
  "chat.conversation_reroll_guidance_setting_off_caption": "리롤을 누르면 바로 다시 써요.",
  "chat.conversation_reroll_guidance_setting_off_toast": "이제 리롤을 누르면 바로 다시 써요",
  "chat.custom_modal_input_settings": "입력창 설정",
  "chat.custom_modal_direction_button_position": "지문 버튼 위치",
  "chat.conversation_composition_title": "대화 구성",
  "chat.conversation_chat_link_copy_button": "링크 복사",
  "chat.conversation_chat_copy_modal_description": "복사본의 이름을 정해주세요. 캐릭터·서사·테마 설정과 지금까지의 대화 내역이 그대로 복사돼요.",
  "chat.free_model_ad_retry_wait_toast": "광고를 불러오지 못했어요. {{int_seconds}}초 후에 다시 시도해 주세요.",
  "chat.free_model_ad_retry_wait_minutes_toast": "광고를 불러오지 못했어요. {{int_minutes}}분 후에 다시 시도해 주세요.",
  "chat.conversation_sidebar_chat_copy": "대화 복사",
  "chat.conversation_sidebar_link_copied": "대화방 링크를 복사하였습니다.",
  "pwa.install_steps_ipad_1": "Safari 브라우저 상단의 [공유] 버튼 선택",
  "chat.custom_modal_tab_color": "색상",
  "chat.custom_modal_tab_input": "입력창",
  "chat.custom_modal_tab_lab": "실험실",
  "chat.custom_modal_background_opacity": "배경 불투명도",
  "chat.custom_modal_opacity_min": "완전 투명",
  "chat.custom_modal_opacity_max": "완전 불투명",
  "chat.custom_modal_reset_viewer_button": "뷰어만 초기화",
  "chat.custom_modal_reset_text_button": "텍스트만 초기화",
  "chat.custom_modal_reset_color_button": "색상만 초기화",
  "chat.custom_modal_reset_input_button": "입력창만 초기화",
  "chat.custom_modal_reset_lab_button": "실험실만 초기화",
  "chat.custom_modal_reset_all_button": "전체 초기화",
  "chat.custom_modal_reset_all_alert_title": "전체 초기화할까요?",
  "chat.custom_modal_reset_all_alert_description": "뷰어·텍스트·색상·입력창 설정이 모두 기본값으로 돌아가요. 저장을 누르면 적용됩니다.",
  "chat.custom_modal_reset_all_alert_description_lab": "뷰어·텍스트·색상·입력창·실험실 설정이 모두 기본값으로 돌아가요. 저장을 누르면 적용됩니다.",
  "chat.custom_modal_reset_all_toast": "기본값으로 되돌렸어요. 저장을 눌러 적용하세요",
  "chat.custom_modal_apply_scope_title": "어디에 적용할까요?",
  "chat.custom_modal_apply_scope_description": "바꾼 설정을 적용할 범위를 골라주세요.",
  "chat.custom_modal_apply_scope_room_button": "이 대화방에만 적용",
  "chat.custom_modal_apply_scope_story_all_button": "소설형 대화방 전체에 적용",
  "chat.custom_modal_apply_scope_chat_all_button": "채팅형 대화방 전체에 적용",
  "chat.custom_modal_apply_scope_story_note": "전체 적용은 소설형 대화방에만 반영돼요. 채팅형 방 설정은 그대로 유지됩니다.",
  "chat.custom_modal_apply_scope_chat_note": "전체 적용은 채팅형 대화방에만 반영돼요. 소설형 방 설정은 그대로 유지됩니다.",
  "chat.custom_modal_apply_room_toast": "이 대화방에만 적용했어요",
  "chat.custom_modal_apply_all_toast": "전체 대화방에 적용했어요",
  "chat.custom_modal_lab_font": "글꼴",
  "chat.custom_modal_lab_font_batang": "바탕체",
  "chat.custom_modal_lab_font_handwriting": "손글씨체",
  "chat.create_character_multi_images_main_image_chip": "대표",
  "chat.create_character_multi_images_bulk_edit_mixed": "혼합",
  "chat.create_character_multi_images_bulk_edit_public_mixed_description": "공개 상태가 섞여 있어요. 탭하면 모두 공개로 바뀌어요.",
  "chat.create_character_multi_images_bulk_edit_ai_mixed_description": "AI 생성 표시가 섞여 있어요. 탭하면 모두 AI 생성으로 바뀌어요.",
  "chat.create_character_multi_images_replace_image": "이미지 교체",
  "chat.create_character_multi_images_main_image_always_public": "대표 이미지는 항상 공개됩니다",
  "dmm.adult_mismatch_toast_dmm": "이 작품은 성인 대상이라 볼 수 없어요.",
  "common.service_name": "팅글 - AI 캐릭터 채팅",
  "chat.rewards_rising_star_monthly_achievement_bonus": "{{string_month}} 달성 보너스",
  "chat.rewards_rising_star_unpaid": "미지급",
  "chat.rewards_rising_star_not_morning_star_on_payout_date": "{{string_payoutDate}} 지급일 기준 샛별이 아니어서 지급되지 않았어요",
  "general.mode": "모드",
  "chat.rewards_rising_star_title": "샛별 달성 보너스",
  "chat.rewards_rising_star_estimated_monthly_bonus": "{{string_month}} 예상 달성 보너스",
  "chat.rewards_rising_star_scheduled_monthly_bonus": "{{string_month}} 지급 예정 보너스",
  "chat.rewards_rising_star_paid_monthly_bonus": "{{string_month}} 지급된 보너스",
  "chat.rewards_rising_star_estimated": "예상",
  "chat.rewards_rising_star_calculated": "산정 완료",
  "chat.rewards_rising_star_paid": "지급 완료",
  "chat.rewards_rising_star_estimate_description": "{{string_asOfAt}} 산정 전 현재 기준 예상 금액이에요 · {{string_payoutDate}} 지급 예정",
  "chat.rewards_rising_star_calculated_description": "{{string_asOfAt}} 산정 완료 · {{string_payoutDate}} 리워드에 자동 지급돼요",
  "chat.rewards_rising_star_paid_description": "{{string_payoutDate}} 리워드에 지급되었어요",
  "chat.rewards_rising_star_next_calculation_date": "다음 산정일",
  "chat.rewards_rising_star_payout_date": "지급일",
  "chat.rewards_rising_star_achievement_tiers": "달성 구간 현황",
  "chat.rewards_rising_star_next_tier_description": "다음 구간({{string_threshold}} 이상)까지 {{string_remaining}} 남았어요 · 달성 시 {{string_bonus}}",
  "chat.rewards_rising_star_highest_tier_description": "최고 구간이에요. 합산 리워드의 50%가 보너스로 적용돼요.",
  "chat.rewards_rising_star_threshold_or_more": "{{string_amount}} 이상",
  "chat.rewards_rising_star_achievement_fifty_percent": "달성치의 50%",
  "chat.rewards_rising_star_calculation_details": "계산 과정",
  "chat.rewards_rising_star_combined_rewards": "합산 리워드",
  "chat.rewards_rising_star_applied_tier": "적용 구간",
  "chat.rewards_rising_star_applied_rule": "적용 규칙",
  "chat.rewards_rising_star_achievement_bonus": "달성 보너스",
  "chat.rewards_rising_star_fixed_bonus": "고정 보너스",
  "chat.rewards_rising_star_achievement_fifty_percent_rounded_up": "달성치의 50% (소수점 올림)",
  "chat.rewards_rising_star_not_achieved": "미달성",
  "chat.rewards_rising_star_eligible_assets": "산정 대상 애셋",
  "chat.rewards_rising_star_within_ninety_days_of_first_release": "최초 공개 90일 이내",
  "chat.rewards_rising_star_first_release": "최초 공개",
  "chat.rewards_rising_star_excluded": "제외",
  "chat.rewards_rising_star_total": "합계",
  "chat.rewards_rising_star_expand_all": "전체 {{int_count}}개 펼치기",
  "chat.rewards_rising_star_no_new_assets": "최근 90일 이내 새로 공개한 애셋이 없어요",
  "chat.rewards_rising_star_new_asset_description": "새 애셋을 공개하면 다음 산정부터 합산돼요",
  "chat.rewards_rising_star_bonus_history": "보너스 적립 내역",
  "chat.rewards_rising_star_morning_star_bonus_history": "샛별 달성 보너스 적립 내역",
  "chat.rewards_rising_star_bonus_reclaimed": "보너스 회수",
  "chat.rewards_rising_star_for_year_month": "{{string_yearMonth}}분",
  "chat.rewards_rising_star_payout_date_label": "{{string_payoutDate}} 지급",
  "chat.rewards_rising_star_base_rewards": "기본 리워드",
  "chat.rewards_rising_star_monthly_total_rewards": "월 리워드 합계",
  "chat.rewards_rising_star_bonus_guide": "샛별 달성 보너스 안내",
  "chat.rewards_rising_star_calculation_notice": "매월 25일 23:59 기준 최근 90일 이내 최초 공개된 애셋에서 같은 기간 발생한 리워드를 합산하여 달성 보너스가 산정되며, 산정된 보너스는 매월 말일에 리워드에 자동으로 지급됩니다.",
  "chat.rewards_rising_star_non_cumulative_notice": "각 달성 보너스는 중복 지급되지 않으며 구간의 최대 보너스만 적용됩니다.",
  "chat.rewards_rising_star_rounding_notice": "50% 보너스의 소수점은 올림 처리됩니다.",
  "chat.rewards_rising_star_first_release_notice": "\"신규 공개\"는 최초 공개 기준입니다.",
  "chat.rewards_rising_star_recalculation_notice": "보너스 산정 후 애셋이 삭제되거나 비공개되면 해당 애셋의 리워드는 산정 값에서 제외됩니다. 25일 산정 후 말일 지급 전에 발생하면 지급 직전에 보너스가 재계산되며, 지급 후에 발생하면 이미 지급된 보너스가 회수될 수 있습니다.",
  "chat.rewards_rising_star_rate_change_notice": "보너스 산정 후 요율이 변경되더라도 이미 산정된 값은 유지됩니다.",
  "chat.image_number": "이미지 {{int_imageNumbers}}",
  "general.ai": "AI",
  "chat.contest_entry_required": "필수",
  "chat.contest_entry_per_character_fields_hint": "캐릭터마다 따로 입력해 주세요 · {{int_number}}개",
  "chat.contest_entry_staff_only_hint": "운영진만 확인해요 · 제출 시 수정 불가",
  "chat.contest_entry_required_character_field_error": "필수 항목이에요. 이 캐릭터의 내용을 입력해 주세요.",
  "chat.contest_entry_additional_fields_remaining": "추가 입력을 작성해 주세요 ({{int_number}}개 남음)",
  "chat.contest_entry_review_confirmation_notice": "운영진 확인 후 참가가 확정돼요. 결과는 알림으로 알려드릴게요.",
  "chat.contest_entry_ineligible_characters_notice": "제출할 수 없는 캐릭터가 있어요. 목록을 다시 확인해 주세요.",
  "chat.contest_entry_pending_approval": "승인 대기",
  "chat.contest_entry_entry_confirmed": "참여 확정",
  "chat.contest_entry_rejected": "반려",
  "chat.contest_entry_entry_canceled": "참가 취소",
  "chat.contest_entry_submitted_pending_review": "제출 {{string_date}} · 검토 대기",
  "chat.contest_entry_closed_awaiting_results": "접수 마감 · 심사 결과 대기 중",
  "chat.contest_entry_approval_revoked_pending_review": "승인 취소 {{string_date}} · 재검토 대기",
  "chat.contest_entry_confirmed_date": "확정 {{string_date}}",
  "chat.contest_entry_confirmed_grant_amount_paid": "확정 {{string_date}} · 제작지원금 {{string_amount}} 지급 완료",
  "chat.contest_entry_confirmed_grant_paid": "확정 {{string_date}} · 제작지원금 지급 완료",
  "chat.contest_entry_rejected_resubmissions_remaining": "반려 {{string_date}} · 재제출 {{int_number}}회 남음",
  "chat.contest_entry_rejected_no_resubmission": "반려 {{string_date}} · 재제출 불가",
  "chat.contest_entry_rejected_after_deadline": "마감 후 반려 · 재제출 불가",
  "chat.contest_entry_auto_canceled_private_character": "{{string_date}} 자동 참가 취소 · 캐릭터 비공개",
  "chat.contest_entry_public_characters_only": "공개 캐릭터만 공모전 참여가 가능합니다.",
  "chat.contest_entry_resubmissions_exhausted_notice": "재제출 기회를 전부 소진했습니다. 다른 작품으로 참여해 주시기 바랍니다.",
  "chat.contest_entry_rejected_after_deadline_notice": "접수 마감 후 반려된 작품은 다시 제출할 수 없습니다.",
  "chat.contest_entry_view_rejection_reason": "반려 사유 보기",
  "chat.contest_entry_view_submission": "제출 내용 보기",
  "chat.contest_entry_collapse_submission": "제출 내용 접기",
  "chat.contest_entry_read_only_hint": "읽기 전용 · 제출 시 수정 불가",
  "chat.contest_entry_rejection_reason": "반려 사유",
  "chat.contest_entry_processed_date": "{{string_date}} 처리",
  "chat.contest_entry_my_additional_information": "내가 제출한 추가 입력",
  "chat.contest_entry_resubmission_attempts": "재제출 가능 횟수",
  "chat.contest_entry_resubmissions_remaining": "{{int_number}}회 남음 (3회 중 {{int_count}}회 사용)",
  "chat.contest_entry_resubmissions_exhausted": "0회 남음 (3회 모두 사용)",
  "chat.contest_entry_resubmission_closed": "재제출 불가 (접수 마감)",
  "chat.contest_entry_resubmission_check_notice": "제출 전에 반려 사유가 수정되었는지 다시 한번 확인해 주세요.",
  "chat.contest_entry_confirm_submission": "제출 확인",
  "chat.contest_entry_resubmitted_notice": "다시 제출했어요. 운영진 확인 후 결과를 알려드릴게요.",
  "chat.contest_entry_ineligible_resubmission_notice": "캐릭터가 참가 조건에 맞지 않아 다시 제출할 수 없어요.",
  "chat.contest_entry_resubmission_rules": "재제출 규칙",
  "chat.contest_entry_resubmission_rules_attempts": "반려 사유를 반영해 수정한 뒤 최대 3회까지 재제출할 수 있습니다.",
  "chat.contest_entry_resubmission_rules_review": "재제출하면 다시 승인 대기 상태가 되고, 어드민 검토 후 확정됩니다.",
  "chat.contest_entry_resubmission_rules_deadline": "접수 마감 이후 반려된 작품은 재제출할 수 없으며, 심사 과정에서 승인 여부가 최종 결정됩니다.",
  "chat.contest_entry_resubmit": "다시 제출하기",
  "chat.contest_entry_approval_revoked": "승인 취소",
  "chat.contest_entry_view_revocation_reason": "취소 사유 보기",
  "chat.contest_entry_revocation_reason": "승인 취소 사유",
  "chat.tag_search_no_results": "'{{string_keyword}}'와 맞는 태그가 없어요",
  "chat.tag_search_try_another": "다른 단어로 검색해 보세요",
  "chat.chat_list_edit_title": "대화 목록 편집",
  "chat.chat_list_delete_selected_confirm": "선택한 대화방을 삭제하시겠어요?",
  "chat.profile_edit_heading": "프로필 편집",
  "chat.chat_without_ads": "광고 없이 대화하기",
  "notification.mark_all_read": "모두 읽음",
  "chat.markdown_apply": "마크다운 적용",
  "chat.markdown_plain_text_description": "쓴 그대로 보여줘요. #, *, - 같은 기호도 글자로 보여요.",
  "chat.create_short_intro_max_length": "한 줄 소개는 {{int_number}}자 이하로 입력해주세요.",
  "chat.markdown_heading_large": "큰 제목",
  "chat.markdown_heading_small": "작은 제목",
  "chat.markdown_bold": "굵게",
  "chat.markdown_italic": "기울임",
  "chat.markdown_list": "목록",
  "chat.markdown_ordered_list": "번호 목록",
  "chat.markdown_quote": "인용",
  "chat.markdown_inline_code": "인라인 코드",
  "chat.markdown_code_block": "코드 블록",
  "chat.markdown_table": "표",
  "chat.markdown_toggle": "접기/펼치기",
  "chat.markdown_format": "마크다운 서식",
  "chat.markdown_table_select_size": "표 크기를 고르세요",
  "chat.markdown_table_dimensions": "{{int_cols}}열 × {{int_rows}}행",
  "chat.markdown_table_size": "표 크기",
  "chat.markdown_bold_text": "굵은 글씨",
  "chat.markdown_italic_text": "기울임 글씨",
  "chat.markdown_code": "코드",
  "chat.markdown_list_item": "목록 항목",
  "chat.markdown_blockquote": "인용문",
  "chat.markdown_image_description": "이미지 설명",
  "chat.markdown_code_placeholder": "코드를 입력하세요",
  "chat.markdown_collapsed_placeholder": "접힌 내용을 입력하세요",
  "chat.markdown_item": "항목",
  "chat.create_short_intro": "한 줄 소개",
  "chat.create_review_info": "검수 정보",
  "chat.create_character_info": "캐릭터 정보",
  "chat.create_background_info": "배경 정보",
  "chat.create_person": "인물",
  "chat.create_hidden_from_users": "유저에게 보이지 않아요",
  "chat.create_hidden_markdown_description": "이 내용은 유저에게 보이지 않아요. ## 제목 같은 마크다운 표기는 그대로 AI에게 전달되어 구조 인식에 도움이 됩니다.",
  "chat.create_review_only_description": "검수에만 사용되며 상세페이지에 노출되지 않아요. 보여주고 싶다면 상세 설명에 원하는 형태로 적어주세요.",
  "chat.create_one_per_line": "한 줄에 하나씩 입력해요",
  "chat.create_prompt_total_count": "프롬프트 합산 {{current}} / {{max}}자",
  "chat.create_total_count": "합산 {{current}} / {{max}}자",
  "chat.create_public_description": "상세 설명",
  "chat.create_public_description_ai_notice": "이 내용은 AI가 인식하지 않아요. 유저에게 보여줄 소개를 자유롭게 작성해 주세요.",
  "chat.create_public_description_ai_hidden": "이 내용은 AI가 인식하지 않아요",
  "chat.create_public_description_ai_unread": "AI가 읽지 않는 소개예요",
  "chat.create_public_description_placeholder": "유저에게 보여줄 소개를 적어주세요",
  "chat.create_public_description_migrated": "기존에 공개로 두셨던 내용을 그대로 옮겨뒀어요 — 다듬어보세요",
  "chat.create_public_description_empty": "상세 설명이 비어 있어요. 이대로 등록할 수 있지만, 상세 설명이 있으면 대화 시작률이 높아져요.",
  "chat.create_character_limit_exceeded": "글자수 상한을 초과했어요",
  "chat.create_public_description_max_length": "상세 설명은 {{int_characters}}자 이하로 입력해주세요.",
  "chat.create_public_description_token_notice": "프롬프트 글자수와 분리 · AI에 전달되지 않아 토큰 비용과 무관",
  "chat.create_public_description_separate_count": "AI 미전달 · 별도 카운터",
  "chat.create_public_description_preview_placeholder": "상세 설명을 입력하면 여기에 보여요",
  "chat.create_public_description_visible_area": "유저에게 보이는 것은 이 영역뿐이에요",
  "chat.image_load_failed": "이미지를 불러올 수 없어요",
  "chat.find_character": "캐릭터 찾기",
  "chat.find_universe": "서사 찾기",
  "chat.find_scene": "테마 찾기",
  "chat.markdown_image": "이미지",
  "chat.create_preview_label": "미리보기",
  "common.list_load_failed": "앗! 목록을 가져오지 못했어요.",
  "validation.email_request_limit_exceeded": "메일 요청 횟수를 초과했어요. 메일함과 스팸함을 확인한 뒤 잠시 후 다시 시도해 주세요.",
  "validation.email_unavailable": "사용할 수 없는 이메일이에요. 다른 이메일을 입력해 주세요.",
  "payment.shampoo_sales_end_notice": "매직 포션 및 매직 포션 리필 상품은 11월 25일부로 판매가 종료됩니다.",
  "payment.shampoo_free_provision_end_notice": "무료 포션 제공은 12월 16일부로 종료되며, 출석 보상으로 대체됩니다. 보유 중인 무료 포션은 12월 15일까지 사용할 수 있습니다.",
  "payment.shampoo_purchased_access_continues": "이미 구매한 매직 포션은 판매 종료 이후에도 남은 기간 동안 계속 이용할 수 있습니다.",
  "payment.shampoo_contact_support": "관련 문의는 고객센터로 접수해 주세요.",
  "payment.shampoo_sales_ended": "매직 포션 이용권(리필 포함)은 2026년 11월 25일부로 판매가 종료되었습니다.",
  "payment.shampoo_pass_validity_continues": "판매 종료 전에 구매한 이용권은 남은 유효기간 동안 정상적으로 이용하실 수 있습니다.",
  "weave.purchase_verification_required": "본인인증 후 구매할 수 있습니다",
  "weave.purchase_verified_adults_only": "위브 플러스는 본인인증을 완료한 성인 회원만 구매할 수 있습니다.",
  "weave.purchase_adults_only": "위브 플러스는 성인만 구매할 수 있습니다",
  "weave.purchase_minors_restricted": "관련 법령에 따라 청소년 회원은 위브 플러스를 구매할 수 없습니다.",
  "weave.continued_use_verification_required": "위브 플러스를 계속 이용하시려면 본인인증이 필요합니다",
  "weave.verified_adults_notice": "{{string_date}}부터 위브 플러스는 본인인증을 완료한 성인 회원만 이용할 수 있습니다. 적용일 전까지 본인인증을 완료해 주시기 바랍니다.",
  "weave.unverified_by_effective_date": "적용일까지 인증하지 않으신 경우",
  "weave.termination_prorated_refund": "위브 플러스 이용이 종료되며, 남은 이용 기간에 비례하여 결제 금액을 환불해 드립니다.",
  "weave.model_usage_notice_title": "위브 모델 이용 안내",
  "weave.model_adults_only_notice": "{{string_date}}부터 위브 모델은 성인만 이용할 수 있어요. 위브로 대화하던 대화방은 Gemini 3.8 Flash로 이어지고, 대화 내용은 그대로 남아 있어요.",
  "weave.access_ending_title": "위브 플러스 이용이 종료됩니다",
  "weave.access_ending_refund_notice": "{{string_date}}부터 위브 모델은 성인만 이용할 수 있어 위브 플러스 이용도 종료됩니다. 결제 금액은 남은 이용 기간에 비례하여 환불해 드립니다.",
  "weave.app_store_subscription_heading": "App Store에서 구독하신 경우",
  "weave.apple_refund_instructions": "아래 [환불 신청하기]로 Apple에 환불을 요청해 주시기 바랍니다. 요청하시면 자동 갱신도 함께 해지됩니다.",
  "weave.request_refund": "환불 신청하기",
  "weave.access_ending_automatic_refund_notice": "{{string_date}}부터 위브 모델은 성인만 이용할 수 있어 위브 플러스 이용도 종료됩니다. 결제 금액은 남은 이용 기간에 비례하여 결제하신 수단으로 자동 환불해 드립니다.",
  "weave.adults_only_badge": "성인 전용",
  "weave.minors_cannot_purchase": "청소년 회원은 위브 플러스를 구매할 수 없습니다."
}